var Xt = Object.defineProperty;
var Jt = (n, t, e) => t in n ? Xt(n, t, { enumerable: !0, configurable: !0, writable: !0, value: e }) : n[t] = e;
var d = (n, t, e) => Jt(n, typeof t != "symbol" ? t + "" : t, e);
import { Slice as z, Fragment as V, DOMSerializer as be, DOMParser as ut, Node as Qt } from "prosemirror-model";
import { ReplaceStep as Zt, ReplaceAroundStep as Be, Mapping as eo } from "prosemirror-transform";
import { k as pe, i as q, a as L, b as Oe, n as E, t as pt, U as ne, c as re, l as to, m as oo, g as _e, f as we, h as O, o as mt, p as no, q as ft, r as ro, s as so, u as Ke, v as qe, w as io, x as ao, y as co, z as gt, d as lo, A as ho, B as kt, e as Me } from "./blockToNode-DIfPWLH8.js";
import { C as Si, H as Ei, D as Bi, E as Mi, N as Pi, F as Ti, O as xi, G as Ii, I as Li, J as Ai, L as Di, j as Oi, M as _i, K as Ni } from "./blockToNode-DIfPWLH8.js";
import { af as Se, ag as uo, ah as po, ai as mo, aj as _, ak as bt, ac as fo, al as S, a9 as Ye, am as Ne, an as go, ao as ko, a6 as wt, a8 as We, ad as bo, ap as He, aq as wo, ar as yo, Z as Co, as as vo, a5 as So } from "./BlockNoteSchema-Bi-eeHal.js";
import { aw as Ui, av as Ri, aR as Vi, E as $i, a as Fi, F as zi, r as Gi, Q as ji, ab as Ki, aC as qi, aN as Yi, aA as Wi, b as Xi, d as Ji, e as Qi, a7 as Zi, aV as ea, at as ta, X as oa, c as na, f as ra, aD as sa, au as ia, aE as aa, aH as ca, x as la, y as da, A as ha, z as ua, g as pa, h as ma, _ as fa, j as ga, k as ka, l as ba, n as wa, o as ya, q as Ca, s as va, w as Sa, aI as Ea, aO as Ba, B as Ma, C as Pa, H as Ta, I as xa, K as Ia, L as La, M as Aa, N as Da, aL as Oa, aP as _a, P as Na, D as Ha, G as Ua, V as Ra, R as Va, T as $a, a1 as Fa, $ as za, a4 as Ga, a3 as ja, a2 as Ka, U as qa, m as Ya, aW as Wa, az as Xa, aT as Ja, aF as Qa, ay as Za, aJ as ec, i as tc, Y as oc, aB as nc, aK as rc, aQ as sc, ae as ic, t as ac, u as cc, v as lc, ax as dc, aS as hc, aU as uc, a0 as pc, p as mc, aa as fc, aM as gc, O as kc, W as bc, S as wc, J as yc, aG as Cc } from "./BlockNoteSchema-Bi-eeHal.js";
import { Node as W, combineTransactionSteps as Eo, Extension as N, Mark as ie, mergeAttributes as yt, getMarkRange as Pe, isTextSelection as Bo, isNodeSelection as Te, posToDOMRect as me, findChildren as Xe, findParentNode as Mo, extensions as te, selectionToInsertionEnd as Po, InputRule as To, getSchema as xo, createDocument as Io, Editor as Lo } from "@tiptap/core";
import Ao from "fast-deep-equal";
import { dropCursor as Do } from "prosemirror-dropcursor";
import * as R from "yjs";
import { Gapcursor as Oo } from "@tiptap/extension-gapcursor";
import { History as _o } from "@tiptap/extension-history";
import { Link as No } from "@tiptap/extension-link";
import { Text as Ho } from "@tiptap/extension-text";
import { Plugin as B, NodeSelection as X, PluginKey as A, TextSelection as I, Selection as ue } from "prosemirror-state";
import { CellSelection as ye, addRowBefore as Uo, addRowAfter as Ro, addColumnBefore as Vo, addColumnAfter as $o, deleteRow as Fo, deleteColumn as zo, mergeCells as Go, splitCell as jo, TableMap as Je } from "prosemirror-tables";
import Ko from "rehype-parse";
import qo from "rehype-remark";
import Ct from "remark-gfm";
import Yo from "remark-stringify";
import { unified as vt } from "unified";
import { fromDom as Wo } from "hast-util-from-dom";
import { visit as Xo } from "unist-util-visit";
import { yCursorPlugin as Jo, defaultSelectionBuilder as Qo, ySyncPlugin as Zo, yUndoPlugin as en, yUndoPluginKey as ae, yCursorPluginKey as tn, ySyncPluginKey as Y, getRelativeSelection as on, absolutePositionToRelativePosition as nn, relativePositionToAbsolutePosition as rn, undoCommand as sn, redoCommand as an } from "y-prosemirror";
import { DecorationSet as U, Decoration as $ } from "prosemirror-view";
import { v4 as cn } from "uuid";
import { e as ln } from "./en-njEqD7AG.js";
import dn from "remark-parse";
import hn, { defaultHandlers as Qe } from "remark-rehype";
import un from "rehype-stringify";
import { undo as pn, redo as mn } from "prosemirror-history";
function fn(n, t) {
  const e = [
    {
      tag: `[data-inline-content-type="${n.type}"]`,
      contentElement: (o) => {
        const r = o;
        return r.matches("[data-editable]") ? r : r.querySelector("[data-editable]") || r;
      }
    }
  ];
  return t && e.push({
    tag: "*",
    getAttrs(o) {
      if (typeof o == "string")
        return !1;
      const r = t == null ? void 0 : t(o);
      return r === void 0 ? !1 : r;
    }
  }), e;
}
function fi(n, t) {
  var o;
  const e = W.create({
    name: n.type,
    inline: !0,
    group: "inline",
    draggable: (o = t.meta) == null ? void 0 : o.draggable,
    selectable: n.content === "styled",
    atom: n.content === "none",
    content: n.content === "styled" ? "inline*" : "",
    addAttributes() {
      return po(n.propSchema);
    },
    addKeyboardShortcuts() {
      return uo(n);
    },
    parseHTML() {
      return fn(
        n,
        t.parse
      );
    },
    renderHTML({ node: r }) {
      const s = this.options.editor, i = t.render.call(
        { renderType: "dom", props: void 0 },
        pe(
          r,
          s.schema.inlineContentSchema,
          s.schema.styleSchema
        ),
        // TODO: fix cast
        () => {
        },
        s
      );
      return Se(
        i,
        n.type,
        r.attrs,
        n.propSchema
      );
    },
    addNodeView() {
      return (r) => {
        const { node: s, getPos: i } = r, c = this.options.editor, a = t.render.call(
          { renderType: "nodeView", props: r },
          pe(
            s,
            c.schema.inlineContentSchema,
            c.schema.styleSchema
          ),
          // TODO: fix cast
          (l) => {
            const h = q([l], c.pmSchema), u = i();
            u && c.transact(
              (f) => f.replaceWith(u, u + s.nodeSize, h)
            );
          },
          c
        );
        return Se(
          a,
          n.type,
          s.attrs,
          n.propSchema
        );
      };
    }
  });
  return mo(
    e,
    n.propSchema,
    {
      ...t,
      toExternalHTML: t.toExternalHTML,
      render(r, s, i) {
        const c = t.render(
          r,
          s,
          i
        );
        return Se(
          c,
          n.type,
          r.props,
          n.propSchema
        );
      }
    }
  );
}
function gn(n, t, e, o = "before") {
  const r = typeof e == "string" ? e : e.id, s = L(n), i = t.map(
    (h) => Oe(h, s)
  ), c = _(r, n.doc);
  if (!c)
    throw new Error(`Block with ID ${r} not found`);
  let a = c.posBeforeNode;
  return o === "after" && (a += c.node.nodeSize), n.step(
    new Zt(a, a, new z(V.from(i), 0, 0))
  ), i.map(
    (h) => E(h, s)
  );
}
function xe(n) {
  if (!n || n.type.name !== "column")
    throw new Error("Invalid columnPos: does not point to column node.");
  const t = n.firstChild;
  if (!t)
    throw new Error("Invalid column: does not have child node.");
  const e = t.firstChild;
  if (!e)
    throw new Error("Invalid blockContainer: does not have child node.");
  return n.childCount === 1 && t.childCount === 1 && e.type.name === "paragraph" && e.content.content.length === 0;
}
function kn(n, t) {
  const e = n.doc.resolve(t), o = e.nodeAfter;
  if (!o || o.type.name !== "columnList")
    throw new Error(
      "Invalid columnListPos: does not point to columnList node."
    );
  for (let r = o.childCount - 1; r >= 0; r--) {
    const s = n.doc.resolve(e.pos + 1).posAtIndex(r), c = n.doc.resolve(s).nodeAfter;
    if (!c || c.type.name !== "column")
      throw new Error("Invalid columnPos: does not point to column node.");
    xe(c) && n.delete(s, s + c.nodeSize);
  }
}
function Ie(n, t) {
  kn(n, t);
  const o = n.doc.resolve(t).nodeAfter;
  if (!o || o.type.name !== "columnList")
    throw new Error(
      "Invalid columnListPos: does not point to columnList node."
    );
  if (o.childCount > 2)
    return;
  if (o.childCount < 2)
    throw new Error("Invalid columnList: contains fewer than two children.");
  const r = t + 1, i = n.doc.resolve(r).nodeAfter, c = t + o.nodeSize - 1, l = n.doc.resolve(c).nodeBefore;
  if (!i || !l)
    throw new Error("Invalid columnList: does not contain children.");
  const h = xe(i), u = xe(l);
  if (h && u) {
    n.delete(t, t + o.nodeSize);
    return;
  }
  if (h) {
    n.step(
      new Be(
        // Replaces `columnList`.
        t,
        t + o.nodeSize,
        // Replaces with content of last `column`.
        c - l.nodeSize + 1,
        c - 1,
        // Doesn't append anything.
        z.empty,
        0,
        !1
      )
    );
    return;
  }
  if (u) {
    n.step(
      new Be(
        // Replaces `columnList`.
        t,
        t + o.nodeSize,
        // Replaces with content of first `column`.
        r + 1,
        r + i.nodeSize - 1,
        // Doesn't append anything.
        z.empty,
        0,
        !1
      )
    );
    return;
  }
}
function Ze(n, t, e) {
  const o = L(n), r = e.map(
    (u) => Oe(u, o)
  ), s = new Set(
    t.map(
      (u) => typeof u == "string" ? u : u.id
    )
  ), i = [], c = /* @__PURE__ */ new Set(), a = typeof t[0] == "string" ? t[0] : t[0].id;
  let l = 0;
  if (n.doc.descendants((u, f) => {
    if (s.size === 0)
      return !1;
    if (!u.type.isInGroup("bnBlock") || !s.has(u.attrs.id))
      return !0;
    if (i.push(E(u, o)), s.delete(u.attrs.id), e.length > 0 && u.attrs.id === a) {
      const k = n.doc.nodeSize;
      n.insert(f, r);
      const b = n.doc.nodeSize;
      l += k - b;
    }
    const m = n.doc.nodeSize, g = n.doc.resolve(f - l);
    g.node().type.name === "column" ? c.add(g.before(-1)) : g.node().type.name === "columnList" && c.add(g.before()), g.node().type.name === "blockGroup" && g.node(g.depth - 1).type.name !== "doc" && g.node().childCount === 1 ? n.delete(g.before(), g.after()) : n.delete(f - l, f - l + u.nodeSize);
    const p = n.doc.nodeSize;
    return l += m - p, !1;
  }), s.size > 0) {
    const u = [...s].join(`
`);
    throw Error(
      "Blocks with the following IDs could not be found in the editor: " + u
    );
  }
  return c.forEach((u) => Ie(n, u)), { insertedBlocks: r.map(
    (u) => E(u, o)
  ), removedBlocks: i };
}
function St(n) {
  const t = Array.from(n.classList).filter(
    (e) => !e.startsWith("bn-")
  ) || [];
  t.length > 0 ? n.className = t.join(" ") : n.removeAttribute("class");
}
function Et(n, t, e, o) {
  var c;
  let r;
  if (t)
    if (typeof t == "string")
      r = q([t], n.pmSchema);
    else if (Array.isArray(t))
      r = q(t, n.pmSchema);
    else if (t.type === "tableContent")
      r = pt(t, n.pmSchema);
    else
      throw new ne(t.type);
  else throw new Error("blockContent is required");
  const i = ((o == null ? void 0 : o.document) ?? document).createDocumentFragment();
  for (const a of r)
    if (a.type.name !== "text" && n.schema.inlineContentSchema[a.type.name]) {
      const l = n.schema.inlineContentSpecs[a.type.name].implementation;
      if (l) {
        const h = pe(
          a,
          n.schema.inlineContentSchema,
          n.schema.styleSchema
        ), u = l.toExternalHTML ? l.toExternalHTML(
          h,
          n
        ) : l.render.call(
          {
            renderType: "dom",
            props: void 0
          },
          h,
          () => {
          },
          n
        );
        if (u) {
          if (i.appendChild(u.dom), u.contentDOM) {
            const f = e.serializeFragment(
              a.content,
              o
            );
            u.contentDOM.dataset.editable = "", u.contentDOM.appendChild(f);
          }
          continue;
        }
      }
    } else if (a.type.name === "text") {
      let l = document.createTextNode(
        a.textContent
      );
      for (const h of a.marks.toReversed())
        if (h.type.name in n.schema.styleSpecs) {
          const u = (n.schema.styleSpecs[h.type.name].implementation.toExternalHTML ?? n.schema.styleSpecs[h.type.name].implementation.render)(h.attrs.stringValue, n);
          u.contentDOM.appendChild(l), l = u.dom;
        } else {
          const u = h.type.spec.toDOM(h, !0), f = be.renderSpec(document, u);
          f.contentDOM.appendChild(l), l = f.dom;
        }
      i.appendChild(l);
    } else {
      const l = e.serializeFragment(
        V.from([a]),
        o
      );
      i.appendChild(l);
    }
  return i.childNodes.length === 1 && ((c = i.firstChild) == null ? void 0 : c.nodeType) === 1 && St(i.firstChild), i;
}
function bn(n, t, e, o, r, s, i) {
  var k, b, w, D, F, J, Q, Z, ee;
  const c = (i == null ? void 0 : i.document) ?? document, a = t.pmSchema.nodes.blockContainer, l = e.props || {};
  for (const [v, M] of Object.entries(
    t.schema.blockSchema[e.type].propSchema
  ))
    !(v in l) && M.default !== void 0 && (l[v] = M.default);
  const h = (b = (k = a.spec) == null ? void 0 : k.toDOM) == null ? void 0 : b.call(
    k,
    a.create({
      id: e.id,
      ...l
    })
  ), u = Array.from(h.dom.attributes), f = t.blockImplementations[e.type].implementation, m = ((w = f.toExternalHTML) == null ? void 0 : w.call(
    {},
    { ...e, props: l },
    t
  )) || f.render.call(
    {},
    { ...e, props: l },
    t
  ), g = c.createDocumentFragment();
  if (m.dom.classList.contains("bn-block-content")) {
    const v = [
      ...u,
      ...Array.from(m.dom.attributes)
    ].filter(
      (M) => M.name.startsWith("data") && M.name !== "data-content-type" && M.name !== "data-file-block" && M.name !== "data-node-view-wrapper" && M.name !== "data-node-type" && M.name !== "data-id" && M.name !== "data-editable"
    );
    for (const M of v)
      m.dom.firstChild.setAttribute(M.name, M.value);
    St(m.dom.firstChild), g.append(...Array.from(m.dom.childNodes));
  } else
    g.append(m.dom);
  if (m.contentDOM && e.content) {
    const v = Et(
      t,
      e.content,
      // TODO
      o,
      i
    );
    m.contentDOM.appendChild(v);
  }
  let p;
  if (r.has(e.type) ? p = "OL" : s.has(e.type) && (p = "UL"), p) {
    if (((D = n.lastChild) == null ? void 0 : D.nodeName) !== p) {
      const v = c.createElement(p);
      p === "OL" && "start" in l && l.start && (l == null ? void 0 : l.start) !== 1 && v.setAttribute("start", l.start + ""), n.append(v);
    }
    n.lastChild.appendChild(g);
  } else
    n.append(g);
  if (e.children && e.children.length > 0) {
    const v = c.createDocumentFragment();
    if (Bt(
      v,
      t,
      e.children,
      o,
      r,
      s,
      i
    ), ((F = n.lastChild) == null ? void 0 : F.nodeName) === "UL" || ((J = n.lastChild) == null ? void 0 : J.nodeName) === "OL")
      for (; ((Q = v.firstChild) == null ? void 0 : Q.nodeName) === "UL" || ((Z = v.firstChild) == null ? void 0 : Z.nodeName) === "OL"; )
        n.lastChild.lastChild.appendChild(v.firstChild);
    t.pmSchema.nodes[e.type].isInGroup("blockContent") ? n.append(v) : (ee = m.contentDOM) == null || ee.append(v);
  }
}
const Bt = (n, t, e, o, r, s, i) => {
  for (const c of e)
    bn(
      n,
      t,
      c,
      o,
      r,
      s,
      i
    );
}, wn = (n, t, e, o, r, s) => {
  const c = ((s == null ? void 0 : s.document) ?? document).createDocumentFragment();
  return Bt(
    c,
    n,
    t,
    e,
    o,
    r,
    s
  ), c;
}, Ce = (n, t) => {
  const e = be.fromSchema(n);
  return {
    exportBlocks: (o, r) => {
      const s = wn(
        t,
        o,
        e,
        /* @__PURE__ */ new Set(["numberedListItem"]),
        /* @__PURE__ */ new Set(["bulletListItem", "checkListItem", "toggleListItem"]),
        r
      ), i = document.createElement("div");
      return i.append(s), i.innerHTML;
    },
    exportInlineContent: (o, r) => {
      const s = Et(
        t,
        o,
        e,
        r
      ), i = document.createElement("div");
      return i.append(s.cloneNode(!0)), i.innerHTML;
    }
  };
};
function yn(n, t, e, o, r) {
  let s;
  if (t)
    if (typeof t == "string")
      s = q([t], n.pmSchema, o);
    else if (Array.isArray(t))
      s = q(t, n.pmSchema, o);
    else if (t.type === "tableContent")
      s = pt(t, n.pmSchema);
    else
      throw new ne(t.type);
  else throw new Error("blockContent is required");
  const c = ((r == null ? void 0 : r.document) ?? document).createDocumentFragment();
  for (const a of s)
    if (a.type.name !== "text" && n.schema.inlineContentSchema[a.type.name]) {
      const l = n.schema.inlineContentSpecs[a.type.name].implementation;
      if (l) {
        const h = pe(
          a,
          n.schema.inlineContentSchema,
          n.schema.styleSchema
        ), u = l.render.call(
          {
            renderType: "dom",
            props: void 0
          },
          h,
          () => {
          },
          n
        );
        if (u) {
          if (c.appendChild(u.dom), u.contentDOM) {
            const f = e.serializeFragment(
              a.content,
              r
            );
            u.contentDOM.dataset.editable = "", u.contentDOM.appendChild(f);
          }
          continue;
        }
      }
    } else if (a.type.name === "text") {
      let l = document.createTextNode(
        a.textContent
      );
      for (const h of a.marks.toReversed())
        if (h.type.name in n.schema.styleSpecs) {
          const u = n.schema.styleSpecs[h.type.name].implementation.render(h.attrs.stringValue, n);
          u.contentDOM.appendChild(l), l = u.dom;
        } else {
          const u = h.type.spec.toDOM(h, !0), f = be.renderSpec(document, u);
          f.contentDOM.appendChild(l), l = f.dom;
        }
      c.appendChild(l);
    } else {
      const l = e.serializeFragment(
        V.from([a]),
        r
      );
      c.appendChild(l);
    }
  return c;
}
function Cn(n, t, e, o) {
  var u, f, m, g, p;
  const r = n.pmSchema.nodes.blockContainer, s = t.props || {};
  for (const [k, b] of Object.entries(
    n.schema.blockSchema[t.type].propSchema
  ))
    !(k in s) && b.default !== void 0 && (s[k] = b.default);
  const i = t.children || [], a = n.blockImplementations[t.type].implementation.render.call(
    {
      renderType: "dom",
      props: void 0
    },
    { ...t, props: s, children: i },
    n
  );
  if (a.contentDOM && t.content) {
    const k = yn(
      n,
      t.content,
      // TODO
      e,
      t.type,
      o
    );
    a.contentDOM.appendChild(k);
  }
  if (n.pmSchema.nodes[t.type].isInGroup("bnBlock")) {
    if (t.children && t.children.length > 0) {
      const k = Mt(
        n,
        t.children,
        e,
        o
      );
      (u = a.contentDOM) == null || u.append(k);
    }
    return a.dom;
  }
  const h = (m = (f = r.spec) == null ? void 0 : f.toDOM) == null ? void 0 : m.call(
    f,
    r.create({
      id: t.id,
      ...s
    })
  );
  return (g = h.contentDOM) == null || g.appendChild(a.dom), t.children && t.children.length > 0 && ((p = h.contentDOM) == null || p.appendChild(
    Pt(n, t.children, e, o)
  )), h.dom;
}
function Mt(n, t, e, o) {
  const s = ((o == null ? void 0 : o.document) ?? document).createDocumentFragment();
  for (const i of t) {
    const c = Cn(n, i, e, o);
    s.appendChild(c);
  }
  return s;
}
const Pt = (n, t, e, o) => {
  var c;
  const r = n.pmSchema.nodes.blockGroup, s = r.spec.toDOM(r.create({})), i = Mt(n, t, e, o);
  return (c = s.contentDOM) == null || c.appendChild(i), s.dom;
}, vn = (n, t) => {
  const e = be.fromSchema(n);
  return {
    serializeBlocks: (o, r) => Pt(t, o, e, r).outerHTML
  };
};
function Sn(n, t) {
  if (t === 0)
    return;
  const e = n.resolve(t);
  for (let o = e.depth; o > 0; o--) {
    const r = e.node(o);
    if (bt(r))
      return r.attrs.id;
  }
}
function En(n) {
  return n.getMeta("paste") ? { type: "paste" } : n.getMeta("uiEvent") === "drop" ? { type: "drop" } : n.getMeta("history$") ? {
    type: n.getMeta("history$").redo ? "redo" : "undo"
  } : n.getMeta("y-sync$") ? n.getMeta("y-sync$").isUndoRedoOperation ? { type: "undo-redo" } : { type: "yjs-remote" } : { type: "local" };
}
function et(n) {
  const t = "__root__", e = {}, o = {}, r = L(n);
  return n.descendants((s, i) => {
    if (!bt(s))
      return !0;
    const c = Sn(n, i), a = c ?? t;
    o[a] || (o[a] = []);
    const l = E(s, r);
    return e[s.attrs.id] = { block: l, parentId: c }, o[a].push(s.attrs.id), !0;
  }), { byId: e, childrenByParent: o };
}
function Bn(n, t) {
  const e = /* @__PURE__ */ new Set();
  if (!n || !t)
    return e;
  const o = new Set(n), r = t.filter((p) => o.has(p)), s = n.filter(
    (p) => r.includes(p)
  );
  if (s.length <= 1 || r.length <= 1)
    return e;
  const i = {};
  for (let p = 0; p < s.length; p++)
    i[s[p]] = p;
  const c = r.map((p) => i[p]), a = c.length, l = [], h = [], u = new Array(a).fill(-1), f = (p, k) => {
    let b = 0, w = p.length;
    for (; b < w; ) {
      const D = b + w >>> 1;
      p[D] < k ? b = D + 1 : w = D;
    }
    return b;
  };
  for (let p = 0; p < a; p++) {
    const k = c[p], b = f(l, k);
    b > 0 && (u[p] = h[b - 1]), b === l.length ? (l.push(k), h.push(p)) : (l[b] = k, h[b] = p);
  }
  const m = /* @__PURE__ */ new Set();
  let g = h[h.length - 1] ?? -1;
  for (; g !== -1; )
    m.add(g), g = u[g];
  for (let p = 0; p < r.length; p++)
    m.has(p) || e.add(r[p]);
  return e;
}
function Tt(n, t = []) {
  const e = En(n), o = Eo(n.before, [
    n,
    ...t
  ]), r = et(
    o.before
  ), s = et(
    o.doc
  ), i = [], c = /* @__PURE__ */ new Set();
  Object.keys(s.byId).filter((m) => !(m in r.byId)).forEach((m) => {
    i.push({
      type: "insert",
      block: s.byId[m].block,
      source: e,
      prevBlock: void 0
    }), c.add(m);
  }), Object.keys(r.byId).filter((m) => !(m in s.byId)).forEach((m) => {
    i.push({
      type: "delete",
      block: r.byId[m].block,
      source: e,
      prevBlock: void 0
    }), c.add(m);
  }), Object.keys(s.byId).filter((m) => m in r.byId).forEach((m) => {
    var b, w;
    const g = r.byId[m], p = s.byId[m];
    g.parentId !== p.parentId ? (i.push({
      type: "move",
      block: p.block,
      prevBlock: g.block,
      source: e,
      prevParent: g.parentId ? (b = r.byId[g.parentId]) == null ? void 0 : b.block : void 0,
      currentParent: p.parentId ? (w = s.byId[p.parentId]) == null ? void 0 : w.block : void 0
    }), c.add(m)) : Ao(
      { ...g.block, children: void 0 },
      { ...p.block, children: void 0 }
    ) || (i.push({
      type: "update",
      block: p.block,
      prevBlock: g.block,
      source: e
    }), c.add(m));
  });
  const a = r.childrenByParent, l = s.childrenByParent, h = "__root__", u = /* @__PURE__ */ new Set([
    ...Object.keys(a),
    ...Object.keys(l)
  ]), f = /* @__PURE__ */ new Set();
  return u.forEach((m) => {
    const g = Bn(
      a[m],
      l[m]
    );
    g.size !== 0 && g.forEach((p) => {
      var D, F;
      const k = r.byId[p], b = s.byId[p];
      !k || !b || k.parentId !== b.parentId || c.has(p) || (k.parentId ?? h) !== m || f.has(p) || (f.add(p), i.push({
        type: "move",
        block: b.block,
        prevBlock: k.block,
        source: e,
        prevParent: k.parentId ? (D = r.byId[k.parentId]) == null ? void 0 : D.block : void 0,
        currentParent: b.parentId ? (F = s.byId[b.parentId]) == null ? void 0 : F.block : void 0
      }), c.add(p));
    });
  }), i;
}
const Ue = [
  "vscode-editor-data",
  "blocknote/html",
  "text/markdown",
  "text/html",
  "text/plain",
  "Files"
];
function Mn(n, t) {
  if (!n.startsWith(".") || !t.startsWith("."))
    throw new Error("The strings provided are not valid file extensions.");
  return n === t;
}
function Pn(n, t) {
  const e = n.split("/"), o = t.split("/");
  if (e.length !== 2)
    throw new Error(`The string ${n} is not a valid MIME type.`);
  if (o.length !== 2)
    throw new Error(`The string ${t} is not a valid MIME type.`);
  return e[1] === "*" || o[1] === "*" ? e[0] === o[0] : (e[0] === "*" || o[0] === "*" || e[0] === o[0]) && e[1] === o[1];
}
function tt(n, t, e, o = "after") {
  let r;
  return Array.isArray(t.content) && t.content.length === 0 ? r = n.updateBlock(t, e).id : r = n.insertBlocks(
    [e],
    t,
    o
  )[0].id, r;
}
async function xt(n, t) {
  var s;
  if (!t.uploadFile) {
    console.warn(
      "Attempted ot insert file, but uploadFile is not set in the BlockNote editor options"
    );
    return;
  }
  const e = "dataTransfer" in n ? n.dataTransfer : n.clipboardData;
  if (e === null)
    return;
  let o = null;
  for (const i of Ue)
    if (e.types.includes(i)) {
      o = i;
      break;
    }
  if (o !== "Files")
    return;
  const r = e.items;
  if (r) {
    n.preventDefault();
    for (let i = 0; i < r.length; i++) {
      let c = "file";
      for (const l of Object.values(t.schema.blockSpecs))
        for (const h of ((s = l.implementation.meta) == null ? void 0 : s.fileBlockAccept) || []) {
          const u = h.startsWith("."), f = r[i].getAsFile();
          if (f && (!u && f.type && Pn(r[i].type, h) || u && Mn(
            "." + f.name.split(".").pop(),
            h
          ))) {
            c = l.config.type;
            break;
          }
        }
      const a = r[i].getAsFile();
      if (a) {
        const l = {
          type: c,
          props: {
            name: a.name
          }
        };
        let h;
        if (n.type === "paste") {
          const m = t.getTextCursorPosition().block;
          h = tt(t, m, l);
        } else if (n.type === "drop") {
          const m = {
            left: n.clientX,
            top: n.clientY
          }, g = t.prosemirrorView.posAtCoords(m);
          if (!g)
            return;
          h = t.transact((p) => {
            const k = re(p.doc, g.pos), b = t.prosemirrorView.dom.querySelector(
              `[data-id="${k.node.attrs.id}"]`
            ), w = b == null ? void 0 : b.getBoundingClientRect();
            return tt(
              t,
              t.getBlock(k.node.attrs.id),
              l,
              w && (w.top + w.bottom) / 2 > m.top ? "before" : "after"
            );
          });
        } else
          return;
        const u = await t.uploadFile(a, h), f = typeof u == "string" ? {
          props: {
            url: u
          }
        } : { ...u };
        t.updateBlock(h, f);
      }
    }
  }
}
const Tn = (n) => N.create({
  name: "dropFile",
  addProseMirrorPlugins() {
    return [
      new B({
        props: {
          handleDOMEvents: {
            drop(t, e) {
              if (!n.isEditable)
                return;
              let o = null;
              for (const r of Ue)
                if (e.dataTransfer.types.includes(r)) {
                  o = r;
                  break;
                }
              return o === null ? !0 : o === "Files" ? (xt(e, n), !0) : !1;
            }
          }
        }
      })
    ];
  }
}), xn = /(^|\n) {0,3}#{1,6} {1,8}[^\n]{1,64}\r?\n\r?\n\s{0,32}\S/, In = /(_|__|\*|\*\*|~~|==|\+\+)(?!\s)(?:[^\s](?:.{0,62}[^\s])?|\S)(?=\1)/, Ln = /\[[^\]]{1,128}\]\(https?:\/\/\S{1,999}\)/, An = /(?:\s|^)`(?!\s)(?:[^\s`](?:[^`]{0,46}[^\s`])?|[^\s`])`([^\w]|$)/, Dn = /(?:^|\n)\s{0,5}-\s{1}[^\n]+\n\s{0,15}-\s/, On = /(?:^|\n)\s{0,5}\d+\.\s{1}[^\n]+\n\s{0,15}\d+\.\s/, _n = /\n{2} {0,3}-{2,48}\n{2}/, Nn = /(?:\n|^)(```|~~~|\$\$)(?!`|~)[^\s]{0,64} {0,64}[^\n]{0,64}\n[\s\S]{0,9999}?\s*\1 {0,64}(?:\n+|$)/, Hn = /(?:\n|^)(?!\s)\w[^\n]{0,64}\r?\n(-|=)\1{0,64}\n\n\s{0,64}(\w|$)/, Un = /(?:^|(\r?\n\r?\n))( {0,3}>[^\n]{1,333}\n){1,999}($|(\r?\n))/, Rn = /^\s*\|(.+\|)+\s*$/m, Vn = /^\s*\|(\s*[-:]+[-:]\s*\|)+\s*$/m, $n = /^\s*\|(.+\|)+\s*$/m, Fn = (n) => xn.test(n) || In.test(n) || Ln.test(n) || An.test(n) || Dn.test(n) || On.test(n) || _n.test(n) || Nn.test(n) || Hn.test(n) || Un.test(n) || Rn.test(n) || Vn.test(n) || $n.test(n);
async function zn(n, t) {
  const { schema: e } = t.state;
  if (!n.clipboardData)
    return !1;
  const o = n.clipboardData.getData("text/plain");
  if (!o)
    return !1;
  if (!e.nodes.codeBlock)
    return t.pasteText(o), !0;
  const r = n.clipboardData.getData("vscode-editor-data"), s = r ? JSON.parse(r) : void 0, i = s == null ? void 0 : s.mode;
  return i ? (t.pasteHTML(
    `<pre><code class="language-${i}">${o.replace(
      /\r\n?/g,
      `
`
    )}</code></pre>`
  ), !0) : !1;
}
function Gn({
  event: n,
  editor: t,
  prioritizeMarkdownOverHTML: e,
  plainTextAsMarkdown: o
}) {
  var c;
  if (t.transact(
    (a) => a.selection.$from.parent.type.spec.code && a.selection.$to.parent.type.spec.code
  )) {
    const a = (c = n.clipboardData) == null ? void 0 : c.getData("text/plain");
    if (a)
      return t.pasteText(a), !0;
  }
  let s;
  for (const a of Ue)
    if (n.clipboardData.types.includes(a)) {
      s = a;
      break;
    }
  if (!s)
    return !0;
  if (s === "vscode-editor-data")
    return zn(n, t.prosemirrorView), !0;
  if (s === "Files")
    return xt(n, t), !0;
  const i = n.clipboardData.getData(s);
  if (s === "blocknote/html")
    return t.pasteHTML(i, !0), !0;
  if (s === "text/markdown")
    return t.pasteMarkdown(i), !0;
  if (e) {
    const a = n.clipboardData.getData("text/plain");
    if (Fn(a))
      return t.pasteMarkdown(a), !0;
  }
  return s === "text/html" ? (t.pasteHTML(i), !0) : o ? (t.pasteMarkdown(i), !0) : (t.pasteText(i), !0);
}
const jn = (n, t) => N.create({
  name: "pasteFromClipboard",
  addProseMirrorPlugins() {
    return [
      new B({
        props: {
          handleDOMEvents: {
            paste(e, o) {
              if (o.preventDefault(), !!n.isEditable)
                return t({
                  event: o,
                  editor: n,
                  defaultPasteHandler: ({
                    prioritizeMarkdownOverHTML: r = !0,
                    plainTextAsMarkdown: s = !0
                  } = {}) => Gn({
                    event: o,
                    editor: n,
                    prioritizeMarkdownOverHTML: r,
                    plainTextAsMarkdown: s
                  })
                });
            }
          }
        }
      })
    ];
  }
});
function Kn() {
  const n = (t) => {
    let e = t.children.length;
    for (let o = 0; o < e; o++) {
      const r = t.children[o];
      if (r.type === "element" && (n(r), r.tagName === "u"))
        if (r.children.length > 0) {
          t.children.splice(o, 1, ...r.children);
          const s = r.children.length - 1;
          e += s, o += s;
        } else
          t.children.splice(o, 1), e--, o--;
    }
  };
  return n;
}
function qn() {
  const n = (t) => {
    var e;
    if (t.children && "length" in t.children && t.children.length)
      for (let o = t.children.length - 1; o >= 0; o--) {
        const r = t.children[o], s = o + 1 < t.children.length ? t.children[o + 1] : void 0;
        r.type === "element" && r.tagName === "input" && ((e = r.properties) == null ? void 0 : e.type) === "checkbox" && (s == null ? void 0 : s.type) === "element" && s.tagName === "p" ? (s.tagName = "span", s.children.splice(
          0,
          0,
          Wo(document.createTextNode(" "))
        )) : n(r);
      }
  };
  return n;
}
function Yn() {
  return (n) => {
    Xo(n, "element", (t, e, o) => {
      var r, s, i, c;
      if (o && t.tagName === "video") {
        const a = ((r = t.properties) == null ? void 0 : r.src) || ((s = t.properties) == null ? void 0 : s["data-url"]) || "", l = ((i = t.properties) == null ? void 0 : i.title) || ((c = t.properties) == null ? void 0 : c["data-name"]) || "";
        o.children[e] = {
          type: "text",
          value: `![${l}](${a})`
        };
      }
    });
  };
}
function Re(n) {
  return vt().use(Ko, { fragment: !0 }).use(Yn).use(Kn).use(qn).use(qo).use(Ct).use(Yo, {
    handlers: { text: (e) => e.value }
  }).processSync(n).value;
}
function Wn(n, t, e, o) {
  const s = Ce(t, e).exportBlocks(n, o);
  return Re(s);
}
function It(n) {
  const t = [];
  return n.descendants((e) => {
    var r, s;
    const o = L(e);
    return e.type.name === "blockContainer" && ((r = e.firstChild) == null ? void 0 : r.type.name) === "blockGroup" ? !0 : e.type.name === "columnList" && e.childCount === 1 ? ((s = e.firstChild) == null || s.forEach((i) => {
      t.push(E(i, o));
    }), !1) : e.type.isInGroup("bnBlock") ? (t.push(E(e, o)), !1) : !0;
  }), t;
}
function Xn(n, t, e) {
  var c;
  let o = !1;
  const r = n.state.selection instanceof ye;
  if (!r) {
    const a = n.state.doc.slice(
      n.state.selection.from,
      n.state.selection.to,
      !1
    ).content, l = [];
    for (let h = 0; h < a.childCount; h++)
      l.push(a.child(h));
    o = l.find(
      (h) => h.type.isInGroup("bnBlock") || h.type.name === "blockGroup" || h.type.spec.group === "blockContent"
    ) === void 0, o && (t = a);
  }
  let s;
  const i = Ce(
    n.state.schema,
    e
  );
  if (r) {
    ((c = t.firstChild) == null ? void 0 : c.type.name) === "table" && (t = t.firstChild.content);
    const a = to(
      t,
      e.schema.inlineContentSchema,
      e.schema.styleSchema
    );
    s = `<table>${i.exportInlineContent(
      a,
      {}
    )}</table>`;
  } else if (o) {
    const a = oo(
      t,
      e.schema.inlineContentSchema,
      e.schema.styleSchema
    );
    s = i.exportInlineContent(a, {});
  } else {
    const a = It(t);
    s = i.exportBlocks(a, {});
  }
  return s;
}
function Lt(n, t) {
  "node" in n.state.selection && n.state.selection.node.type.spec.group === "blockContent" && t.transact(
    (i) => i.setSelection(
      new X(i.doc.resolve(n.state.selection.from - 1))
    )
  );
  const e = n.serializeForClipboard(
    n.state.selection.content()
  ).dom.innerHTML, o = n.state.selection.content().content, r = Xn(
    n,
    o,
    t
  ), s = Re(r);
  return { clipboardHTML: e, externalHTML: r, markdown: s };
}
const ot = () => {
  const n = window.getSelection();
  if (!n || n.isCollapsed)
    return !0;
  let t = n.focusNode;
  for (; t; ) {
    if (t instanceof HTMLElement && t.getAttribute("contenteditable") === "false")
      return !0;
    t = t.parentElement;
  }
  return !1;
}, nt = (n, t, e) => {
  e.preventDefault(), e.clipboardData.clearData();
  const { clipboardHTML: o, externalHTML: r, markdown: s } = Lt(
    t,
    n
  );
  e.clipboardData.setData("blocknote/html", o), e.clipboardData.setData("text/html", r), e.clipboardData.setData("text/plain", s);
}, Jn = (n) => N.create({
  name: "copyToClipboard",
  addProseMirrorPlugins() {
    return [
      new B({
        props: {
          handleDOMEvents: {
            copy(t, e) {
              return ot() || nt(n, t, e), !0;
            },
            cut(t, e) {
              return ot() || (nt(n, t, e), t.editable && t.dispatch(t.state.tr.deleteSelection())), !0;
            },
            // This is for the use-case in which only a block without content
            // is selected, e.g. an image block, and dragged (not using the
            // drag handle).
            dragstart(t, e) {
              if (!("node" in t.state.selection) || t.state.selection.node.type.spec.group !== "blockContent")
                return;
              n.transact(
                (i) => i.setSelection(
                  new X(
                    i.doc.resolve(t.state.selection.from - 1)
                  )
                )
              ), e.preventDefault(), e.dataTransfer.clearData();
              const { clipboardHTML: o, externalHTML: r, markdown: s } = Lt(t, n);
              return e.dataTransfer.setData("blocknote/html", o), e.dataTransfer.setData("text/html", r), e.dataTransfer.setData("text/plain", s), !0;
            }
          }
        }
      })
    ];
  }
}), Qn = N.create({
  name: "blockBackgroundColor",
  addGlobalAttributes() {
    return [
      {
        types: ["tableCell", "tableHeader"],
        attributes: {
          backgroundColor: fo()
        }
      }
    ];
  }
});
class Zn extends S {
  constructor() {
    super();
    d(this, "beforeChangeCallbacks", []);
    this.addProsemirrorPlugin(
      new B({
        key: new A("blockChange"),
        filterTransaction: (e) => {
          let o;
          return this.beforeChangeCallbacks.reduce((r, s) => r === !1 ? r : s({
            getChanges() {
              return o || (o = Tt(e), o);
            },
            tr: e
          }) !== !1, !0);
        }
      })
    );
  }
  static key() {
    return "blockChange";
  }
  subscribe(e) {
    return this.beforeChangeCallbacks.push(e), () => {
      this.beforeChangeCallbacks = this.beforeChangeCallbacks.filter(
        (o) => o !== e
      );
    };
  }
}
const j = class j extends S {
  constructor(e) {
    super();
    d(this, "provider");
    d(this, "recentlyUpdatedCursors");
    d(this, "renderCursor", (e, o) => {
      let r = this.recentlyUpdatedCursors.get(o);
      if (!r) {
        const s = (this.collaboration.renderCursor ?? j.defaultCursorRender)(e);
        this.collaboration.showCursorLabels !== "always" && (s.addEventListener("mouseenter", () => {
          const i = this.recentlyUpdatedCursors.get(o);
          i.element.setAttribute("data-active", ""), i.hideTimeout && (clearTimeout(i.hideTimeout), this.recentlyUpdatedCursors.set(o, {
            element: i.element,
            hideTimeout: void 0
          }));
        }), s.addEventListener("mouseleave", () => {
          const i = this.recentlyUpdatedCursors.get(o);
          this.recentlyUpdatedCursors.set(o, {
            element: i.element,
            hideTimeout: setTimeout(() => {
              i.element.removeAttribute("data-active");
            }, 2e3)
          });
        })), r = {
          element: s,
          hideTimeout: void 0
        }, this.recentlyUpdatedCursors.set(o, r);
      }
      return r.element;
    });
    d(this, "updateUser", (e) => {
      this.provider.awareness.setLocalStateField("user", e);
    });
    this.collaboration = e, this.provider = e.provider, this.recentlyUpdatedCursors = /* @__PURE__ */ new Map(), this.provider.awareness.setLocalStateField("user", e.user), e.showCursorLabels !== "always" && this.provider.awareness.on(
      "change",
      ({
        updated: o
      }) => {
        for (const r of o) {
          const s = this.recentlyUpdatedCursors.get(r);
          s && (s.element.setAttribute("data-active", ""), s.hideTimeout && clearTimeout(s.hideTimeout), this.recentlyUpdatedCursors.set(r, {
            element: s.element,
            hideTimeout: setTimeout(() => {
              s.element.removeAttribute("data-active");
            }, 2e3)
          }));
        }
      }
    ), this.addProsemirrorPlugin(
      Jo(this.provider.awareness, {
        selectionBuilder: Qo,
        cursorBuilder: this.renderCursor
      })
    );
  }
  static key() {
    return "yCursorPlugin";
  }
  get priority() {
    return 999;
  }
  /**
   * Determine whether the foreground color should be white or black based on a provided background color
   * Inspired by: https://stackoverflow.com/a/3943023
   *
   */
  static isDarkColor(e) {
    const o = e.charAt(0) === "#" ? e.substring(1, 7) : e, r = parseInt(o.substring(0, 2), 16), s = parseInt(o.substring(2, 4), 16), i = parseInt(o.substring(4, 6), 16), a = [r / 255, s / 255, i / 255].map((h) => h <= 0.03928 ? h / 12.92 : Math.pow((h + 0.055) / 1.055, 2.4));
    return 0.2126 * a[0] + 0.7152 * a[1] + 0.0722 * a[2] <= 0.179;
  }
};
d(j, "defaultCursorRender", (e) => {
  const o = document.createElement("span");
  o.classList.add("bn-collaboration-cursor__base");
  const r = document.createElement("span");
  r.setAttribute("contentedEditable", "false"), r.classList.add("bn-collaboration-cursor__caret"), r.setAttribute(
    "style",
    `background-color: ${e.color}; color: ${j.isDarkColor(e.color) ? "white" : "black"}`
  );
  const s = document.createElement("span");
  return s.classList.add("bn-collaboration-cursor__label"), s.setAttribute(
    "style",
    `background-color: ${e.color}; color: ${j.isDarkColor(e.color) ? "white" : "black"}`
  ), s.insertBefore(document.createTextNode(e.name), null), r.insertBefore(s, null), o.insertBefore(document.createTextNode("⁠"), null), o.insertBefore(r, null), o.insertBefore(document.createTextNode("⁠"), null), o;
});
let se = j;
class fe extends S {
  static key() {
    return "ySyncPlugin";
  }
  constructor(t) {
    super(), this.addProsemirrorPlugin(Zo(t));
  }
  get priority() {
    return 1001;
  }
}
class ge extends S {
  static key() {
    return "yUndoPlugin";
  }
  constructor({ editor: t }) {
    super(), this.addProsemirrorPlugin(en({ trackedOrigins: [t] }));
  }
  get priority() {
    return 1e3;
  }
}
class At extends S {
  constructor({
    editor: e,
    collaboration: o
  }) {
    super(e);
    d(this, "editor");
    d(this, "collaboration");
    /**
     * Stores whether the editor is editing a forked document,
     * preserving a reference to the original document and the forked document.
     */
    d(this, "forkedState");
    this.editor = e, this.collaboration = o;
  }
  static key() {
    return "ForkYDocPlugin";
  }
  /**
   * To find a fragment in another ydoc, we need to search for it.
   */
  findTypeInOtherYdoc(e, o) {
    const r = e.doc;
    if (e._item === null) {
      const s = Array.from(r.share.keys()).find(
        (i) => r.share.get(i) === e
      );
      if (s == null)
        throw new Error("type does not exist in other ydoc");
      return o.get(s, e.constructor);
    } else {
      const s = e._item, i = o.store.clients.get(s.id.client) ?? [], c = R.findIndexSS(i, s.id.clock);
      return i[c].content.type;
    }
  }
  /**
   * Whether the editor is editing a forked document,
   * preserving a reference to the original document and the forked document.
   */
  get isForkedFromRemote() {
    return this.forkedState !== void 0;
  }
  /**
   * Fork the Y.js document from syncing to the remote,
   * allowing modifications to the document without affecting the remote.
   * These changes can later be rolled back or applied to the remote.
   */
  fork() {
    var s;
    if (this.isForkedFromRemote)
      return;
    const e = (s = this.collaboration) == null ? void 0 : s.fragment;
    if (!e)
      throw new Error("No fragment to fork from");
    const o = new R.Doc();
    R.applyUpdate(o, R.encodeStateAsUpdate(e.doc));
    const r = this.findTypeInOtherYdoc(e, o);
    this.forkedState = {
      undoStack: ae.getState(this.editor.prosemirrorState).undoManager.undoStack,
      originalFragment: e,
      forkedFragment: r
    }, this.editor._tiptapEditor.unregisterPlugin([
      tn,
      ae,
      Y
    ]), this.editor._tiptapEditor.registerPlugin(
      new fe(r).plugins[0]
    ), this.editor._tiptapEditor.registerPlugin(
      new ge({ editor: this.editor }).plugins[0]
    ), this.emit("forked", !0);
  }
  /**
   * Resume syncing the Y.js document to the remote
   * If `keepChanges` is true, any changes that have been made to the forked document will be applied to the original document.
   * Otherwise, the original document will be restored and the changes will be discarded.
   */
  merge({ keepChanges: e }) {
    if (!this.forkedState)
      return;
    this.editor._tiptapEditor.unregisterPlugin(Y), this.editor._tiptapEditor.unregisterPlugin(ae);
    const { originalFragment: o, forkedFragment: r, undoStack: s } = this.forkedState;
    if (this.editor.extensions.ySyncPlugin = new fe(o), this.editor.extensions.yCursorPlugin = new se(
      this.collaboration
    ), this.editor.extensions.yUndoPlugin = new ge({
      editor: this.editor
    }), this.editor._tiptapEditor.registerPlugin(
      this.editor.extensions.ySyncPlugin.plugins[0]
    ), this.editor._tiptapEditor.registerPlugin(
      this.editor.extensions.yCursorPlugin.plugins[0]
    ), this.editor._tiptapEditor.registerPlugin(
      this.editor.extensions.yUndoPlugin.plugins[0]
    ), ae.getState(
      this.editor.prosemirrorState
    ).undoManager.undoStack = s, e) {
      const i = R.encodeStateAsUpdate(
        r.doc,
        R.encodeStateVector(o.doc)
      );
      R.applyUpdate(o.doc, i, this.editor);
    }
    this.forkedState = void 0, this.emit("forked", !1);
  }
}
const Dt = (n, t) => {
  t(n), n.forEach((e) => {
    e instanceof R.XmlElement && Dt(e, t);
  });
}, er = (n, t) => {
  const e = /* @__PURE__ */ new Map();
  return n.forEach((o) => {
    o instanceof R.XmlElement && Dt(o, (r) => {
      if (r.nodeName === "blockContainer" && r.hasAttribute("id")) {
        const s = r.getAttribute("textColor"), i = r.getAttribute("backgroundColor"), c = {
          textColor: s === Ye.textColor.default ? void 0 : s,
          backgroundColor: i === Ye.backgroundColor.default ? void 0 : i
        };
        (c.textColor || c.backgroundColor) && e.set(r.getAttribute("id"), c);
      }
    });
  }), e.size === 0 ? !1 : (t.doc.descendants((o, r) => {
    if (o.type.name === "blockContainer" && e.has(o.attrs.id)) {
      const s = t.doc.nodeAt(r + 1);
      if (!s)
        throw new Error("No element found");
      t.setNodeMarkup(r + 1, void 0, {
        // preserve existing attributes
        ...s.attrs,
        // add the textColor and backgroundColor attributes
        ...e.get(o.attrs.id)
      });
    }
  }), !0);
}, tr = [er];
class Ve extends S {
  constructor(e) {
    const o = new A(Ve.key());
    super();
    d(this, "migrationDone", !1);
    this.addProsemirrorPlugin(
      new B({
        key: o,
        appendTransaction: (r, s, i) => {
          if (this.migrationDone || // If any of the transactions are not due to a yjs sync, we don't need to run the migration
          !r.some((a) => a.getMeta("y-sync$")) || // If none of the transactions result in a document change, we don't need to run the migration
          r.every((a) => !a.docChanged) || // If the fragment is still empty, we can't run the migration (since it has not yet been applied to the Y.Doc)
          !e.firstChild)
            return;
          const c = i.tr;
          for (const a of tr)
            a(e, c);
          if (this.migrationDone = !0, !!c.docChanged)
            return c;
        }
      })
    );
  }
  static key() {
    return "schemaMigrationPlugin";
  }
}
const ke = ie.create({
  name: "comment",
  excludes: "",
  inclusive: !1,
  keepOnSplit: !0,
  addAttributes() {
    return {
      // orphans are marks that currently don't have an active thread. It could be
      // that users have resolved the thread. Resolved threads by default are not shown in the document,
      // but we need to keep the mark (positioning) data so we can still "revive" it when the thread is unresolved
      // or we enter a "comments" view that includes resolved threads.
      orphan: {
        parseHTML: (n) => !!n.getAttribute("data-orphan"),
        renderHTML: (n) => n.orphan ? {
          "data-orphan": "true"
        } : {},
        default: !1
      },
      threadId: {
        parseHTML: (n) => n.getAttribute("data-bn-thread-id"),
        renderHTML: (n) => ({
          "data-bn-thread-id": n.threadId
        }),
        default: ""
      }
    };
  },
  renderHTML({ HTMLAttributes: n }) {
    return [
      "span",
      yt(n, {
        class: "bn-thread-mark"
      })
    ];
  },
  parseHTML() {
    return [{ tag: "span.bn-thread-mark" }];
  },
  extendMarkSchema(n) {
    return n.name === "comment" ? {
      blocknoteIgnore: !0
    } : {};
  }
});
class or extends Ne {
  constructor(e) {
    super();
    d(this, "userCache", /* @__PURE__ */ new Map());
    // avoid duplicate loads
    d(this, "loadingUsers", /* @__PURE__ */ new Set());
    this.resolveUsers = e;
  }
  /**
   * Load information about users based on an array of user ids.
   */
  async loadUsers(e) {
    const o = e.filter(
      (r) => !this.userCache.has(r) && !this.loadingUsers.has(r)
    );
    if (o.length !== 0) {
      for (const r of o)
        this.loadingUsers.add(r);
      try {
        const r = await this.resolveUsers(o);
        for (const s of r)
          this.userCache.set(s.id, s);
        this.emit("update", this.userCache);
      } finally {
        for (const r of o)
          this.loadingUsers.delete(r);
      }
    }
  }
  /**
   * Retrieve information about a user based on their id, if cached.
   *
   * The user will have to be loaded via `loadUsers` first
   */
  getUser(e) {
    return this.userCache.get(e);
  }
  /**
   * Subscribe to changes in the user store.
   *
   * @param cb - The callback to call when the user store changes.
   * @returns A function to unsubscribe from the user store.
   */
  subscribe(e) {
    return this.on("update", e);
  }
}
const ce = new A("blocknote-comments"), nr = "SET_SELECTED_THREAD_ID";
function rr(n, t) {
  const e = /* @__PURE__ */ new Map();
  return n.descendants((o, r) => {
    o.marks.forEach((s) => {
      if (s.type.name === t) {
        const i = s.attrs.threadId;
        if (!i)
          return;
        const c = r, a = c + o.nodeSize, l = e.get(i) ?? {
          from: 1 / 0,
          to: 0
        };
        e.set(i, {
          from: Math.min(c, l.from),
          to: Math.max(a, l.to)
        });
      }
    });
  }), e;
}
class Ot extends S {
  constructor(e, o, r, s, i) {
    super();
    d(this, "userStore");
    /**
     * Whether a comment is currently being composed
     */
    d(this, "pendingComment", !1);
    /**
     * The currently selected thread id
     */
    d(this, "selectedThreadId");
    /**
     * Store the positions of all threads in the document.
     * this can be used later to implement a floating sidebar
     */
    d(this, "threadPositions", /* @__PURE__ */ new Map());
    /**
     * when a thread is resolved or deleted, we need to update the marks to reflect the new state
     */
    d(this, "updateMarksFromThreads", (e) => {
      this.editor.transact((o) => {
        o.doc.descendants((r, s) => {
          r.marks.forEach((i) => {
            if (i.type.name === this.markType) {
              const c = i.type, a = i.attrs.threadId, l = e.get(a), h = !!(!l || l.resolved || l.deletedAt);
              if (h !== i.attrs.orphan) {
                const u = Math.max(s, 0), f = Math.min(
                  s + r.nodeSize,
                  o.doc.content.size - 1,
                  o.doc.content.size - 1
                );
                o.removeMark(u, f, i), o.addMark(
                  u,
                  f,
                  c.create({
                    ...i.attrs,
                    orphan: h
                  })
                ), h && this.selectedThreadId === a && (this.selectedThreadId = void 0, this.emitStateUpdate());
              }
            }
          });
        });
      });
    });
    if (this.editor = e, this.threadStore = o, this.markType = r, this.resolveUsers = s, this.commentEditorSchema = i, !s)
      throw new Error("resolveUsers is required for comments");
    this.userStore = new or(s), this.threadStore.subscribe(this.updateMarksFromThreads), e.onCreate(() => {
      this.updateMarksFromThreads(this.threadStore.getThreads()), e.onSelectionChange(() => {
        this.pendingComment && (this.pendingComment = !1, this.emitStateUpdate());
      });
    });
    const c = this;
    this.addProsemirrorPlugin(
      new B({
        key: ce,
        state: {
          init() {
            return {
              decorations: U.empty
            };
          },
          apply(a, l) {
            const h = a.getMeta(ce);
            if (!a.docChanged && !h)
              return l;
            const u = a.docChanged ? rr(a.doc, c.markType) : c.threadPositions;
            (u.size > 0 || c.threadPositions.size > 0) && (c.threadPositions = u, c.emitStateUpdate());
            const f = [];
            if (c.selectedThreadId) {
              const m = u.get(
                c.selectedThreadId
              );
              m && f.push(
                $.inline(
                  m.from,
                  m.to,
                  {
                    class: "bn-thread-mark-selected"
                  }
                )
              );
            }
            return {
              decorations: U.create(a.doc, f)
            };
          }
        },
        props: {
          decorations(a) {
            var l;
            return ((l = ce.getState(a)) == null ? void 0 : l.decorations) ?? U.empty;
          },
          /**
           * Handle click on a thread mark and mark it as selected
           */
          handleClick: (a, l, h) => {
            var k;
            if (h.button !== 0)
              return;
            const u = a.state.doc.nodeAt(l);
            if (!u) {
              c.selectThread(void 0);
              return;
            }
            const f = a.state.schema.marks[r], m = a.state.doc.resolve(l), g = (k = u.marks.filter(
              (b) => b.type.name === r && b.attrs.orphan !== !0
            ).map((b) => {
              const w = Pe(
                m,
                f,
                b.attrs
              );
              return {
                mark: b,
                // calculate how far the mark is from the click position
                distance: (Math.abs(w.from - l) + Math.abs(w.to - l)) / 2,
                // calculate the length of text the mark spans
                length: w.to - w.from
              };
            }).sort((b, w) => b.distance !== w.distance ? b.distance - w.distance : b.length - w.length)[0]) == null ? void 0 : k.mark, p = g == null ? void 0 : g.attrs.threadId;
            c.selectThread(p);
          }
        }
      })
    );
  }
  static key() {
    return "comments";
  }
  emitStateUpdate() {
    this.emit("update", {
      selectedThreadId: this.selectedThreadId,
      pendingComment: this.pendingComment,
      threadPositions: this.threadPositions
    });
  }
  /**
   * Subscribe to state updates
   */
  onUpdate(e) {
    return this.on("update", e);
  }
  /**
   * Set the selected thread
   */
  selectThread(e) {
    var o, r;
    if (this.selectedThreadId !== e && (this.selectedThreadId = e, this.emitStateUpdate(), this.editor.transact(
      (s) => s.setMeta(ce, {
        name: nr
      })
    ), e)) {
      const s = this.threadPositions.get(e);
      if (!s)
        return;
      (r = (o = this.editor.prosemirrorView) == null ? void 0 : o.domAtPos(s.from).node) == null || r.scrollIntoView({
        behavior: "smooth",
        block: "center"
      });
    }
  }
  /**
   * Start a pending comment (e.g.: when clicking the "Add comment" button)
   */
  startPendingComment() {
    this.pendingComment = !0, this.emitStateUpdate();
  }
  /**
   * Stop a pending comment (e.g.: user closes the comment composer)
   */
  stopPendingComment() {
    this.pendingComment = !1, this.emitStateUpdate();
  }
  /**
   * Create a thread at the current selection
   */
  async createThread(e) {
    const o = await this.threadStore.createThread(e);
    if (this.threadStore.addThreadToDocument) {
      const r = this.editor.prosemirrorView, s = r.state.selection, i = Y.getState(r.state), c = {
        prosemirror: {
          head: s.head,
          anchor: s.anchor
        },
        yjs: i ? on(i.binding, r.state) : void 0
        // if we're not using yjs
      };
      await this.threadStore.addThreadToDocument({
        threadId: o.id,
        selection: c
      });
    } else
      this.editor._tiptapEditor.commands.setMark(this.markType, {
        orphan: !1,
        threadId: o.id
      });
  }
}
class sr {
  constructor(t, e, o, r) {
    d(this, "state");
    d(this, "emitUpdate");
    d(this, "mouseDownHandler", () => {
      var t;
      (t = this.state) != null && t.show && (this.state.show = !1, this.emitUpdate());
    });
    // For dragging the whole editor.
    d(this, "dragstartHandler", () => {
      var t;
      (t = this.state) != null && t.show && (this.state.show = !1, this.emitUpdate());
    });
    d(this, "scrollHandler", () => {
      var t;
      if ((t = this.state) != null && t.show) {
        const e = this.pmView.root.querySelector(
          `[data-node-type="blockContainer"][data-id="${this.state.block.id}"]`
        );
        if (!e)
          return;
        this.state.referencePos = e.getBoundingClientRect(), this.emitUpdate();
      }
    });
    d(this, "closeMenu", () => {
      var t;
      (t = this.state) != null && t.show && (this.state.show = !1, this.emitUpdate());
    });
    this.editor = t, this.pluginKey = e, this.pmView = o, this.emitUpdate = () => {
      if (!this.state)
        throw new Error("Attempting to update uninitialized file panel");
      r(this.state);
    }, o.dom.addEventListener("mousedown", this.mouseDownHandler), o.dom.addEventListener("dragstart", this.dragstartHandler), o.root.addEventListener("scroll", this.scrollHandler, !0);
  }
  update(t, e) {
    var c, a;
    const o = this.pluginKey.getState(t.state), r = this.pluginKey.getState(e);
    if (!((c = this.state) != null && c.show) && (o != null && o.block) && this.editor.isEditable) {
      const l = this.pmView.root.querySelector(
        `[data-node-type="blockContainer"][data-id="${o.block.id}"]`
      );
      if (!l)
        return;
      this.state = {
        show: !0,
        referencePos: l.getBoundingClientRect(),
        block: o.block
      }, this.emitUpdate();
      return;
    }
    const s = (o == null ? void 0 : o.block) && !(r != null && r.block), i = !(o != null && o.block) && (r == null ? void 0 : r.block);
    s && this.state && !this.state.show && (this.state.show = !0, this.emitUpdate()), i && ((a = this.state) != null && a.show) && (this.state.show = !1, this.emitUpdate());
  }
  destroy() {
    this.pmView.dom.removeEventListener("mousedown", this.mouseDownHandler), this.pmView.dom.removeEventListener("dragstart", this.dragstartHandler), this.pmView.root.removeEventListener("scroll", this.scrollHandler, !0);
  }
}
const Ee = new A(
  "FilePanelPlugin"
);
class ir extends S {
  constructor(e) {
    super();
    d(this, "view");
    d(this, "closeMenu", () => {
      var e;
      return (e = this.view) == null ? void 0 : e.closeMenu();
    });
    this.addProsemirrorPlugin(
      new B({
        key: Ee,
        view: (o) => (this.view = new sr(
          e,
          Ee,
          o,
          (r) => {
            this.emit("update", r);
          }
        ), this.view),
        props: {
          handleKeyDown: (o, r) => {
            var s;
            return r.key === "Escape" && this.shown ? ((s = this.view) == null || s.closeMenu(), !0) : !1;
          }
        },
        state: {
          init: () => ({
            block: void 0
          }),
          apply: (o, r) => {
            const s = o.getMeta(Ee);
            return s || (!o.getMeta(Y) && (o.selectionSet || o.docChanged) ? { block: void 0 } : r);
          }
        }
      })
    );
  }
  static key() {
    return "filePanel";
  }
  get shown() {
    var e, o;
    return ((o = (e = this.view) == null ? void 0 : e.state) == null ? void 0 : o.show) || !1;
  }
  onUpdate(e) {
    return this.on("update", e);
  }
}
class ar {
  constructor(t, e, o) {
    d(this, "state");
    d(this, "emitUpdate");
    d(this, "preventHide", !1);
    d(this, "preventShow", !1);
    d(this, "shouldShow", ({ view: t, state: e, from: o, to: r }) => {
      const { doc: s, selection: i } = e, { empty: c } = i, a = !s.textBetween(o, r).length && Bo(e.selection);
      if (i.$from.parent.type.spec.code || Te(i) && i.node.type.spec.code || c || a)
        return !1;
      const l = document.activeElement;
      return !(!this.isElementWithinEditorWrapper(l) && t.editable);
    });
    d(this, "blurHandler", (t) => {
      var o;
      if (this.preventHide) {
        this.preventHide = !1;
        return;
      }
      const e = this.pmView.dom.parentElement;
      // An element is clicked.
      t && t.relatedTarget && // Element is inside the editor.
      (e === t.relatedTarget || e.contains(t.relatedTarget) || t.relatedTarget.matches(
        ".bn-ui-container, .bn-ui-container *"
      )) || (o = this.state) != null && o.show && (this.state.show = !1, this.emitUpdate());
    });
    d(this, "isElementWithinEditorWrapper", (t) => {
      if (!t)
        return !1;
      const e = this.pmView.dom.parentElement;
      return e ? e.contains(t) : !1;
    });
    d(this, "viewMousedownHandler", (t) => {
      (!this.isElementWithinEditorWrapper(t.target) || t.button === 0) && (this.preventShow = !0);
    });
    d(this, "mouseupHandler", () => {
      this.preventShow && (this.preventShow = !1, setTimeout(() => this.update(this.pmView)));
    });
    // For dragging the whole editor.
    d(this, "dragHandler", () => {
      var t;
      (t = this.state) != null && t.show && (this.state.show = !1, this.emitUpdate());
    });
    d(this, "scrollHandler", () => {
      var t;
      (t = this.state) != null && t.show && (this.state.referencePos = this.getSelectionBoundingBox(), this.emitUpdate());
    });
    d(this, "closeMenu", () => {
      var t;
      (t = this.state) != null && t.show && (this.state.show = !1, this.emitUpdate());
    });
    this.editor = t, this.pmView = e, this.emitUpdate = () => {
      if (!this.state)
        throw new Error(
          "Attempting to update uninitialized formatting toolbar"
        );
      o(this.state);
    }, e.dom.addEventListener("mousedown", this.viewMousedownHandler), e.root.addEventListener("mouseup", this.mouseupHandler), e.dom.addEventListener("dragstart", this.dragHandler), e.dom.addEventListener("dragover", this.dragHandler), e.dom.addEventListener("blur", this.blurHandler), e.root.addEventListener("scroll", this.scrollHandler, !0);
  }
  update(t, e) {
    var m, g, p;
    const { state: o, composing: r } = t, { doc: s, selection: i } = o, c = e && e.doc.eq(s) && e.selection.eq(i);
    if (r || c)
      return;
    const { ranges: a } = i, l = Math.min(...a.map((k) => k.$from.pos)), h = Math.max(...a.map((k) => k.$to.pos)), u = this.shouldShow({
      view: t,
      state: o,
      from: l,
      to: h
    }), f = typeof Range.prototype.getClientRects > "u";
    if (!this.preventShow && (u || this.preventHide) && !f) {
      const k = this.getSelectionBoundingBox();
      if (k.height === 0 && k.width === 0) {
        queueMicrotask(() => {
          const w = {
            show: !0,
            referencePos: this.getSelectionBoundingBox()
          };
          this.state = w, this.emitUpdate(), t.dispatch(
            t.state.tr.setSelection(
              I.create(
                t.state.doc,
                t.state.selection.from + 1,
                t.state.selection.to
              )
            )
          ), t.dispatch(
            t.state.tr.setSelection(
              I.create(
                t.state.doc,
                t.state.selection.from - 1,
                t.state.selection.to
              )
            )
          );
        });
        return;
      }
      const b = {
        show: !0,
        referencePos: this.getSelectionBoundingBox()
      };
      (b.show !== ((m = this.state) == null ? void 0 : m.show) || b.referencePos.toJSON() !== ((g = this.state) == null ? void 0 : g.referencePos.toJSON())) && (this.state = b, this.emitUpdate());
      return;
    }
    if ((p = this.state) != null && p.show && !this.preventHide && (!u || this.preventShow || !this.editor.isEditable)) {
      this.state.show = !1, this.emitUpdate();
      return;
    }
  }
  destroy() {
    this.pmView.dom.removeEventListener("mousedown", this.viewMousedownHandler), this.pmView.root.removeEventListener("mouseup", this.mouseupHandler), this.pmView.dom.removeEventListener("dragstart", this.dragHandler), this.pmView.dom.removeEventListener("dragover", this.dragHandler), this.pmView.dom.removeEventListener("blur", this.blurHandler), this.pmView.root.removeEventListener("scroll", this.scrollHandler, !0);
  }
  getSelectionBoundingBox() {
    const { state: t } = this.pmView, { selection: e } = t, { ranges: o } = e, r = Math.min(...o.map((i) => i.$from.pos)), s = Math.max(...o.map((i) => i.$to.pos));
    if (Te(e)) {
      const i = this.pmView.nodeDOM(r);
      if (i)
        return i.getBoundingClientRect();
    }
    return me(this.pmView, r, s);
  }
}
const cr = new A(
  "FormattingToolbarPlugin"
);
class lr extends S {
  constructor(e) {
    super();
    d(this, "view");
    d(this, "closeMenu", () => this.view.closeMenu());
    this.addProsemirrorPlugin(
      new B({
        key: cr,
        view: (o) => (this.view = new ar(e, o, (r) => {
          this.emit("update", r);
        }), this.view),
        props: {
          handleKeyDown: (o, r) => r.key === "Escape" && this.shown ? (this.view.closeMenu(), !0) : !1
        }
      })
    );
  }
  static key() {
    return "formattingToolbar";
  }
  get shown() {
    var e, o;
    return ((o = (e = this.view) == null ? void 0 : e.state) == null ? void 0 : o.show) || !1;
  }
  onUpdate(e) {
    return this.on("update", e);
  }
}
const dr = W.create({
  name: "hardBreak",
  inline: !0,
  group: "inline",
  selectable: !1,
  linebreakReplacement: !0,
  priority: 10,
  parseHTML() {
    return [{ tag: "br" }];
  },
  renderHTML({ HTMLAttributes: n }) {
    return ["br", yt(this.options.HTMLAttributes, n)];
  },
  renderText() {
    return `
`;
  }
}), Le = (n, t) => {
  const e = n.resolve(t), o = e.index();
  if (o === 0)
    return;
  const r = e.posAtIndex(o - 1);
  return _e(
    n.resolve(r)
  );
}, _t = (n, t) => {
  for (; t.childContainer; ) {
    const e = t.childContainer.node, o = n.resolve(t.childContainer.beforePos + 1).posAtIndex(e.childCount - 1);
    t = _e(n.resolve(o));
  }
  return t;
}, hr = (n, t) => n.isBlockContainer && n.blockContent.node.type.spec.content === "inline*" && n.blockContent.node.childCount > 0 && t.isBlockContainer && t.blockContent.node.type.spec.content === "inline*", ur = (n, t, e, o) => {
  if (!o.isBlockContainer)
    throw new Error(
      `Attempted to merge block at position ${o.bnBlock.beforePos} into previous block at position ${e.bnBlock.beforePos}, but next block is not a block container`
    );
  if (o.childContainer) {
    const r = n.doc.resolve(
      o.childContainer.beforePos + 1
    ), s = n.doc.resolve(
      o.childContainer.afterPos - 1
    ), i = r.blockRange(s);
    if (t) {
      const c = n.doc.resolve(o.bnBlock.beforePos);
      n.tr.lift(i, c.depth);
    }
  }
  if (t) {
    if (!e.isBlockContainer)
      throw new Error(
        `Attempted to merge block at position ${o.bnBlock.beforePos} into previous block at position ${e.bnBlock.beforePos}, but previous block is not a block container`
      );
    t(
      n.tr.delete(
        e.blockContent.afterPos - 1,
        o.blockContent.beforePos + 1
      )
    );
  }
  return !0;
}, rt = (n) => ({
  state: t,
  dispatch: e
}) => {
  const o = t.doc.resolve(n), r = _e(o), s = Le(
    t.doc,
    r.bnBlock.beforePos
  );
  if (!s)
    return !1;
  const i = _t(
    t.doc,
    s
  );
  return hr(i, r) ? ur(t, e, i, r) : !1;
};
function pr(n, t, e) {
  const { $from: o, $to: r } = n.selection, s = o.blockRange(
    r,
    (g) => g.childCount > 0 && (g.type.name === "blockGroup" || g.type.name === "column")
    // change necessary to not look at first item child type
  );
  if (!s)
    return !1;
  const i = s.startIndex;
  if (i === 0)
    return !1;
  const a = s.parent.child(i - 1);
  if (a.type !== t)
    return !1;
  const l = a.lastChild && a.lastChild.type === e, h = V.from(l ? t.create() : null), u = new z(
    V.from(
      t.create(null, V.from(e.create(null, h)))
      // change necessary to create "groupType" instead of parent.type
    ),
    l ? 3 : 1,
    0
  ), f = s.start, m = s.end;
  return n.step(
    new Be(
      f - (l ? 3 : 1),
      m,
      f,
      m,
      u,
      1,
      !0
    )
  ).scrollIntoView(), !0;
}
function Nt(n) {
  return n.transact((t) => pr(
    t,
    n.pmSchema.nodes.blockContainer,
    n.pmSchema.nodes.blockGroup
  ));
}
function mr(n) {
  n._tiptapEditor.commands.liftListItem("blockContainer");
}
function fr(n) {
  return n.transact((t) => {
    const { bnBlock: e } = we(t);
    return t.doc.resolve(e.beforePos).nodeBefore !== null;
  });
}
function gr(n) {
  return n.transact((t) => {
    const { bnBlock: e } = we(t);
    return t.doc.resolve(e.beforePos).depth > 1;
  });
}
const kr = N.create({
  priority: 50,
  // TODO: The shortcuts need a refactor. Do we want to use a command priority
  //  design as there is now, or clump the logic into a single function?
  addKeyboardShortcuts() {
    const n = () => this.editor.commands.first(({ chain: o, commands: r }) => [
      // Deletes the selection if it's not empty.
      () => r.deleteSelection(),
      // Undoes an input rule if one was triggered in the last editor state change.
      () => r.undoInputRule(),
      // Reverts block content type to a paragraph if the selection is at the start of the block.
      () => r.command(({ state: s }) => {
        const i = O(s);
        if (!i.isBlockContainer)
          return !1;
        const c = s.selection.from === i.blockContent.beforePos + 1, a = i.blockContent.node.type.name === "paragraph";
        return c && !a ? r.command(
          ko(i.bnBlock.beforePos, {
            type: "paragraph",
            props: {}
          })
        ) : !1;
      }),
      // Removes a level of nesting if the block is indented if the selection is at the start of the block.
      () => r.command(({ state: s }) => {
        const i = O(s);
        if (!i.isBlockContainer)
          return !1;
        const { blockContent: c } = i;
        return s.selection.from === c.beforePos + 1 ? r.liftListItem("blockContainer") : !1;
      }),
      // Merges block with the previous one if it isn't indented, and the selection is at the start of the
      // block. The target block for merging must contain inline content.
      () => r.command(({ state: s }) => {
        const i = O(s);
        if (!i.isBlockContainer)
          return !1;
        const { bnBlock: c, blockContent: a } = i, l = s.selection.from === a.beforePos + 1, h = s.selection.empty, u = c.beforePos;
        return l && h ? o().command(rt(u)).scrollIntoView().run() : !1;
      }),
      () => r.command(({ state: s, tr: i, dispatch: c }) => {
        const a = O(s);
        if (!a.isBlockContainer || !(i.selection.from === a.blockContent.beforePos + 1))
          return !1;
        const h = i.doc.resolve(a.bnBlock.beforePos);
        if (h.nodeBefore || h.node().type.name !== "column")
          return !1;
        const m = i.doc.resolve(a.bnBlock.beforePos), g = i.doc.resolve(m.before()), p = g.before();
        if (c) {
          const k = i.doc.slice(
            a.bnBlock.beforePos,
            a.bnBlock.afterPos
          ).content;
          i.delete(
            a.bnBlock.beforePos,
            a.bnBlock.afterPos
          ), g.index() === 0 ? (Ie(i, p), i.insert(p, k), i.setSelection(
            I.near(i.doc.resolve(p))
          )) : (i.insert(g.pos - 1, k), i.setSelection(
            I.near(i.doc.resolve(g.pos - 1))
          ), Ie(i, p));
        }
        return !0;
      }),
      // Deletes the current block if it's an empty block with inline content,
      // and moves the selection to the previous block.
      () => r.command(({ state: s }) => {
        const i = O(s);
        if (!i.isBlockContainer)
          return !1;
        if (i.blockContent.node.childCount === 0 && i.blockContent.node.type.spec.content === "inline*") {
          const a = Le(
            s.doc,
            i.bnBlock.beforePos
          );
          if (!a || !a.isBlockContainer)
            return !1;
          let l = o();
          if (a.blockContent.node.type.spec.content === "tableRow+") {
            const g = i.bnBlock.beforePos - 1 - 1 - 1 - 1 - 1;
            l = l.setTextSelection(
              g
            );
          } else if (a.blockContent.node.type.spec.content === "") {
            const h = a.blockContent.afterPos - a.blockContent.node.nodeSize;
            l = l.setNodeSelection(
              h
            );
          } else {
            const h = a.blockContent.afterPos - a.blockContent.node.nodeSize;
            l = l.setTextSelection(h);
          }
          return l.deleteRange({
            from: i.bnBlock.beforePos,
            to: i.bnBlock.afterPos
          }).scrollIntoView().run();
        }
        return !1;
      }),
      // Deletes previous block if it contains no content and isn't a table,
      // when the selection is empty and at the start of the block. Moves the
      // current block into the deleted block's place.
      () => r.command(({ state: s }) => {
        const i = O(s);
        if (!i.isBlockContainer)
          throw new Error("todo");
        const c = s.selection.from === i.blockContent.beforePos + 1, a = s.selection.empty, l = Le(
          s.doc,
          i.bnBlock.beforePos
        );
        if (l && c && a) {
          const h = _t(
            s.doc,
            l
          );
          if (!h.isBlockContainer)
            throw new Error("todo");
          if (h.blockContent.node.type.spec.content === "" || h.blockContent.node.type.spec.content === "inline*" && h.blockContent.node.childCount === 0)
            return o().cut(
              {
                from: i.bnBlock.beforePos,
                to: i.bnBlock.afterPos
              },
              h.bnBlock.afterPos
            ).deleteRange({
              from: h.bnBlock.beforePos,
              to: h.bnBlock.afterPos
            }).run();
        }
        return !1;
      })
    ]), t = () => this.editor.commands.first(({ commands: o }) => [
      // Deletes the selection if it's not empty.
      () => o.deleteSelection(),
      // Merges block with the next one (at the same nesting level or lower),
      // if one exists, the block has no children, and the selection is at the
      // end of the block.
      () => o.command(({ state: r }) => {
        const s = O(r);
        if (!s.isBlockContainer)
          return !1;
        const {
          bnBlock: i,
          blockContent: c,
          childContainer: a
        } = s, { depth: l } = r.doc.resolve(i.beforePos), h = i.afterPos === r.doc.nodeSize - 3, u = r.selection.from === c.afterPos - 1, f = r.selection.empty;
        if (!h && u && f && !(a !== void 0)) {
          let g = l, p = i.afterPos + 1, k = r.doc.resolve(p).depth;
          for (; k < g; )
            g = k, p += 2, k = r.doc.resolve(p).depth;
          return o.command(rt(p - 1));
        }
        return !1;
      })
    ]), e = (o = !1) => this.editor.commands.first(({ commands: r, tr: s }) => [
      // Removes a level of nesting if the block is empty & indented, while the selection is also empty & at the start
      // of the block.
      () => r.command(({ state: i }) => {
        const c = O(i);
        if (!c.isBlockContainer)
          return !1;
        const { bnBlock: a, blockContent: l } = c, { depth: h } = i.doc.resolve(a.beforePos), u = i.selection.$anchor.parentOffset === 0, f = i.selection.anchor === i.selection.head, m = l.node.childCount === 0, g = h > 1;
        return u && f && m && g ? r.liftListItem("blockContainer") : !1;
      }),
      // Creates a hard break if block is configured to do so.
      () => r.command(({ state: i }) => {
        var l;
        const c = O(i), a = ((l = this.options.editor.schema.blockSchema[c.blockNoteType].meta) == null ? void 0 : l.hardBreakShortcut) ?? "shift+enter";
        if (a === "none")
          return !1;
        if (
          // If shortcut is not configured, or is configured as "shift+enter",
          // create a hard break for shift+enter, but not for enter.
          a === "shift+enter" && o || // If shortcut is configured as "enter", create a hard break for
          // both enter and shift+enter.
          a === "enter"
        ) {
          const h = s.storedMarks || s.selection.$head.marks().filter(
            (u) => this.editor.extensionManager.splittableMarks.includes(
              u.type.name
            )
          );
          return s.insert(
            s.selection.head,
            s.doc.type.schema.nodes.hardBreak.create()
          ).ensureMarks(h), !0;
        }
        return !1;
      }),
      // Creates a new block and moves the selection to it if the current one is empty, while the selection is also
      // empty & at the start of the block.
      () => r.command(({ state: i, dispatch: c }) => {
        const a = O(i);
        if (!a.isBlockContainer)
          return !1;
        const { bnBlock: l, blockContent: h } = a, u = i.selection.$anchor.parentOffset === 0, f = i.selection.anchor === i.selection.head, m = h.node.childCount === 0;
        if (u && f && m) {
          const g = l.afterPos, p = g + 2;
          if (c) {
            const k = i.schema.nodes.blockContainer.createAndFill();
            i.tr.insert(g, k).scrollIntoView(), i.tr.setSelection(
              new I(i.doc.resolve(p))
            );
          }
          return !0;
        }
        return !1;
      }),
      // Splits the current block, moving content inside that's after the cursor to a new text block below. Also
      // deletes the selection beforehand, if it's not empty.
      () => r.command(({ state: i, chain: c }) => {
        const a = O(i);
        if (!a.isBlockContainer)
          return !1;
        const { blockContent: l } = a, h = i.selection.$anchor.parentOffset === 0;
        return l.node.childCount === 0 ? !1 : (c().deleteSelection().command(
          go(
            i.selection.from,
            h,
            h
          )
        ).run(), !0);
      })
    ]);
    return {
      Backspace: n,
      Delete: t,
      Enter: () => e(),
      "Shift-Enter": () => e(!0),
      // Always returning true for tab key presses ensures they're not captured by the browser. Otherwise, they blur the
      // editor since the browser will try to use tab for keyboard navigation.
      Tab: () => {
        var o, r, s;
        return this.options.tabBehavior !== "prefer-indent" && ((o = this.options.editor.formattingToolbar) != null && o.shown || (r = this.options.editor.linkToolbar) != null && r.shown || (s = this.options.editor.filePanel) != null && s.shown) ? !1 : Nt(this.options.editor);
      },
      "Shift-Tab": () => {
        var o, r, s;
        return this.options.tabBehavior !== "prefer-indent" && ((o = this.options.editor.formattingToolbar) != null && o.shown || (r = this.options.editor.linkToolbar) != null && r.shown || (s = this.options.editor.filePanel) != null && s.shown) ? !1 : (this.editor.commands.liftListItem("blockContainer"), !0);
      },
      "Shift-Mod-ArrowUp": () => (this.options.editor.moveBlocksUp(), !0),
      "Shift-Mod-ArrowDown": () => (this.options.editor.moveBlocksDown(), !0),
      "Mod-z": () => this.options.editor.undo(),
      "Mod-y": () => this.options.editor.redo(),
      "Shift-Mod-z": () => this.options.editor.redo()
    };
  }
});
class br {
  constructor(t, e, o) {
    d(this, "state");
    d(this, "emitUpdate");
    d(this, "menuUpdateTimer");
    d(this, "startMenuUpdateTimer");
    d(this, "stopMenuUpdateTimer");
    d(this, "mouseHoveredLinkMark");
    d(this, "mouseHoveredLinkMarkRange");
    d(this, "keyboardHoveredLinkMark");
    d(this, "keyboardHoveredLinkMarkRange");
    d(this, "linkMark");
    d(this, "linkMarkRange");
    d(this, "mouseOverHandler", (t) => {
      if (this.mouseHoveredLinkMark = void 0, this.mouseHoveredLinkMarkRange = void 0, this.stopMenuUpdateTimer(), t.target instanceof HTMLAnchorElement && t.target.nodeName === "A") {
        const e = t.target, o = this.pmView.posAtDOM(e, 0) + 1, r = this.pmView.state.doc.resolve(o), s = r.marks();
        for (const i of s)
          if (i.type.name === this.pmView.state.schema.mark("link").type.name) {
            this.mouseHoveredLinkMark = i, this.mouseHoveredLinkMarkRange = Pe(r, i.type, i.attrs) || void 0;
            break;
          }
      }
      return this.startMenuUpdateTimer(), !1;
    });
    d(this, "clickHandler", (t) => {
      var o;
      const e = this.pmView.dom.parentElement;
      // Toolbar is open.
      this.linkMark && // An element is clicked.
      t && t.target && // The clicked element is not the editor.
      !(e === t.target || e.contains(t.target)) && (o = this.state) != null && o.show && (this.state.show = !1, this.emitUpdate());
    });
    d(this, "scrollHandler", () => {
      var t;
      this.linkMark !== void 0 && (t = this.state) != null && t.show && (this.state.referencePos = me(
        this.pmView,
        this.linkMarkRange.from,
        this.linkMarkRange.to
      ), this.emitUpdate());
    });
    d(this, "closeMenu", () => {
      var t;
      (t = this.state) != null && t.show && (this.state.show = !1, this.emitUpdate());
    });
    this.editor = t, this.pmView = e, this.emitUpdate = () => {
      if (!this.state)
        throw new Error("Attempting to update uninitialized link toolbar");
      o(this.state);
    }, this.startMenuUpdateTimer = () => {
      this.menuUpdateTimer = setTimeout(() => {
        this.update(this.pmView, void 0, !0);
      }, 250);
    }, this.stopMenuUpdateTimer = () => (this.menuUpdateTimer && (clearTimeout(this.menuUpdateTimer), this.menuUpdateTimer = void 0), !1), this.pmView.dom.addEventListener("mouseover", this.mouseOverHandler), this.pmView.root.addEventListener(
      "click",
      this.clickHandler,
      !0
    ), this.pmView.root.addEventListener("scroll", this.scrollHandler, !0);
  }
  editLink(t, e) {
    var o;
    this.editor.transact((r) => {
      const s = L(r);
      r.insertText(e, this.linkMarkRange.from, this.linkMarkRange.to), r.addMark(
        this.linkMarkRange.from,
        this.linkMarkRange.from + e.length,
        s.mark("link", { href: t })
      );
    }), this.pmView.focus(), (o = this.state) != null && o.show && (this.state.show = !1, this.emitUpdate());
  }
  deleteLink() {
    var t;
    this.editor.transact(
      (e) => e.removeMark(
        this.linkMarkRange.from,
        this.linkMarkRange.to,
        this.linkMark.type
      ).setMeta("preventAutolink", !0)
    ), this.pmView.focus(), (t = this.state) != null && t.show && (this.state.show = !1, this.emitUpdate());
  }
  update(t, e, o = !1) {
    var c;
    const { state: r } = t;
    if (e && e.selection.from === r.selection.from && e.selection.to === r.selection.to || !this.pmView.hasFocus())
      return;
    const i = this.linkMark;
    if (this.linkMark = void 0, this.linkMarkRange = void 0, this.keyboardHoveredLinkMark = void 0, this.keyboardHoveredLinkMarkRange = void 0, this.pmView.state.selection.empty) {
      const a = this.pmView.state.selection.$from.marks();
      for (const l of a)
        if (l.type.name === this.pmView.state.schema.mark("link").type.name) {
          this.keyboardHoveredLinkMark = l, this.keyboardHoveredLinkMarkRange = Pe(
            this.pmView.state.selection.$from,
            l.type,
            l.attrs
          ) || void 0;
          break;
        }
    }
    if (this.mouseHoveredLinkMark && o && (this.linkMark = this.mouseHoveredLinkMark, this.linkMarkRange = this.mouseHoveredLinkMarkRange), this.keyboardHoveredLinkMark && (this.linkMark = this.keyboardHoveredLinkMark, this.linkMarkRange = this.keyboardHoveredLinkMarkRange), this.linkMark && this.editor.isEditable) {
      this.state = {
        show: !0,
        referencePos: me(
          this.pmView,
          this.linkMarkRange.from,
          this.linkMarkRange.to
        ),
        url: this.linkMark.attrs.href,
        text: this.pmView.state.doc.textBetween(
          this.linkMarkRange.from,
          this.linkMarkRange.to
        )
      }, this.emitUpdate();
      return;
    }
    if ((c = this.state) != null && c.show && i && (!this.linkMark || !this.editor.isEditable)) {
      this.state.show = !1, this.emitUpdate();
      return;
    }
  }
  destroy() {
    this.pmView.dom.removeEventListener("mouseover", this.mouseOverHandler), this.pmView.root.removeEventListener("scroll", this.scrollHandler, !0), this.pmView.root.removeEventListener(
      "click",
      this.clickHandler,
      !0
    );
  }
}
const wr = new A("LinkToolbarPlugin");
class yr extends S {
  constructor(e) {
    super();
    d(this, "view");
    /**
     * Edit the currently hovered link.
     */
    d(this, "editLink", (e, o) => {
      this.view.editLink(e, o);
    });
    /**
     * Delete the currently hovered link.
     */
    d(this, "deleteLink", () => {
      this.view.deleteLink();
    });
    /**
     * When hovering on/off links using the mouse cursor, the link toolbar will
     * open & close with a delay.
     *
     * This function starts the delay timer, and should be used for when the mouse
     * cursor enters the link toolbar.
     */
    d(this, "startHideTimer", () => {
      this.view.startMenuUpdateTimer();
    });
    /**
     * When hovering on/off links using the mouse cursor, the link toolbar will
     * open & close with a delay.
     *
     * This function stops the delay timer, and should be used for when the mouse
     * cursor exits the link toolbar.
     */
    d(this, "stopHideTimer", () => {
      this.view.stopMenuUpdateTimer();
    });
    d(this, "closeMenu", () => this.view.closeMenu());
    this.addProsemirrorPlugin(
      new B({
        key: wr,
        view: (o) => (this.view = new br(e, o, (r) => {
          this.emit("update", r);
        }), this.view),
        props: {
          handleKeyDown: (o, r) => r.key === "Escape" && this.shown ? (this.view.closeMenu(), !0) : !1
        }
      })
    );
  }
  static key() {
    return "linkToolbar";
  }
  onUpdate(e) {
    return this.on("update", e);
  }
  get shown() {
    var e, o;
    return ((o = (e = this.view) == null ? void 0 : e.state) == null ? void 0 : o.show) || !1;
  }
}
const Cr = [
  "http",
  "https",
  "ftp",
  "ftps",
  "mailto",
  "tel",
  "callto",
  "sms",
  "cid",
  "xmpp"
], vr = "https", Sr = new A("node-selection-keyboard");
class Er extends S {
  static key() {
    return "nodeSelectionKeyboard";
  }
  constructor() {
    super(), this.addProsemirrorPlugin(
      new B({
        key: Sr,
        props: {
          handleKeyDown: (t, e) => {
            if ("node" in t.state.selection) {
              if (e.ctrlKey || e.metaKey)
                return !1;
              if (e.key.length === 1)
                return e.preventDefault(), !0;
              if (e.key === "Enter" && !e.shiftKey && !e.altKey && !e.ctrlKey && !e.metaKey) {
                const o = t.state.tr;
                return t.dispatch(
                  o.insert(
                    t.state.tr.selection.$to.after(),
                    t.state.schema.nodes.paragraph.createChecked()
                  ).setSelection(
                    new I(
                      o.doc.resolve(t.state.tr.selection.$to.after() + 1)
                    )
                  )
                ), !0;
              }
            }
            return !1;
          }
        }
      })
    );
  }
}
const Br = new A("blocknote-placeholder");
class Mr extends S {
  static key() {
    return "placeholder";
  }
  constructor(t, e) {
    super(), this.addProsemirrorPlugin(
      new B({
        key: Br,
        view: (o) => {
          const r = `placeholder-selector-${cn()}`;
          o.dom.classList.add(r);
          const s = document.createElement("style"), i = t._tiptapEditor.options.injectNonce;
          i && s.setAttribute("nonce", i), o.root instanceof window.ShadowRoot ? o.root.append(s) : o.root.head.appendChild(s);
          const c = s.sheet, a = (l = "") => `.${r} .bn-block-content${l} .bn-inline-content:has(> .ProseMirror-trailingBreak:only-child):before`;
          try {
            const {
              default: l,
              emptyDocument: h,
              ...u
            } = e;
            for (const [g, p] of Object.entries(u)) {
              const k = `[data-content-type="${g}"]`;
              c.insertRule(
                `${a(k)} { content: ${JSON.stringify(
                  p
                )}; }`
              );
            }
            const f = "[data-is-only-empty-block]", m = "[data-is-empty-and-focused]";
            c.insertRule(
              `${a(f)} { content: ${JSON.stringify(
                h
              )}; }`
            ), c.insertRule(
              `${a(m)} { content: ${JSON.stringify(
                l
              )}; }`
            );
          } catch (l) {
            console.warn(
              "Failed to insert placeholder CSS rule - this is likely due to the browser not supporting certain CSS pseudo-element selectors (:has, :only-child:, or :before)",
              l
            );
          }
          return {
            destroy: () => {
              o.root instanceof window.ShadowRoot ? o.root.removeChild(s) : o.root.head.removeChild(s);
            }
          };
        },
        props: {
          decorations: (o) => {
            const { doc: r, selection: s } = o;
            if (!t.isEditable || !s.empty || s.$from.parent.type.spec.code)
              return;
            const i = [];
            o.doc.content.size === 6 && i.push(
              $.node(2, 4, {
                "data-is-only-empty-block": "true"
              })
            );
            const c = s.$anchor, a = c.parent;
            if (a.content.size === 0) {
              const l = c.before();
              i.push(
                $.node(l, l + a.nodeSize, {
                  "data-is-empty-and-focused": "true"
                })
              );
            }
            return U.create(r, i);
          }
        }
      })
    );
  }
}
const st = new A("previous-blocks"), Pr = {
  // Numbered List Items
  index: "index",
  // Headings
  level: "level",
  // All Blocks
  type: "type",
  depth: "depth",
  "depth-change": "depth-change"
};
class Tr extends S {
  static key() {
    return "previousBlockType";
  }
  constructor() {
    super();
    let t;
    this.addProsemirrorPlugin(
      new B({
        key: st,
        view(e) {
          return {
            update: async (o, r) => {
              var s;
              ((s = this.key) == null ? void 0 : s.getState(o.state).updatedBlocks.size) > 0 && (t = setTimeout(() => {
                o.dispatch(
                  o.state.tr.setMeta(st, { clearUpdate: !0 })
                );
              }, 0));
            },
            destroy: () => {
              t && clearTimeout(t);
            }
          };
        },
        state: {
          init() {
            return {
              // Block attributes, by block ID, from just before the previous transaction.
              prevTransactionOldBlockAttrs: {},
              // Block attributes, by block ID, from just before the current transaction.
              currentTransactionOldBlockAttrs: {},
              // Set of IDs of blocks whose attributes changed from the current transaction.
              updatedBlocks: /* @__PURE__ */ new Set()
            };
          },
          apply(e, o, r, s) {
            if (o.currentTransactionOldBlockAttrs = {}, o.updatedBlocks.clear(), !e.docChanged || r.doc.eq(s.doc))
              return o;
            const i = {}, c = Xe(
              r.doc,
              (h) => h.attrs.id
            ), a = new Map(
              c.map((h) => [h.node.attrs.id, h])
            ), l = Xe(
              s.doc,
              (h) => h.attrs.id
            );
            for (const h of l) {
              const u = a.get(h.node.attrs.id), f = u == null ? void 0 : u.node.firstChild, m = h.node.firstChild;
              if (u && f && m) {
                const g = {
                  index: m.attrs.index,
                  level: m.attrs.level,
                  type: m.type.name,
                  depth: s.doc.resolve(h.pos).depth
                }, p = {
                  index: f.attrs.index,
                  level: f.attrs.level,
                  type: f.type.name,
                  depth: r.doc.resolve(u.pos).depth
                };
                i[h.node.attrs.id] = p, o.currentTransactionOldBlockAttrs[h.node.attrs.id] = p, JSON.stringify(p) !== JSON.stringify(g) && (p["depth-change"] = p.depth - g.depth, o.updatedBlocks.add(h.node.attrs.id));
              }
            }
            return o.prevTransactionOldBlockAttrs = i, o;
          }
        },
        props: {
          decorations(e) {
            const o = this.getState(e);
            if (o.updatedBlocks.size === 0)
              return;
            const r = [];
            return e.doc.descendants((s, i) => {
              if (!s.attrs.id || !o.updatedBlocks.has(s.attrs.id))
                return;
              const c = o.currentTransactionOldBlockAttrs[s.attrs.id], a = {};
              for (const [h, u] of Object.entries(c))
                a["data-prev-" + Pr[h]] = u || "none";
              const l = $.node(i, i + s.nodeSize, {
                ...a
              });
              r.push(l);
            }), U.create(e.doc, r);
          }
        }
      })
    );
  }
}
const it = new A("blocknote-show-selection");
class xr extends S {
  constructor(e) {
    super();
    d(this, "enabled", !1);
    this.editor = e, this.addProsemirrorPlugin(
      new B({
        key: it,
        props: {
          decorations: (o) => {
            const { doc: r, selection: s } = o;
            if (!this.enabled)
              return U.empty;
            const i = $.inline(s.from, s.to, {
              "data-show-selection": "true"
            });
            return U.create(r, [i]);
          }
        }
      })
    );
  }
  static key() {
    return "showSelection";
  }
  setEnabled(e) {
    this.enabled !== e && (this.enabled = e, this.editor.transact((o) => o.setMeta(it, {})));
  }
  getEnabled() {
    return this.enabled;
  }
}
function Ht(n, t) {
  var e, o;
  for (; n && n.parentElement && n.parentElement !== t.dom && ((e = n.getAttribute) == null ? void 0 : e.call(n, "data-node-type")) !== "blockContainer"; )
    n = n.parentElement;
  if (((o = n.getAttribute) == null ? void 0 : o.call(n, "data-node-type")) === "blockContainer")
    return { node: n, id: n.getAttribute("data-id") };
}
class G extends ue {
  constructor(e, o) {
    super(e, o);
    d(this, "nodes");
    const r = e.node();
    this.nodes = [], e.doc.nodesBetween(e.pos, o.pos, (s, i, c) => {
      if (c !== null && c.eq(r))
        return this.nodes.push(s), !1;
    });
  }
  static create(e, o, r = o) {
    return new G(e.resolve(o), e.resolve(r));
  }
  content() {
    return new z(V.from(this.nodes), 0, 0);
  }
  eq(e) {
    if (!(e instanceof G) || this.nodes.length !== e.nodes.length || this.from !== e.from || this.to !== e.to)
      return !1;
    for (let o = 0; o < this.nodes.length; o++)
      if (!this.nodes[o].eq(e.nodes[o]))
        return !1;
    return !0;
  }
  map(e, o) {
    const r = o.mapResult(this.from), s = o.mapResult(this.to);
    return s.deleted ? ue.near(e.resolve(r.pos)) : r.deleted ? ue.near(e.resolve(s.pos)) : new G(
      e.resolve(r.pos),
      e.resolve(s.pos)
    );
  }
  toJSON() {
    return { type: "multiple-node", anchor: this.anchor, head: this.head };
  }
}
ue.jsonID("multiple-node", G);
let H;
function Ir(n, t) {
  let e, o;
  const r = t.resolve(n.from).node().type.spec.group === "blockContent", s = t.resolve(n.to).node().type.spec.group === "blockContent", i = Math.min(n.$anchor.depth, n.$head.depth);
  if (r && s) {
    const c = n.$from.start(i - 1), a = n.$to.end(i - 1);
    e = t.resolve(c - 1).pos, o = t.resolve(a + 1).pos;
  } else
    e = n.from, o = n.to;
  return { from: e, to: o };
}
function at(n, t, e = t) {
  t === e && (e += n.state.doc.resolve(t + 1).node().nodeSize);
  const o = n.domAtPos(t).node.cloneNode(!0), r = n.domAtPos(t).node, s = (u, f) => Array.prototype.indexOf.call(u.children, f), i = s(
    r,
    // Expects from position to be just before the first selected block.
    n.domAtPos(t + 1).node.parentElement
  ), c = s(
    r,
    // Expects to position to be just after the last selected block.
    n.domAtPos(e - 1).node.parentElement
  );
  for (let u = r.childElementCount - 1; u >= 0; u--)
    (u > c || u < i) && o.removeChild(o.children[u]);
  Ut(n.root), H = o;
  const a = H.getElementsByTagName("iframe");
  for (let u = 0; u < a.length; u++) {
    const f = a[u], m = f.parentElement;
    m && m.removeChild(f);
  }
  const h = n.dom.className.split(" ").filter(
    (u) => u !== "ProseMirror" && u !== "bn-root" && u !== "bn-editor"
  ).join(" ");
  H.className = H.className + " bn-drag-preview " + h, n.root instanceof ShadowRoot ? n.root.appendChild(H) : n.root.body.appendChild(H);
}
function Ut(n) {
  H !== void 0 && (n instanceof ShadowRoot ? n.removeChild(H) : n.body.removeChild(H), H = void 0);
}
function Lr(n, t, e) {
  if (!n.dataTransfer || e.headless)
    return;
  const o = e.prosemirrorView, r = _(t.id, o.state.doc);
  if (!r)
    throw new Error(`Block with ID ${t.id} not found`);
  const s = r.posBeforeNode;
  if (s != null) {
    const i = o.state.selection, c = o.state.doc, { from: a, to: l } = Ir(i, c), h = a <= s && s < l, u = i.$anchor.node() !== i.$head.node() || i instanceof G;
    h && u ? (o.dispatch(
      o.state.tr.setSelection(G.create(c, a, l))
    ), at(o, a, l)) : (o.dispatch(
      o.state.tr.setSelection(X.create(o.state.doc, s))
    ), at(o, s));
    const f = o.state.selection.content(), m = e.pmSchema, g = o.serializeForClipboard(f).dom.innerHTML, p = Ce(m, e), k = It(f.content), b = p.exportBlocks(k, {}), w = Re(b);
    n.dataTransfer.clearData(), n.dataTransfer.setData("blocknote/html", g), n.dataTransfer.setData("text/html", b), n.dataTransfer.setData("text/plain", w), n.dataTransfer.effectAllowed = "move", n.dataTransfer.setDragImage(H, 0, 0);
  }
}
const ct = 250;
function Ae(n, t, e = !0) {
  const o = n.root.elementsFromPoint(t.left, t.top);
  for (const r of o)
    if (n.dom.contains(r))
      return e && r.closest("[data-node-type=columnList]") ? Ae(
        n,
        {
          // TODO can we do better than this?
          left: t.left + 50,
          // bit hacky, but if we're inside a column, offset x position to right to account for the width of sidemenu itself
          top: t.top
        },
        !1
      ) : Ht(r, n);
}
function Ar(n, t) {
  if (!t.dom.firstChild)
    return;
  const e = t.dom.firstChild.getBoundingClientRect(), o = {
    // Clamps the x position to the editor's bounding box.
    left: Math.min(
      Math.max(e.left + 10, n.x),
      e.right - 10
    ),
    top: n.y
  }, r = Ae(t, o);
  if (!r)
    return;
  const s = r.node.getBoundingClientRect();
  return Ae(
    t,
    {
      left: s.right - 10,
      top: n.y
    },
    !1
  );
}
class Dr {
  constructor(t, e, o) {
    d(this, "state");
    d(this, "emitUpdate");
    d(this, "mousePos");
    d(this, "hoveredBlock");
    d(this, "menuFrozen", !1);
    d(this, "isDragOrigin", !1);
    d(this, "updateState", (t) => {
      this.state = t, this.emitUpdate(this.state);
    });
    d(this, "updateStateFromMousePos", () => {
      var o, r, s, i, c;
      if (this.menuFrozen || !this.mousePos)
        return;
      const t = this.findClosestEditorElement({
        clientX: this.mousePos.x,
        clientY: this.mousePos.y
      });
      if ((t == null ? void 0 : t.element) !== this.pmView.dom || t.distance > ct) {
        (o = this.state) != null && o.show && (this.state.show = !1, this.updateState(this.state));
        return;
      }
      const e = Ar(this.mousePos, this.pmView);
      if (!e || !this.editor.isEditable) {
        (r = this.state) != null && r.show && (this.state.show = !1, this.updateState(this.state));
        return;
      }
      if (!((s = this.state) != null && s.show && ((i = this.hoveredBlock) != null && i.hasAttribute("data-id")) && ((c = this.hoveredBlock) == null ? void 0 : c.getAttribute("data-id")) === e.id) && (this.hoveredBlock = e.node, this.editor.isEditable)) {
        const a = e.node.getBoundingClientRect(), l = e.node.closest("[data-node-type=column]");
        this.state = {
          show: !0,
          referencePos: new DOMRect(
            l ? (
              // We take the first child as column elements have some default
              // padding. This is a little weird since this child element will
              // be the first block, but since it's always non-nested and we
              // only take the x coordinate, it's ok.
              l.firstElementChild.getBoundingClientRect().x
            ) : this.pmView.dom.firstChild.getBoundingClientRect().x,
            a.y,
            a.width,
            a.height
          ),
          block: this.editor.getBlock(
            this.hoveredBlock.getAttribute("data-id")
          )
        }, this.updateState(this.state);
      }
    });
    /**
     * If a block is being dragged, ProseMirror usually gets the context of what's
     * being dragged from `view.dragging`, which is automatically set when a
     * `dragstart` event fires in the editor. However, if the user tries to drag
     * and drop blocks between multiple editors, only the one in which the drag
     * began has that context, so we need to set it on the others manually. This
     * ensures that PM always drops the blocks in between other blocks, and not
     * inside them.
     *
     * After the `dragstart` event fires on the drag handle, it sets
     * `blocknote/html` data on the clipboard. This handler fires right after,
     * parsing the `blocknote/html` data into nodes and setting them on
     * `view.dragging`.
     *
     * Note: Setting `view.dragging` on `dragover` would be better as the user
     * could then drag between editors in different windows, but you can only
     * access `dataTransfer` contents on `dragstart` and `drop` events.
     */
    d(this, "onDragStart", (t) => {
      var i;
      const e = (i = t.dataTransfer) == null ? void 0 : i.getData("blocknote/html");
      if (!e || this.pmView.dragging)
        return;
      const o = document.createElement("div");
      o.innerHTML = e;
      const s = ut.fromSchema(this.pmView.state.schema).parse(o, {
        topNode: this.pmView.state.schema.nodes.blockGroup.create()
      });
      this.pmView.dragging = {
        slice: new z(s.content, 0, 0),
        move: !0
      };
    });
    /**
     * Finds the closest editor visually to the given coordinates
     */
    d(this, "findClosestEditorElement", (t) => {
      const e = Array.from(this.pmView.root.querySelectorAll(".bn-editor"));
      if (e.length === 0)
        return null;
      let o = e[0], r = Number.MAX_VALUE;
      return e.forEach((s) => {
        const i = s.querySelector(".bn-block-group").getBoundingClientRect(), c = t.clientX < i.left ? i.left - t.clientX : t.clientX > i.right ? t.clientX - i.right : 0, a = t.clientY < i.top ? i.top - t.clientY : t.clientY > i.bottom ? t.clientY - i.bottom : 0, l = Math.sqrt(
          Math.pow(c, 2) + Math.pow(a, 2)
        );
        l < r && (r = l, o = s);
      }), {
        element: o,
        distance: r
      };
    });
    /**
     * This dragover event handler listens at the document level,
     * and is trying to handle dragover events for all editors.
     *
     * It specifically is trying to handle the following cases:
     *  - If the dragover event is within the bounds of any editor, then it does nothing
     *  - If the dragover event is outside the bounds of any editor, but close enough (within DISTANCE_TO_CONSIDER_EDITOR_BOUNDS) to the closest editor,
     *    then it dispatches a synthetic dragover event to the closest editor (which will trigger the drop-cursor to be shown on that editor)
     *  - If the dragover event is outside the bounds of the current editor, then it will dispatch a synthetic dragleave event to the current editor
     *    (which will trigger the drop-cursor to be removed from the current editor)
     *
     * The synthetic event is a necessary evil because we do not control prosemirror-dropcursor to be able to show the drop-cursor within the range we want
     */
    d(this, "onDragOver", (t) => {
      if (t.synthetic)
        return;
      const e = this.getDragEventContext(t);
      if (!e || !e.isDropPoint) {
        this.closeDropCursor();
        return;
      }
      e.isDropPoint && !e.isDropWithinEditorBounds && this.dispatchSyntheticEvent(t);
    });
    /**
     * Closes the drop-cursor for the current editor
     */
    d(this, "closeDropCursor", () => {
      const t = new Event("dragleave", { bubbles: !1 });
      t.synthetic = !0, this.pmView.dom.dispatchEvent(t);
    });
    /**
     * It is surprisingly difficult to determine the information we need to know about a drag event
     *
     * This function is trying to determine the following:
     *  - Whether the current editor instance is the drop point
     *  - Whether the current editor instance is the drag origin
     *  - Whether the drop event is within the bounds of the current editor instance
     */
    d(this, "getDragEventContext", (t) => {
      var a;
      const e = !((a = t.dataTransfer) != null && a.types.includes("blocknote/html")) && !!this.pmView.dragging, o = !!this.isDragOrigin, r = e || o, s = this.findClosestEditorElement(t);
      if (!s || s.distance > ct)
        return;
      const i = s.element === this.pmView.dom, c = i && s.distance === 0;
      if (!(!i && !r))
        return {
          isDropPoint: i,
          isDropWithinEditorBounds: c,
          isDragOrigin: r
        };
    });
    /**
     * The drop event handler listens at the document level,
     * and handles drop events for all editors.
     *
     * It specifically handles the following cases:
     *  - If we are both the drag origin and drop point:
     *    - Let normal drop handling take over
     *  - If we are the drop point but not the drag origin:
     *    - Collapse selection to prevent PM from deleting unrelated content
     *    - If drop event is outside our editor bounds, dispatch synthetic drop event to our editor
     *  - If we are the drag origin but not the drop point:
     *    - Delete the dragged content from our editor after a delay
     */
    d(this, "onDrop", (t) => {
      if (t.synthetic)
        return;
      const e = this.getDragEventContext(t);
      if (!e) {
        this.closeDropCursor();
        return;
      }
      const { isDropPoint: o, isDropWithinEditorBounds: r, isDragOrigin: s } = e;
      if (!r && o && this.dispatchSyntheticEvent(t), o) {
        if (this.pmView.dragging)
          return;
        this.pmView.dispatch(
          this.pmView.state.tr.setSelection(
            I.create(
              this.pmView.state.tr.doc,
              this.pmView.state.tr.selection.anchor
            )
          )
        );
        return;
      } else if (s) {
        setTimeout(
          () => this.pmView.dispatch(this.pmView.state.tr.deleteSelection()),
          0
        );
        return;
      }
    });
    d(this, "onDragEnd", (t) => {
      t.synthetic || (this.pmView.dragging = null);
    });
    d(this, "onKeyDown", (t) => {
      var e;
      (e = this.state) != null && e.show && this.editor.isFocused() && (this.state.show = !1, this.emitUpdate(this.state));
    });
    d(this, "onMouseMove", (t) => {
      var s;
      if (this.menuFrozen)
        return;
      this.mousePos = { x: t.clientX, y: t.clientY };
      const e = this.pmView.dom.getBoundingClientRect(), o = this.mousePos.x > e.left && this.mousePos.x < e.right && this.mousePos.y > e.top && this.mousePos.y < e.bottom, r = this.pmView.dom.parentElement;
      if (
        // Cursor is within the editor area
        o && // An element is hovered
        t && t.target && // Element is outside the editor
        !(r === t.target || r.contains(t.target))
      ) {
        (s = this.state) != null && s.show && (this.state.show = !1, this.emitUpdate(this.state));
        return;
      }
      this.updateStateFromMousePos();
    });
    d(this, "onScroll", () => {
      var t;
      (t = this.state) != null && t.show && (this.state.referencePos = this.hoveredBlock.getBoundingClientRect(), this.emitUpdate(this.state)), this.updateStateFromMousePos();
    });
    this.editor = t, this.pmView = e, this.emitUpdate = () => {
      if (!this.state)
        throw new Error("Attempting to update uninitialized side menu");
      o(this.state);
    }, this.pmView.root.addEventListener(
      "dragstart",
      this.onDragStart
    ), this.pmView.root.addEventListener(
      "dragover",
      this.onDragOver
    ), this.pmView.root.addEventListener(
      "drop",
      this.onDrop,
      !0
    ), this.pmView.root.addEventListener(
      "dragend",
      this.onDragEnd,
      !0
    ), this.pmView.root.addEventListener(
      "mousemove",
      this.onMouseMove,
      !0
    ), this.pmView.root.addEventListener(
      "keydown",
      this.onKeyDown,
      !0
    ), e.root.addEventListener("scroll", this.onScroll, !0);
  }
  dispatchSyntheticEvent(t) {
    const e = new Event(t.type, t), o = this.pmView.dom.firstChild.getBoundingClientRect();
    e.clientX = t.clientX, e.clientY = t.clientY, e.clientX = Math.min(
      Math.max(t.clientX, o.left),
      o.left + o.width
    ), e.clientY = Math.min(
      Math.max(t.clientY, o.top),
      o.top + o.height
    ), e.dataTransfer = t.dataTransfer, e.preventDefault = () => t.preventDefault(), e.synthetic = !0, this.pmView.dom.dispatchEvent(e);
  }
  // Needed in cases where the editor state updates without the mouse cursor
  // moving, as some state updates can require a side menu update. For example,
  // adding a button to the side menu which removes the block can cause the
  // block below to jump up into the place of the removed block when clicked,
  // allowing the user to click the button again without moving the cursor. This
  // would otherwise not update the side menu, and so clicking the button again
  // would attempt to remove the same block again, causing an error.
  update(t, e) {
    var r;
    !e.doc.eq(this.pmView.state.doc) && ((r = this.state) != null && r.show) && this.updateStateFromMousePos();
  }
  destroy() {
    var t;
    (t = this.state) != null && t.show && (this.state.show = !1, this.emitUpdate(this.state)), this.pmView.root.removeEventListener(
      "mousemove",
      this.onMouseMove,
      !0
    ), this.pmView.root.removeEventListener(
      "dragstart",
      this.onDragStart
    ), this.pmView.root.removeEventListener(
      "dragover",
      this.onDragOver
    ), this.pmView.root.removeEventListener(
      "drop",
      this.onDrop,
      !0
    ), this.pmView.root.removeEventListener(
      "dragend",
      this.onDragEnd,
      !0
    ), this.pmView.root.removeEventListener(
      "keydown",
      this.onKeyDown,
      !0
    ), this.pmView.root.removeEventListener("scroll", this.onScroll, !0);
  }
}
const Or = new A("SideMenuPlugin");
class _r extends S {
  constructor(e) {
    super();
    d(this, "view");
    /**
     * Handles drag & drop events for blocks.
     */
    d(this, "blockDragStart", (e, o) => {
      this.view && (this.view.isDragOrigin = !0), Lr(e, o, this.editor);
    });
    /**
     * Handles drag & drop events for blocks.
     */
    d(this, "blockDragEnd", () => {
      Ut(this.editor.prosemirrorView.root), this.view && (this.view.isDragOrigin = !1), this.editor.blur();
    });
    /**
     * Freezes the side menu. When frozen, the side menu will stay
     * attached to the same block regardless of which block is hovered by the
     * mouse cursor.
     */
    d(this, "freezeMenu", () => {
      this.view.menuFrozen = !0, this.view.state.show = !0, this.view.emitUpdate(this.view.state);
    });
    /**
     * Unfreezes the side menu. When frozen, the side menu will stay
     * attached to the same block regardless of which block is hovered by the
     * mouse cursor.
     */
    d(this, "unfreezeMenu", () => {
      this.view.menuFrozen = !1, this.view.state.show = !1, this.view.emitUpdate(this.view.state);
    });
    this.editor = e, this.addProsemirrorPlugin(
      new B({
        key: Or,
        view: (o) => (this.view = new Dr(e, o, (r) => {
          this.emit("update", r);
        }), this.view)
      })
    );
  }
  static key() {
    return "sideMenu";
  }
  onUpdate(e) {
    return this.on("update", e);
  }
}
const le = /* @__PURE__ */ new Map();
function Nr(n) {
  if (le.has(n))
    return le.get(n);
  const t = new eo();
  return n._tiptapEditor.on("transaction", ({ transaction: e }) => {
    t.appendMapping(e.mapping);
  }), n._tiptapEditor.on("destroy", () => {
    le.delete(n);
  }), le.set(n, t), t;
}
function Hr(n, t, e = "left") {
  const o = Y.getState(n.prosemirrorState);
  if (!o) {
    const s = Nr(n), i = s.maps.length;
    return () => s.slice(i).map(t, e === "left" ? -1 : 1);
  }
  const r = nn(
    // Track the position after the position if we are on the right side
    t + (e === "right" ? 1 : -1),
    o.binding.type,
    o.binding.mapping
  );
  return () => {
    const s = Y.getState(
      n.prosemirrorState
    ), i = rn(
      s.doc,
      s.binding.type,
      r,
      s.binding.mapping
    );
    if (i === null)
      throw new Error("Position not found, cannot track positions");
    return i + (e === "right" ? -1 : 1);
  };
}
const Ur = Mo((n) => n.type.name === "blockContainer");
class Rr {
  constructor(t, e, o) {
    d(this, "state");
    d(this, "emitUpdate");
    d(this, "rootEl");
    d(this, "pluginState");
    d(this, "handleScroll", () => {
      var t, e;
      if ((t = this.state) != null && t.show) {
        const o = (e = this.rootEl) == null ? void 0 : e.querySelector(
          `[data-decoration-id="${this.pluginState.decorationId}"]`
        );
        if (!o)
          return;
        this.state.referencePos = o.getBoundingClientRect(), this.emitUpdate(this.pluginState.triggerCharacter);
      }
    });
    d(this, "closeMenu", () => {
      this.editor.transact((t) => t.setMeta(K, null));
    });
    d(this, "clearQuery", () => {
      this.pluginState !== void 0 && this.editor._tiptapEditor.chain().focus().deleteRange({
        from: this.pluginState.queryStartPos() - (this.pluginState.deleteTriggerCharacter ? this.pluginState.triggerCharacter.length : 0),
        to: this.editor.transact((t) => t.selection.from)
      }).run();
    });
    var r;
    this.editor = t, this.pluginState = void 0, this.emitUpdate = (s) => {
      var i;
      if (!this.state)
        throw new Error("Attempting to update uninitialized suggestions menu");
      e(s, {
        ...this.state,
        ignoreQueryLength: (i = this.pluginState) == null ? void 0 : i.ignoreQueryLength
      });
    }, this.rootEl = o.root, (r = this.rootEl) == null || r.addEventListener("scroll", this.handleScroll, !0);
  }
  update(t, e) {
    var l;
    const o = K.getState(e), r = K.getState(
      t.state
    ), s = o === void 0 && r !== void 0, i = o !== void 0 && r === void 0;
    if (!s && !(o !== void 0 && r !== void 0) && !i)
      return;
    if (this.pluginState = i ? o : r, i || !this.editor.isEditable) {
      this.state && (this.state.show = !1), this.emitUpdate(this.pluginState.triggerCharacter);
      return;
    }
    const a = (l = this.rootEl) == null ? void 0 : l.querySelector(
      `[data-decoration-id="${this.pluginState.decorationId}"]`
    );
    this.editor.isEditable && a && (this.state = {
      show: !0,
      referencePos: a.getBoundingClientRect(),
      query: this.pluginState.query
    }, this.emitUpdate(this.pluginState.triggerCharacter));
  }
  destroy() {
    var t;
    (t = this.rootEl) == null || t.removeEventListener("scroll", this.handleScroll, !0);
  }
}
const K = new A("SuggestionMenuPlugin");
class Vr extends S {
  constructor(e) {
    super();
    d(this, "view");
    d(this, "triggerCharacters", []);
    d(this, "addTriggerCharacter", (e) => {
      this.triggerCharacters.push(e);
    });
    // TODO: Should this be called automatically when listeners are removed?
    d(this, "removeTriggerCharacter", (e) => {
      this.triggerCharacters = this.triggerCharacters.filter(
        (o) => o !== e
      );
    });
    d(this, "closeMenu", () => this.view.closeMenu());
    d(this, "clearQuery", () => this.view.clearQuery());
    const o = this.triggerCharacters;
    this.addProsemirrorPlugin(
      new B({
        key: K,
        view: (r) => (this.view = new Rr(
          e,
          (s, i) => {
            this.emit(`update ${s}`, i);
          },
          r
        ), this.view),
        state: {
          // Initialize the plugin's internal state.
          init() {
          },
          // Apply changes to the plugin state from an editor transaction.
          apply: (r, s, i, c) => {
            if (r.selection.$from.parent.type.spec.code)
              return s;
            const a = r.getMeta(K);
            if (typeof a == "object" && a !== null) {
              s && this.closeMenu();
              const h = Hr(
                e,
                c.selection.from - // Need to account for the trigger char that was inserted, so we offset the position by the length of the trigger character.
                a.triggerCharacter.length
              );
              return {
                triggerCharacter: a.triggerCharacter,
                deleteTriggerCharacter: a.deleteTriggerCharacter !== !1,
                // When reading the queryStartPos, we offset the result by the length of the trigger character, to make it easy on the caller
                queryStartPos: () => h() + a.triggerCharacter.length,
                query: "",
                decorationId: `id_${Math.floor(Math.random() * 4294967295)}`,
                ignoreQueryLength: a == null ? void 0 : a.ignoreQueryLength
              };
            }
            if (s === void 0)
              return s;
            if (
              // Highlighting text should hide the menu.
              c.selection.from !== c.selection.to || // Transactions with plugin metadata should hide the menu.
              a === null || // Certain mouse events should hide the menu.
              // TODO: Change to global mousedown listener.
              r.getMeta("focus") || r.getMeta("blur") || r.getMeta("pointer") || // Moving the caret before the character which triggered the menu should hide it.
              s.triggerCharacter !== void 0 && c.selection.from < s.queryStartPos() || // Moving the caret to a new block should hide the menu.
              !c.selection.$from.sameParent(
                c.doc.resolve(s.queryStartPos())
              )
            )
              return;
            const l = { ...s };
            return l.query = c.doc.textBetween(
              s.queryStartPos(),
              c.selection.from
            ), l;
          }
        },
        props: {
          handleTextInput(r, s, i, c) {
            if (s === i) {
              const a = r.state.doc;
              for (const l of o) {
                const h = l.length > 1 ? a.textBetween(s - l.length, s) + c : c;
                if (l === h)
                  return r.dispatch(r.state.tr.insertText(c)), r.dispatch(
                    r.state.tr.setMeta(K, {
                      triggerCharacter: h
                    }).scrollIntoView()
                  ), !0;
              }
            }
            return !1;
          },
          // Setup decorator on the currently active suggestion.
          decorations(r) {
            const s = this.getState(r);
            if (s === void 0)
              return null;
            if (!s.deleteTriggerCharacter) {
              const i = Ur(r.selection);
              if (i)
                return U.create(r.doc, [
                  $.node(
                    i.pos,
                    i.pos + i.node.nodeSize,
                    {
                      nodeName: "span",
                      class: "bn-suggestion-decorator",
                      "data-decoration-id": s.decorationId
                    }
                  )
                ]);
            }
            return U.create(r.doc, [
              $.inline(
                s.queryStartPos() - s.triggerCharacter.length,
                s.queryStartPos(),
                {
                  nodeName: "span",
                  class: "bn-suggestion-decorator",
                  "data-decoration-id": s.decorationId
                }
              )
            ]);
          }
        }
      })
    );
  }
  static key() {
    return "suggestionMenu";
  }
  onUpdate(e, o) {
    return this.triggerCharacters.includes(e) || this.addTriggerCharacter(e), this.on(`update ${e}`, o);
  }
  get shown() {
    var e, o;
    return ((o = (e = this.view) == null ? void 0 : e.state) == null ? void 0 : o.show) || !1;
  }
}
function gi(n, t) {
  n.suggestionMenus.addTriggerCharacter(t);
}
const $r = ie.create({
  name: "insertion",
  inclusive: !1,
  excludes: "deletion modification insertion",
  addAttributes() {
    return {
      id: { default: null, validate: "number" }
      // note: validate is supported in prosemirror but not in tiptap, so this doesn't actually work (considered not critical)
    };
  },
  extendMarkSchema(n) {
    return n.name !== "insertion" ? {} : {
      blocknoteIgnore: !0,
      inclusive: !1,
      toDOM(t, e) {
        return [
          "ins",
          {
            "data-id": String(t.attrs.id),
            "data-inline": String(e),
            ...!e && { style: "display: contents" }
            // changed to "contents" to make this work for table rows
          },
          0
        ];
      },
      parseDOM: [
        {
          tag: "ins",
          getAttrs(t) {
            return t.dataset.id ? {
              id: parseInt(t.dataset.id, 10)
            } : !1;
          }
        }
      ]
    };
  }
}), Fr = ie.create({
  name: "deletion",
  inclusive: !1,
  excludes: "insertion modification deletion",
  addAttributes() {
    return {
      id: { default: null, validate: "number" }
      // note: validate is supported in prosemirror but not in tiptap
    };
  },
  extendMarkSchema(n) {
    return n.name !== "deletion" ? {} : {
      blocknoteIgnore: !0,
      inclusive: !1,
      // attrs: {
      //   id: { validate: "number" },
      // },
      toDOM(t, e) {
        return [
          "del",
          {
            "data-id": String(t.attrs.id),
            "data-inline": String(e),
            ...!e && { style: "display: contents" }
            // changed to "contents" to make this work for table rows
          },
          0
        ];
      },
      parseDOM: [
        {
          tag: "del",
          getAttrs(t) {
            return t.dataset.id ? {
              id: parseInt(t.dataset.id, 10)
            } : !1;
          }
        }
      ]
    };
  }
}), zr = ie.create({
  name: "modification",
  inclusive: !1,
  excludes: "deletion insertion",
  addAttributes() {
    return {
      id: { default: null, validate: "number" },
      type: { validate: "string" },
      attrName: { default: null, validate: "string|null" },
      previousValue: { default: null },
      newValue: { default: null }
    };
  },
  extendMarkSchema(n) {
    return n.name !== "modification" ? {} : {
      blocknoteIgnore: !0,
      inclusive: !1,
      // attrs: {
      //   id: { validate: "number" },
      //   type: { validate: "string" },
      //   attrName: { default: null, validate: "string|null" },
      //   previousValue: { default: null },
      //   newValue: { default: null },
      // },
      toDOM(t, e) {
        return [
          e ? "span" : "div",
          {
            "data-type": "modification",
            "data-id": String(t.attrs.id),
            "data-mod-type": t.attrs.type,
            "data-mod-prev-val": JSON.stringify(t.attrs.previousValue),
            // TODO: Try to serialize marks with toJSON?
            "data-mod-new-val": JSON.stringify(t.attrs.newValue)
          },
          0
        ];
      },
      parseDOM: [
        {
          tag: "span[data-type='modification']",
          getAttrs(t) {
            return t.dataset.id ? {
              id: parseInt(t.dataset.id, 10),
              type: t.dataset.modType,
              previousValue: t.dataset.modPrevVal,
              newValue: t.dataset.modNewVal
            } : !1;
          }
        },
        {
          tag: "div[data-type='modification']",
          getAttrs(t) {
            return t.dataset.id ? {
              id: parseInt(t.dataset.id, 10),
              type: t.dataset.modType,
              previousValue: t.dataset.modPrevVal
            } : !1;
          }
        }
      ]
    };
  }
});
let x;
function lt(n) {
  x || (x = document.createElement("div"), x.innerHTML = "_", x.style.opacity = "0", x.style.height = "1px", x.style.width = "1px", n instanceof Document ? n.body.appendChild(x) : n.appendChild(x));
}
function Gr(n) {
  x && (n instanceof Document ? n.body.removeChild(x) : n.removeChild(x), x = void 0);
}
function de(n) {
  return Array.prototype.indexOf.call(n.parentElement.childNodes, n);
}
function jr(n) {
  let t = n;
  for (; t && t.nodeName !== "TD" && t.nodeName !== "TH" && !t.classList.contains("tableWrapper"); ) {
    if (t.classList.contains("ProseMirror"))
      return;
    const e = t.parentNode;
    if (!e || !(e instanceof Element))
      return;
    t = e;
  }
  return t.nodeName === "TD" || t.nodeName === "TH" ? {
    type: "cell",
    domNode: t,
    tbodyNode: t.closest("tbody")
  } : {
    type: "wrapper",
    domNode: t,
    tbodyNode: t.querySelector("tbody")
  };
}
function Kr(n, t) {
  const e = t.querySelectorAll(n);
  for (let o = 0; o < e.length; o++)
    e[o].style.visibility = "hidden";
}
class qr {
  constructor(t, e, o) {
    d(this, "state");
    d(this, "emitUpdate");
    d(this, "tableId");
    d(this, "tablePos");
    d(this, "tableElement");
    d(this, "menuFrozen", !1);
    d(this, "mouseState", "up");
    d(this, "prevWasEditable", null);
    d(this, "viewMousedownHandler", () => {
      this.mouseState = "down";
    });
    d(this, "mouseUpHandler", (t) => {
      this.mouseState = "up", this.mouseMoveHandler(t);
    });
    d(this, "mouseMoveHandler", (t) => {
      var l, h, u, f, m, g, p;
      if (this.menuFrozen || this.mouseState === "selecting" || !(t.target instanceof Element) || !this.pmView.dom.contains(t.target))
        return;
      const e = jr(t.target);
      if ((e == null ? void 0 : e.type) === "cell" && this.mouseState === "down" && !((l = this.state) != null && l.draggingState)) {
        this.mouseState = "selecting", (h = this.state) != null && h.show && (this.state.show = !1, this.state.showAddOrRemoveRowsButton = !1, this.state.showAddOrRemoveColumnsButton = !1, this.emitUpdate());
        return;
      }
      if (!e || !this.editor.isEditable) {
        (u = this.state) != null && u.show && (this.state.show = !1, this.state.showAddOrRemoveRowsButton = !1, this.state.showAddOrRemoveColumnsButton = !1, this.emitUpdate());
        return;
      }
      if (!e.tbodyNode)
        return;
      const o = e.tbodyNode.getBoundingClientRect(), r = Ht(e.domNode, this.pmView);
      if (!r)
        return;
      this.tableElement = r.node;
      let s;
      const i = this.editor.transact(
        (k) => _(r.id, k.doc)
      );
      if (!i)
        throw new Error(`Block with ID ${r.id} not found`);
      const c = E(
        i.node,
        this.editor.pmSchema,
        this.editor.schema.blockSchema,
        this.editor.schema.inlineContentSchema,
        this.editor.schema.styleSchema
      );
      if (wt(this.editor, "table") && (this.tablePos = i.posBeforeNode + 1, s = c), !s)
        return;
      this.tableId = r.id;
      const a = (f = e.domNode.closest(".tableWrapper")) == null ? void 0 : f.querySelector(".table-widgets-container");
      if ((e == null ? void 0 : e.type) === "wrapper") {
        const k = t.clientY >= o.bottom - 1 && // -1 to account for fractions of pixels in "bottom"
        t.clientY < o.bottom + 20, b = t.clientX >= o.right - 1 && t.clientX < o.right + 20, w = t.clientX > o.right || t.clientY > o.bottom;
        this.state = {
          ...this.state,
          show: !0,
          showAddOrRemoveRowsButton: k,
          showAddOrRemoveColumnsButton: b,
          referencePosTable: o,
          block: s,
          widgetContainer: a,
          colIndex: w || (m = this.state) == null ? void 0 : m.colIndex,
          rowIndex: w || (g = this.state) == null ? void 0 : g.rowIndex,
          referencePosCell: w || (p = this.state) == null ? void 0 : p.referencePosCell
        };
      } else {
        const k = de(e.domNode), b = de(e.domNode.parentElement), w = e.domNode.getBoundingClientRect();
        if (this.state !== void 0 && this.state.show && this.tableId === r.id && this.state.rowIndex === b && this.state.colIndex === k)
          return;
        this.state = {
          show: !0,
          showAddOrRemoveColumnsButton: k === s.content.rows[0].cells.length - 1,
          showAddOrRemoveRowsButton: b === s.content.rows.length - 1,
          referencePosTable: o,
          block: s,
          draggingState: void 0,
          referencePosCell: w,
          colIndex: k,
          rowIndex: b,
          widgetContainer: a
        };
      }
      return this.emitUpdate(), !1;
    });
    d(this, "dragOverHandler", (t) => {
      var f;
      if (((f = this.state) == null ? void 0 : f.draggingState) === void 0)
        return;
      t.preventDefault(), t.dataTransfer.dropEffect = "move", Kr(
        ".prosemirror-dropcursor-block, .prosemirror-dropcursor-inline",
        this.pmView.root
      );
      const e = {
        left: Math.min(
          Math.max(t.clientX, this.state.referencePosTable.left + 1),
          this.state.referencePosTable.right - 1
        ),
        top: Math.min(
          Math.max(t.clientY, this.state.referencePosTable.top + 1),
          this.state.referencePosTable.bottom - 1
        )
      }, o = this.pmView.root.elementsFromPoint(e.left, e.top).filter(
        (m) => m.tagName === "TD" || m.tagName === "TH"
      );
      if (o.length === 0)
        return;
      const r = o[0];
      let s = !1;
      const i = de(r.parentElement), c = de(r), a = this.state.draggingState.draggedCellOrientation === "row" ? this.state.rowIndex : this.state.colIndex, h = (this.state.draggingState.draggedCellOrientation === "row" ? i : c) !== a;
      (this.state.rowIndex !== i || this.state.colIndex !== c) && (this.state.rowIndex = i, this.state.colIndex = c, this.state.referencePosCell = r.getBoundingClientRect(), s = !0);
      const u = this.state.draggingState.draggedCellOrientation === "row" ? e.top : e.left;
      this.state.draggingState.mousePos !== u && (this.state.draggingState.mousePos = u, s = !0), s && this.emitUpdate(), h && this.editor.transact((m) => m.setMeta(oe, !0));
    });
    d(this, "dropHandler", (t) => {
      if (this.mouseState = "up", this.state === void 0 || this.state.draggingState === void 0)
        return !1;
      if (this.state.rowIndex === void 0 || this.state.colIndex === void 0)
        throw new Error(
          "Attempted to drop table row or column, but no table block was hovered prior."
        );
      t.preventDefault();
      const { draggingState: e, colIndex: o, rowIndex: r } = this.state, s = this.state.block.content.columnWidths;
      if (e.draggedCellOrientation === "row") {
        if (!mt(
          this.state.block,
          e.originalIndex,
          r
        ))
          return !1;
        const i = no(
          this.state.block,
          e.originalIndex,
          r
        );
        this.editor.updateBlock(this.state.block, {
          type: "table",
          content: {
            ...this.state.block.content,
            rows: i
          }
        });
      } else {
        if (!ft(
          this.state.block,
          e.originalIndex,
          o
        ))
          return !1;
        const i = ro(
          this.state.block,
          e.originalIndex,
          o
        ), [c] = s.splice(e.originalIndex, 1);
        s.splice(o, 0, c), this.editor.updateBlock(this.state.block, {
          type: "table",
          content: {
            ...this.state.block.content,
            columnWidths: s,
            rows: i
          }
        });
      }
      return this.editor.setTextCursorPosition(this.state.block.id), !0;
    });
    this.editor = t, this.pmView = e, this.emitUpdate = () => {
      if (!this.state)
        throw new Error("Attempting to update uninitialized image toolbar");
      o(this.state);
    }, e.dom.addEventListener("mousemove", this.mouseMoveHandler), e.dom.addEventListener("mousedown", this.viewMousedownHandler), window.addEventListener("mouseup", this.mouseUpHandler), e.root.addEventListener(
      "dragover",
      this.dragOverHandler
    ), e.root.addEventListener(
      "drop",
      this.dropHandler
    );
  }
  // Updates drag handles when the table is modified or removed.
  update() {
    var r;
    if (!this.state || !this.state.show)
      return;
    if (this.state.block = this.editor.getBlock(this.state.block.id), !this.state.block || this.state.block.type !== "table" || // when collaborating, the table element might be replaced and out of date
    // because yjs replaces the element when for example you change the color via the side menu
    !((r = this.tableElement) != null && r.isConnected)) {
      this.state.show = !1, this.state.showAddOrRemoveRowsButton = !1, this.state.showAddOrRemoveColumnsButton = !1, this.emitUpdate();
      return;
    }
    const { height: t, width: e } = so(
      this.state.block
    );
    this.state.rowIndex !== void 0 && this.state.colIndex !== void 0 && (this.state.rowIndex >= t && (this.state.rowIndex = t - 1), this.state.colIndex >= e && (this.state.colIndex = e - 1));
    const o = this.tableElement.querySelector("tbody");
    if (!o)
      throw new Error(
        "Table block does not contain a 'tbody' HTML element. This should never happen."
      );
    if (this.state.rowIndex !== void 0 && this.state.colIndex !== void 0) {
      const i = o.children[this.state.rowIndex].children[this.state.colIndex];
      i ? this.state.referencePosCell = i.getBoundingClientRect() : (this.state.rowIndex = void 0, this.state.colIndex = void 0);
    }
    this.state.referencePosTable = o.getBoundingClientRect(), this.emitUpdate();
  }
  destroy() {
    this.pmView.dom.removeEventListener("mousemove", this.mouseMoveHandler), window.removeEventListener("mouseup", this.mouseUpHandler), this.pmView.dom.removeEventListener("mousedown", this.viewMousedownHandler), this.pmView.root.removeEventListener(
      "dragover",
      this.dragOverHandler
    ), this.pmView.root.removeEventListener(
      "drop",
      this.dropHandler
    );
  }
}
const oe = new A("TableHandlesPlugin");
class Yr extends S {
  constructor(e) {
    super();
    d(this, "view");
    /**
     * Callback that should be set on the `dragStart` event for whichever element
     * is used as the column drag handle.
     */
    d(this, "colDragStart", (e) => {
      if (this.view.state === void 0 || this.view.state.colIndex === void 0)
        throw new Error(
          "Attempted to drag table column, but no table block was hovered prior."
        );
      this.view.state.draggingState = {
        draggedCellOrientation: "col",
        originalIndex: this.view.state.colIndex,
        mousePos: e.clientX
      }, this.view.emitUpdate(), this.editor.transact(
        (o) => o.setMeta(oe, {
          draggedCellOrientation: this.view.state.draggingState.draggedCellOrientation,
          originalIndex: this.view.state.colIndex,
          newIndex: this.view.state.colIndex,
          tablePos: this.view.tablePos
        })
      ), !this.editor.headless && (lt(this.editor.prosemirrorView.root), e.dataTransfer.setDragImage(x, 0, 0), e.dataTransfer.effectAllowed = "move");
    });
    /**
     * Callback that should be set on the `dragStart` event for whichever element
     * is used as the row drag handle.
     */
    d(this, "rowDragStart", (e) => {
      if (this.view.state === void 0 || this.view.state.rowIndex === void 0)
        throw new Error(
          "Attempted to drag table row, but no table block was hovered prior."
        );
      this.view.state.draggingState = {
        draggedCellOrientation: "row",
        originalIndex: this.view.state.rowIndex,
        mousePos: e.clientY
      }, this.view.emitUpdate(), this.editor.transact(
        (o) => o.setMeta(oe, {
          draggedCellOrientation: this.view.state.draggingState.draggedCellOrientation,
          originalIndex: this.view.state.rowIndex,
          newIndex: this.view.state.rowIndex,
          tablePos: this.view.tablePos
        })
      ), !this.editor.headless && (lt(this.editor.prosemirrorView.root), e.dataTransfer.setDragImage(x, 0, 0), e.dataTransfer.effectAllowed = "copyMove");
    });
    /**
     * Callback that should be set on the `dragEnd` event for both the element
     * used as the row drag handle, and the one used as the column drag handle.
     */
    d(this, "dragEnd", () => {
      if (this.view.state === void 0)
        throw new Error(
          "Attempted to drag table row, but no table block was hovered prior."
        );
      this.view.state.draggingState = void 0, this.view.emitUpdate(), this.editor.transact((e) => e.setMeta(oe, null)), !this.editor.headless && Gr(this.editor.prosemirrorView.root);
    });
    /**
     * Freezes the drag handles. When frozen, they will stay attached to the same
     * cell regardless of which cell is hovered by the mouse cursor.
     */
    d(this, "freezeHandles", () => {
      this.view.menuFrozen = !0;
    });
    /**
     * Unfreezes the drag handles. When frozen, they will stay attached to the
     * same cell regardless of which cell is hovered by the mouse cursor.
     */
    d(this, "unfreezeHandles", () => {
      this.view.menuFrozen = !1;
    });
    d(this, "getCellsAtRowHandle", (e, o) => Ke(e, o));
    /**
     * Get all the cells in a column of the table block.
     */
    d(this, "getCellsAtColumnHandle", (e, o) => qe(e, o));
    /**
     * Sets the selection to the given cell or a range of cells.
     * @returns The new state after the selection has been set.
     */
    d(this, "setCellSelection", (e, o, r = o) => {
      const s = this.view;
      if (!s)
        throw new Error("Table handles view not initialized");
      const i = e.doc.resolve(s.tablePos + 1), c = e.doc.resolve(
        i.posAtIndex(o.row) + 1
      ), a = e.doc.resolve(
        // No need for +1, since CellSelection expects the position before the cell
        c.posAtIndex(o.col)
      ), l = e.doc.resolve(
        i.posAtIndex(r.row) + 1
      ), h = e.doc.resolve(
        // No need for +1, since CellSelection expects the position before the cell
        l.posAtIndex(r.col)
      ), u = e.tr;
      return u.setSelection(
        new ye(a, h)
      ), e.apply(u);
    });
    /**
     * Adds a row or column to the table using prosemirror-table commands
     */
    d(this, "addRowOrColumn", (e, o) => {
      this.editor.exec((r, s) => {
        const i = this.setCellSelection(
          r,
          o.orientation === "row" ? { row: e, col: 0 } : { row: 0, col: e }
        );
        return o.orientation === "row" ? o.side === "above" ? Uo(i, s) : Ro(i, s) : o.side === "left" ? Vo(i, s) : $o(i, s);
      });
    });
    /**
     * Removes a row or column from the table using prosemirror-table commands
     */
    d(this, "removeRowOrColumn", (e, o) => o === "row" ? this.editor.exec((r, s) => {
      const i = this.setCellSelection(r, {
        row: e,
        col: 0
      });
      return Fo(i, s);
    }) : this.editor.exec((r, s) => {
      const i = this.setCellSelection(r, {
        row: 0,
        col: e
      });
      return zo(i, s);
    }));
    /**
     * Merges the cells in the table block.
     */
    d(this, "mergeCells", (e) => this.editor.exec((o, r) => {
      const s = e ? this.setCellSelection(
        o,
        e.relativeStartCell,
        e.relativeEndCell
      ) : o;
      return Go(s, r);
    }));
    /**
     * Splits the cell in the table block.
     * If no cell is provided, the current cell selected will be split.
     */
    d(this, "splitCell", (e) => this.editor.exec((o, r) => {
      const s = e ? this.setCellSelection(o, e) : o;
      return jo(s, r);
    }));
    /**
     * Gets the start and end cells of the current cell selection.
     * @returns The start and end cells of the current cell selection.
     */
    d(this, "getCellSelection", () => this.editor.transact((e) => {
      const o = e.selection;
      let r = o.$from, s = o.$to;
      if (We(o)) {
        const { ranges: g } = o;
        g.forEach((p) => {
          r = p.$from.min(r ?? p.$from), s = p.$to.max(s ?? p.$to);
        });
      } else if (r = e.doc.resolve(
        o.$from.pos - o.$from.parentOffset - 1
      ), s = e.doc.resolve(
        o.$to.pos - o.$to.parentOffset - 1
      ), r.pos === 0 || s.pos === 0)
        return;
      const i = e.doc.resolve(
        r.pos - r.parentOffset - 1
      ), c = e.doc.resolve(s.pos - s.parentOffset - 1), a = e.doc.resolve(i.pos - i.parentOffset - 1), l = r.index(i.depth), h = i.index(a.depth), u = s.index(c.depth), f = c.index(a.depth), m = [];
      for (let g = h; g <= f; g++)
        for (let p = l; p <= u; p++)
          m.push({ row: g, col: p });
      return {
        from: {
          row: h,
          col: l
        },
        to: {
          row: f,
          col: u
        },
        cells: m
      };
    }));
    /**
     * Gets the direction of the merge based on the current cell selection.
     *
     * Returns undefined when there is no cell selection, or the selection is not within a table.
     */
    d(this, "getMergeDirection", (e) => this.editor.transact((o) => {
      const r = We(o.selection) ? o.selection : void 0;
      if (!r || !e || // Only offer the merge button if there is more than one cell selected.
      r.ranges.length <= 1)
        return;
      const s = this.getCellSelection();
      if (s)
        return io(s.from, s.to, e) ? "vertical" : "horizontal";
    }));
    d(this, "cropEmptyRowsOrColumns", (e, o) => ao(e, o));
    d(this, "addRowsOrColumns", (e, o, r) => co(e, o, r));
    this.editor = e, this.addProsemirrorPlugin(
      new B({
        key: oe,
        view: (o) => (this.view = new qr(e, o, (r) => {
          this.emit("update", r);
        }), this.view),
        // We use decorations to render the drop cursor when dragging a table row
        // or column. The decorations are updated in the `dragOverHandler` method.
        props: {
          decorations: (o) => {
            if (this.view === void 0 || this.view.state === void 0 || this.view.state.draggingState === void 0 || this.view.tablePos === void 0)
              return;
            const r = this.view.state.draggingState.draggedCellOrientation === "row" ? this.view.state.rowIndex : this.view.state.colIndex;
            if (r === void 0)
              return;
            const s = [], { block: i, draggingState: c } = this.view.state, { originalIndex: a, draggedCellOrientation: l } = c;
            if (r === a || !i || l === "row" && !mt(i, a, r) || l === "col" && !ft(i, a, r))
              return U.create(o.doc, s);
            const h = o.doc.resolve(this.view.tablePos + 1);
            return this.view.state.draggingState.draggedCellOrientation === "row" ? Ke(
              this.view.state.block,
              r
            ).forEach(({ row: f, col: m }) => {
              const g = o.doc.resolve(
                h.posAtIndex(f) + 1
              ), p = o.doc.resolve(
                g.posAtIndex(m) + 1
              ), k = p.node(), b = p.pos + (r > a ? k.nodeSize - 2 : 0);
              s.push(
                // The widget is a small bar which spans the width of the cell.
                $.widget(b, () => {
                  const w = document.createElement("div");
                  return w.className = "bn-table-drop-cursor", w.style.left = "0", w.style.right = "0", r > a ? w.style.bottom = "-2px" : w.style.top = "-3px", w.style.height = "4px", w;
                })
              );
            }) : qe(
              this.view.state.block,
              r
            ).forEach(({ row: f, col: m }) => {
              const g = o.doc.resolve(
                h.posAtIndex(f) + 1
              ), p = o.doc.resolve(
                g.posAtIndex(m) + 1
              ), k = p.node(), b = p.pos + (r > a ? k.nodeSize - 2 : 0);
              s.push(
                // The widget is a small bar which spans the height of the cell.
                $.widget(b, () => {
                  const w = document.createElement("div");
                  return w.className = "bn-table-drop-cursor", w.style.top = "0", w.style.bottom = "0", r > a ? w.style.right = "-2px" : w.style.left = "-3px", w.style.width = "4px", w;
                })
              );
            }), U.create(o.doc, s);
          }
        }
      })
    );
  }
  static key() {
    return "tableHandles";
  }
  onUpdate(e) {
    return this.on("update", e);
  }
}
const Wr = N.create({
  name: "textAlignment",
  addGlobalAttributes() {
    return [
      {
        // Generally text alignment is handled through props using the custom
        // blocks API. Tables are the only blocks that are created as TipTap
        // nodes and ported to blocks, so we need to add text alignment in a
        // separate extension.
        types: ["tableCell", "tableHeader"],
        attributes: {
          textAlignment: {
            default: "left",
            parseHTML: (n) => n.getAttribute("data-text-alignment"),
            renderHTML: (n) => n.textAlignment === "left" ? {} : {
              "data-text-alignment": n.textAlignment
            }
          }
        }
      }
    ];
  }
}), Xr = N.create({
  name: "blockTextColor",
  addGlobalAttributes() {
    return [
      {
        types: ["table", "tableCell", "tableHeader"],
        attributes: {
          textColor: bo()
        }
      }
    ];
  }
}), Jr = N.create({
  name: "trailingNode",
  addProseMirrorPlugins() {
    const n = new A(this.name);
    return [
      new B({
        key: n,
        appendTransaction: (t, e, o) => {
          const { doc: r, tr: s, schema: i } = o, c = n.getState(o), a = r.content.size - 2, l = i.nodes.blockContainer, h = i.nodes.paragraph;
          if (c)
            return s.insert(
              a,
              l.create(void 0, h.create())
            );
        },
        state: {
          init: (t, e) => {
          },
          apply: (t, e) => {
            if (!t.docChanged)
              return e;
            let o = t.doc.lastChild;
            if (!o || o.type.name !== "blockGroup")
              throw new Error("Expected blockGroup");
            if (o = o.lastChild, !o || o.type.name !== "blockContainer")
              return !0;
            const r = o.firstChild;
            if (!r)
              throw new Error("Expected blockContent");
            return o.nodeSize > 4 || r.type.spec.content !== "inline*";
          }
        }
      })
    ];
  }
}), Qr = {
  blockColor: "data-block-color",
  blockStyle: "data-block-style",
  id: "data-id",
  depth: "data-depth",
  depthChange: "data-depth-change"
}, Zr = W.create({
  name: "blockContainer",
  group: "blockGroupChild bnBlock",
  // A block always contains content, and optionally a blockGroup which contains nested blocks
  content: "blockContent blockGroup?",
  // Ensures content-specific keyboard handlers trigger first.
  priority: 50,
  defining: !0,
  marks: "insertion modification deletion",
  parseHTML() {
    return [
      {
        tag: "div[data-node-type=" + this.name + "]",
        getAttrs: (n) => {
          if (typeof n == "string")
            return !1;
          const t = {};
          for (const [e, o] of Object.entries(Qr))
            n.getAttribute(o) && (t[e] = n.getAttribute(o));
          return t;
        }
      },
      // Ignore `blockOuter` divs, but parse the `blockContainer` divs inside them.
      {
        tag: 'div[data-node-type="blockOuter"]',
        skip: !0
      }
    ];
  },
  renderHTML({ HTMLAttributes: n }) {
    var r;
    const t = document.createElement("div");
    t.className = "bn-block-outer", t.setAttribute("data-node-type", "blockOuter");
    for (const [s, i] of Object.entries(n))
      s !== "class" && t.setAttribute(s, i);
    const e = {
      ...((r = this.options.domAttributes) == null ? void 0 : r.block) || {},
      ...n
    }, o = document.createElement("div");
    o.className = He("bn-block", e.class), o.setAttribute("data-node-type", this.name);
    for (const [s, i] of Object.entries(e))
      s !== "class" && o.setAttribute(s, i);
    return t.appendChild(o), {
      dom: t,
      contentDOM: o
    };
  }
}), es = W.create({
  name: "blockGroup",
  group: "childContainer",
  content: "blockGroupChild+",
  marks: "deletion insertion modification",
  parseHTML() {
    return [
      {
        tag: "div",
        getAttrs: (n) => typeof n == "string" ? !1 : n.getAttribute("data-node-type") === "blockGroup" ? null : !1
      }
    ];
  },
  renderHTML({ HTMLAttributes: n }) {
    var o;
    const t = {
      ...((o = this.options.domAttributes) == null ? void 0 : o.blockGroup) || {},
      ...n
    }, e = document.createElement("div");
    e.className = He(
      "bn-block-group",
      t.class
    ), e.setAttribute("data-node-type", "blockGroup");
    for (const [r, s] of Object.entries(t))
      r !== "class" && e.setAttribute(r, s);
    return {
      dom: e,
      contentDOM: e
    };
  }
}), ts = W.create({
  name: "doc",
  topNode: !0,
  content: "blockGroup",
  marks: "insertion modification deletion"
}), os = (n) => {
  var r;
  const t = {}, e = ns(n);
  for (const s of e)
    t[s.name] = s;
  n.collaboration && (t.ySyncPlugin = new fe(n.collaboration.fragment), t.yUndoPlugin = new ge({ editor: n.editor }), (r = n.collaboration.provider) != null && r.awareness && (t.yCursorPlugin = new se(n.collaboration)), t.forkYDocPlugin = new At({
    editor: n.editor,
    collaboration: n.collaboration
  }), t.schemaMigrationPlugin = new Ve(
    n.collaboration.fragment
  )), t.formattingToolbar = new lr(
    n.editor
  ), t.linkToolbar = new yr(n.editor), t.sideMenu = new _r(n.editor), t.suggestionMenus = new Vr(n.editor), t.filePanel = new ir(n.editor), t.placeholder = new Mr(n.editor, n.placeholders), (n.animations ?? !0) && (t.animations = new Tr()), n.tableHandles && (t.tableHandles = new Yr(n.editor)), t.nodeSelectionKeyboard = new Er(), t.blockChange = new Zn(), t.showSelection = new xr(n.editor), n.comments && (t.comments = new Ot(
    n.editor,
    n.comments.threadStore,
    ke.name,
    n.comments.resolveUsers,
    n.comments.schema
  ));
  const o = n.disableExtensions || [];
  for (const s of o)
    delete t[s];
  return t;
};
let dt = !1;
const ns = (n) => {
  const t = [
    te.ClipboardTextSerializer,
    te.Commands,
    te.Editable,
    te.FocusEvents,
    te.Tabindex,
    // DevTools,
    Oo,
    // DropCursor,
    N.create({
      name: "dropCursor",
      addProseMirrorPlugins: () => [
        n.dropCursor({
          width: 5,
          color: "#ddeeff",
          editor: n.editor
        })
      ]
    }),
    gt.configure({
      // everything from bnBlock group (nodes that represent a BlockNote block should have an id)
      types: ["blockContainer", "columnList", "column"],
      setIdAttribute: n.setIdAttribute
    }),
    dr,
    // Comments,
    // basics:
    Ho,
    // marks:
    $r,
    Fr,
    zr,
    No.extend({
      inclusive: !1
    }).configure({
      defaultProtocol: vr,
      // only call this once if we have multiple editors installed. Or fix https://github.com/ueberdosis/tiptap/issues/5450
      protocols: dt ? [] : Cr
    }),
    ...Object.values(n.styleSpecs).map((e) => e.implementation.mark.configure({
      editor: n.editor
    })),
    Xr,
    Qn,
    Wr,
    // make sure escape blurs editor, so that we can tab to other elements in the host page (accessibility)
    N.create({
      name: "OverrideEscape",
      addKeyboardShortcuts() {
        return {
          Escape: () => n.editor.suggestionMenus.shown ? !1 : this.editor.commands.blur()
        };
      }
    }),
    // nodes
    ts,
    Zr.configure({
      editor: n.editor,
      domAttributes: n.domAttributes
    }),
    kr.configure({
      editor: n.editor,
      tabBehavior: n.tabBehavior
    }),
    es.configure({
      domAttributes: n.domAttributes
    }),
    ...Object.values(n.inlineContentSpecs).filter((e) => e.config !== "link" && e.config !== "text").map((e) => e.implementation.node.configure({
      editor: n.editor
    })),
    ...Object.values(n.blockSpecs).flatMap((e) => [
      // the node extension implementations
      ..."node" in e.implementation ? [
        e.implementation.node.configure({
          editor: n.editor,
          domAttributes: n.domAttributes
        })
      ] : []
    ]),
    Jn(n.editor),
    jn(
      n.editor,
      n.pasteHandler || ((e) => e.defaultPasteHandler())
    ),
    Tn(n.editor),
    // This needs to be at the bottom of this list, because Key events (such as enter, when selecting a /command),
    // should be handled before Enter handlers in other components like splitListItem
    ...n.trailingBlock === void 0 || n.trailingBlock ? [Jr] : [],
    ...n.comments ? [ke] : []
  ];
  return dt = !0, n.collaboration || t.push(_o), t;
};
function rs(n) {
  return n.transact((t) => {
    const e = re(t.doc, t.selection.anchor);
    if (t.selection instanceof ye)
      return {
        type: "cell",
        anchorBlockId: e.node.attrs.id,
        anchorCellOffset: t.selection.$anchorCell.pos - e.posBeforeNode,
        headCellOffset: t.selection.$headCell.pos - e.posBeforeNode
      };
    if (t.selection instanceof X)
      return {
        type: "node",
        anchorBlockId: e.node.attrs.id
      };
    {
      const o = re(t.doc, t.selection.head);
      return {
        type: "text",
        anchorBlockId: e.node.attrs.id,
        headBlockId: o.node.attrs.id,
        anchorOffset: t.selection.anchor - e.posBeforeNode,
        headOffset: t.selection.head - o.posBeforeNode
      };
    }
  });
}
function ss(n, t) {
  var r, s;
  const e = (r = _(t.anchorBlockId, n.doc)) == null ? void 0 : r.posBeforeNode;
  if (e === void 0)
    throw new Error(
      `Could not find block with ID ${t.anchorBlockId} to update selection`
    );
  let o;
  if (t.type === "cell")
    o = ye.create(
      n.doc,
      e + t.anchorCellOffset,
      e + t.headCellOffset
    );
  else if (t.type === "node")
    o = X.create(n.doc, e + 1);
  else {
    const i = (s = _(t.headBlockId, n.doc)) == null ? void 0 : s.posBeforeNode;
    if (i === void 0)
      throw new Error(
        `Could not find block with ID ${t.headBlockId} to update selection`
      );
    o = I.create(
      n.doc,
      e + t.anchorOffset,
      i + t.headOffset
    );
  }
  n.setSelection(o);
}
function De(n) {
  return n.map((t) => t.type === "columnList" ? t.children.map((e) => De(e.children)).flat() : {
    ...t,
    children: De(t.children)
  }).flat();
}
function Rt(n, t, e) {
  n.transact((o) => {
    var i;
    const r = ((i = n.getSelection()) == null ? void 0 : i.blocks) || [
      n.getTextCursorPosition().block
    ], s = rs(n);
    n.removeBlocks(r), n.insertBlocks(De(r), t, e), ss(o, s);
  });
}
function Vt(n) {
  return !n || n.type !== "columnList";
}
function $t(n, t, e) {
  let o, r;
  if (t ? t.children.length > 0 ? (o = t.children[t.children.length - 1], r = "after") : (o = t, r = "before") : e && (o = e, r = "before"), !o || !r)
    return;
  const s = n.getParentBlock(o);
  return Vt(s) ? { referenceBlock: o, placement: r } : $t(
    n,
    r === "after" ? o : n.getPrevBlock(o),
    s
  );
}
function Ft(n, t, e) {
  let o, r;
  if (t ? t.children.length > 0 ? (o = t.children[0], r = "before") : (o = t, r = "after") : e && (o = e, r = "after"), !o || !r)
    return;
  const s = n.getParentBlock(o);
  return Vt(s) ? { referenceBlock: o, placement: r } : Ft(
    n,
    r === "before" ? o : n.getNextBlock(o),
    s
  );
}
function is(n) {
  n.transact(() => {
    const t = n.getSelection(), e = (t == null ? void 0 : t.blocks[0]) || n.getTextCursorPosition().block, o = $t(
      n,
      n.getPrevBlock(e),
      n.getParentBlock(e)
    );
    o && Rt(
      n,
      o.referenceBlock,
      o.placement
    );
  });
}
function as(n) {
  n.transact(() => {
    const t = n.getSelection(), e = (t == null ? void 0 : t.blocks[(t == null ? void 0 : t.blocks.length) - 1]) || n.getTextCursorPosition().block, o = Ft(
      n,
      n.getNextBlock(e),
      n.getParentBlock(e)
    );
    o && Rt(
      n,
      o.referenceBlock,
      o.placement
    );
  });
}
function cs(n, t) {
  const e = typeof t == "string" ? t : t.id, o = L(n), r = _(e, n);
  if (r)
    return E(r.node, o);
}
function ls(n, t) {
  const e = typeof t == "string" ? t : t.id, o = _(e, n), r = L(n);
  if (!o)
    return;
  const i = n.resolve(o.posBeforeNode).nodeBefore;
  if (i)
    return E(i, r);
}
function ds(n, t) {
  const e = typeof t == "string" ? t : t.id, o = _(e, n), r = L(n);
  if (!o)
    return;
  const i = n.resolve(
    o.posBeforeNode + o.node.nodeSize
  ).nodeAfter;
  if (i)
    return E(i, r);
}
function hs(n, t) {
  const e = typeof t == "string" ? t : t.id, o = L(n), r = _(e, n);
  if (!r)
    return;
  const s = n.resolve(r.posBeforeNode), i = s.node(), c = s.node(-1), a = c.type.name !== "doc" ? i.type.name === "blockGroup" ? c : i : void 0;
  if (a)
    return E(a, o);
}
class us {
  constructor(t) {
    this.editor = t;
  }
  /**
   * Gets a snapshot of all top-level (non-nested) blocks in the editor.
   * @returns A snapshot of all top-level (non-nested) blocks in the editor.
   */
  get document() {
    return this.editor.transact((t) => lo(t.doc, this.editor.pmSchema));
  }
  /**
   * Gets a snapshot of an existing block from the editor.
   * @param blockIdentifier The identifier of an existing block that should be
   * retrieved.
   * @returns The block that matches the identifier, or `undefined` if no
   * matching block was found.
   */
  getBlock(t) {
    return this.editor.transact((e) => cs(e.doc, t));
  }
  /**
   * Gets a snapshot of the previous sibling of an existing block from the
   * editor.
   * @param blockIdentifier The identifier of an existing block for which the
   * previous sibling should be retrieved.
   * @returns The previous sibling of the block that matches the identifier.
   * `undefined` if no matching block was found, or it's the first child/block
   * in the document.
   */
  getPrevBlock(t) {
    return this.editor.transact((e) => ls(e.doc, t));
  }
  /**
   * Gets a snapshot of the next sibling of an existing block from the editor.
   * @param blockIdentifier The identifier of an existing block for which the
   * next sibling should be retrieved.
   * @returns The next sibling of the block that matches the identifier.
   * `undefined` if no matching block was found, or it's the last child/block in
   * the document.
   */
  getNextBlock(t) {
    return this.editor.transact((e) => ds(e.doc, t));
  }
  /**
   * Gets a snapshot of the parent of an existing block from the editor.
   * @param blockIdentifier The identifier of an existing block for which the
   * parent should be retrieved.
   * @returns The parent of the block that matches the identifier. `undefined`
   * if no matching block was found, or the block isn't nested.
   */
  getParentBlock(t) {
    return this.editor.transact(
      (e) => hs(e.doc, t)
    );
  }
  /**
   * Traverses all blocks in the editor depth-first, and executes a callback for each.
   * @param callback The callback to execute for each block. Returning `false` stops the traversal.
   * @param reverse Whether the blocks should be traversed in reverse order.
   */
  forEachBlock(t, e = !1) {
    const o = this.document.slice();
    e && o.reverse();
    function r(s) {
      for (const i of s) {
        if (t(i) === !1)
          return !1;
        const c = e ? i.children.slice().reverse() : i.children;
        if (!r(c))
          return !1;
      }
      return !0;
    }
    r(o);
  }
  /**
   * Inserts new blocks into the editor. If a block's `id` is undefined, BlockNote generates one automatically. Throws an
   * error if the reference block could not be found.
   * @param blocksToInsert An array of partial blocks that should be inserted.
   * @param referenceBlock An identifier for an existing block, at which the new blocks should be inserted.
   * @param placement Whether the blocks should be inserted just before, just after, or nested inside the
   * `referenceBlock`.
   */
  insertBlocks(t, e, o = "before") {
    return this.editor.transact(
      (r) => gn(r, t, e, o)
    );
  }
  /**
   * Updates an existing block in the editor. Since updatedBlock is a PartialBlock object, some fields might not be
   * defined. These undefined fields are kept as-is from the existing block. Throws an error if the block to update could
   * not be found.
   * @param blockToUpdate The block that should be updated.
   * @param update A partial block which defines how the existing block should be changed.
   */
  updateBlock(t, e) {
    return this.editor.transact((o) => wo(o, t, e));
  }
  /**
   * Removes existing blocks from the editor. Throws an error if any of the blocks could not be found.
   * @param blocksToRemove An array of identifiers for existing blocks that should be removed.
   */
  removeBlocks(t) {
    return this.editor.transact(
      (e) => Ze(e, t, []).removedBlocks
    );
  }
  /**
   * Replaces existing blocks in the editor with new blocks. If the blocks that should be removed are not adjacent or
   * are at different nesting levels, `blocksToInsert` will be inserted at the position of the first block in
   * `blocksToRemove`. Throws an error if any of the blocks to remove could not be found.
   * @param blocksToRemove An array of blocks that should be replaced.
   * @param blocksToInsert An array of partial blocks to replace the old ones with.
   */
  replaceBlocks(t, e) {
    return this.editor.transact(
      (o) => Ze(o, t, e)
    );
  }
  /**
   * Checks if the block containing the text cursor can be nested.
   */
  canNestBlock() {
    return fr(this.editor);
  }
  /**
   * Nests the block containing the text cursor into the block above it.
   */
  nestBlock() {
    Nt(this.editor);
  }
  /**
   * Checks if the block containing the text cursor is nested.
   */
  canUnnestBlock() {
    return gr(this.editor);
  }
  /**
   * Lifts the block containing the text cursor out of its parent.
   */
  unnestBlock() {
    mr(this.editor);
  }
  /**
   * Moves the selected blocks up. If the previous block has children, moves
   * them to the end of its children. If there is no previous block, but the
   * current blocks share a common parent, moves them out of & before it.
   */
  moveBlocksUp() {
    return is(this.editor);
  }
  /**
   * Moves the selected blocks down. If the next block has children, moves
   * them to the start of its children. If there is no next block, but the
   * current blocks share a common parent, moves them out of & after it.
   */
  moveBlocksDown() {
    return as(this.editor);
  }
}
class ps {
  constructor(t, e) {
    d(this, "editor");
    d(this, "options");
    d(this, "_commentsPlugin");
    d(this, "_forkYDocPlugin");
    d(this, "_syncPlugin");
    d(this, "_undoPlugin");
    d(this, "_cursorPlugin");
    this.editor = t, this.options = e;
  }
  /**
   * Get the sync plugin instance
   */
  get syncPlugin() {
    return this._syncPlugin;
  }
  /**
   * Get the undo plugin instance
   */
  get undoPlugin() {
    return this._undoPlugin;
  }
  /**
   * Get the cursor plugin instance
   */
  get cursorPlugin() {
    return this._cursorPlugin;
  }
  /**
   * Get the fork YDoc plugin instance
   */
  get forkYDocPlugin() {
    return this._forkYDocPlugin;
  }
  // Initialize collaboration plugins
  initExtensions() {
    var e;
    const t = {};
    if (this._syncPlugin = new fe(this.options.fragment), t.ySyncPlugin = this._syncPlugin, this._undoPlugin = new ge({ editor: this.editor }), t.yUndoPlugin = this._undoPlugin, (e = this.options.provider) != null && e.awareness && (this._cursorPlugin = new se(this.options), t.yCursorPlugin = this._cursorPlugin), this._forkYDocPlugin = new At({
      editor: this.editor,
      collaboration: this.options
    }), t.forkYDocPlugin = this._forkYDocPlugin, this.options.comments) {
      if (!this.options.resolveUsers)
        throw new Error("resolveUsers is required when using comments");
      this._commentsPlugin = new Ot(
        this.editor,
        this.options.comments.threadStore,
        ke.name,
        this.options.resolveUsers,
        this.options.comments.schema
      ), t.comments = this._commentsPlugin, t.commentMark = ke;
    }
    return t;
  }
  /**
   * Update the user info for the current user that's shown to other collaborators
   */
  updateUserInfo(t) {
    const e = this.cursorPlugin;
    if (!e)
      throw new Error(
        "Cannot update collaboration user info when collaboration is disabled."
      );
    e.updateUser(t);
  }
  /**
   * Get the collaboration undo command
   */
  getUndoCommand() {
    return sn;
  }
  /**
   * Get the collaboration redo command
   */
  getRedoCommand() {
    return an;
  }
  /**
   * Check if initial content should be avoided due to collaboration
   */
  shouldAvoidInitialContent() {
    return !!this.options.provider;
  }
  /**
   * Get the collaboration options
   */
  getOptions() {
    return this.options;
  }
  /**
   * Get the comments plugin if available
   */
  get comments() {
    return this._commentsPlugin;
  }
  /**
   * Check if comments are enabled
   */
  get hasComments() {
    return !!this.options.comments;
  }
  /**
   * Get the resolveUsers function
   */
  get resolveUsers() {
    return this.options.resolveUsers;
  }
}
class ms extends Ne {
  constructor(t) {
    super(), this.editor = t, t.onCreate(() => {
      t._tiptapEditor.on(
        "update",
        ({ transaction: e, appendedTransactions: o }) => {
          this.emit("onChange", t, {
            getChanges() {
              return Tt(
                e,
                o
              );
            }
          });
        }
      ), t._tiptapEditor.on("selectionUpdate", ({ transaction: e }) => {
        this.emit("onSelectionChange", { editor: t, transaction: e });
      }), t._tiptapEditor.on("mount", () => {
        this.emit("onMount", { editor: t });
      }), t._tiptapEditor.on("unmount", () => {
        this.emit("onUnmount", { editor: t });
      });
    });
  }
  /**
   * Register a callback that will be called when the editor changes.
   */
  onChange(t) {
    return this.on("onChange", t), () => {
      this.off("onChange", t);
    };
  }
  /**
   * Register a callback that will be called when the selection changes.
   */
  onSelectionChange(t, e = !1) {
    const o = (r) => {
      r.transaction.getMeta("$y-sync") && !e || t(this.editor);
    };
    return this.on("onSelectionChange", o), () => {
      this.off("onSelectionChange", o);
    };
  }
  /**
   * Register a callback that will be called when the editor is mounted.
   */
  onMount(t) {
    return this.on("onMount", t), () => {
      this.off("onMount", t);
    };
  }
  /**
   * Register a callback that will be called when the editor is unmounted.
   */
  onUnmount(t) {
    return this.on("onUnmount", t), () => {
      this.off("onUnmount", t);
    };
  }
}
function fs(n) {
  return Array.prototype.indexOf.call(n.parentElement.childNodes, n);
}
function gs(n) {
  return n.nodeType === 3 && !/\S/.test(n.nodeValue || "");
}
function ks(n) {
  n.querySelectorAll("li > ul, li > ol").forEach((t) => {
    const e = fs(t), o = t.parentElement, r = Array.from(o.childNodes).slice(
      e + 1
    );
    t.remove(), r.forEach((s) => {
      s.remove();
    }), o.insertAdjacentElement("afterend", t), r.reverse().forEach((s) => {
      if (gs(s))
        return;
      const i = document.createElement("li");
      i.append(s), t.insertAdjacentElement("afterend", i);
    }), o.childNodes.length === 0 && o.remove();
  });
}
function bs(n) {
  n.querySelectorAll("li + ul, li + ol").forEach((t) => {
    var s, i;
    const e = t.previousElementSibling, o = document.createElement("div");
    e.insertAdjacentElement("afterend", o), o.append(e);
    const r = document.createElement("div");
    for (r.setAttribute("data-node-type", "blockGroup"), o.append(r); ((s = o.nextElementSibling) == null ? void 0 : s.nodeName) === "UL" || ((i = o.nextElementSibling) == null ? void 0 : i.nodeName) === "OL"; )
      r.append(o.nextElementSibling);
  });
}
let ht = null;
function ws() {
  return ht || (ht = document.implementation.createHTMLDocument("title"));
}
function ys(n) {
  if (typeof n == "string") {
    const t = ws().createElement("div");
    t.innerHTML = n, n = t;
  }
  return ks(n), bs(n), n;
}
function zt(n, t) {
  const e = ys(n), r = ut.fromSchema(t).parse(e, {
    topNode: t.nodes.blockGroup.create()
  }), s = [];
  for (let i = 0; i < r.childCount; i++)
    s.push(E(r.child(i), t));
  return s;
}
function Cs(n, t) {
  const e = t.value ? t.value : "", o = {};
  t.lang && (o["data-language"] = t.lang);
  let r = {
    type: "element",
    tagName: "code",
    properties: o,
    children: [{ type: "text", value: e }]
  };
  return t.meta && (r.data = { meta: t.meta }), n.patch(t, r), r = n.applyData(t, r), r = {
    type: "element",
    tagName: "pre",
    properties: {},
    children: [r]
  }, n.patch(t, r), r;
}
function vs(n, t) {
  var s;
  const e = String((t == null ? void 0 : t.url) || ""), o = t != null && t.title ? String(t.title) : void 0;
  let r = {
    type: "element",
    tagName: "video",
    properties: {
      src: e,
      "data-name": o,
      "data-url": e,
      controls: !0
    },
    children: []
  };
  return (s = n.patch) == null || s.call(n, t, r), r = n.applyData ? n.applyData(t, r) : r, r;
}
function Gt(n) {
  return vt().use(dn).use(Ct).use(hn, {
    handlers: {
      ...Qe,
      image: (e, o) => {
        const r = String((o == null ? void 0 : o.url) || "");
        return yo(r) ? vs(e, o) : Qe.image(e, o);
      },
      code: Cs
    }
  }).use(un).processSync(n).value;
}
function Ss(n, t) {
  const e = Gt(n);
  return zt(e, t);
}
class Es {
  constructor(t) {
    this.editor = t;
  }
  /**
   * Exports blocks into a simplified HTML string. To better conform to HTML standards, children of blocks which aren't list
   * items are un-nested in the output HTML.
   *
   * @param blocks An array of blocks that should be serialized into HTML.
   * @returns The blocks, serialized as an HTML string.
   */
  blocksToHTMLLossy(t = this.editor.document) {
    return Ce(
      this.editor.pmSchema,
      this.editor
    ).exportBlocks(t, {});
  }
  /**
   * Serializes blocks into an HTML string in the format that would normally be rendered by the editor.
   *
   * Use this method if you want to server-side render HTML (for example, a blog post that has been edited in BlockNote)
   * and serve it to users without loading the editor on the client (i.e.: displaying the blog post)
   *
   * @param blocks An array of blocks that should be serialized into HTML.
   * @returns The blocks, serialized as an HTML string.
   */
  blocksToFullHTML(t = this.editor.document) {
    return vn(
      this.editor.pmSchema,
      this.editor
    ).serializeBlocks(t, {});
  }
  /**
   * Parses blocks from an HTML string. Tries to create `Block` objects out of any HTML block-level elements, and
   * `InlineNode` objects from any HTML inline elements, though not all element types are recognized. If BlockNote
   * doesn't recognize an HTML element's tag, it will parse it as a paragraph or plain text.
   * @param html The HTML string to parse blocks from.
   * @returns The blocks parsed from the HTML string.
   */
  tryParseHTMLToBlocks(t) {
    return zt(t, this.editor.pmSchema);
  }
  /**
   * Serializes blocks into a Markdown string. The output is simplified as Markdown does not support all features of
   * BlockNote - children of blocks which aren't list items are un-nested and certain styles are removed.
   * @param blocks An array of blocks that should be serialized into Markdown.
   * @returns The blocks, serialized as a Markdown string.
   */
  blocksToMarkdownLossy(t = this.editor.document) {
    return Wn(t, this.editor.pmSchema, this.editor, {});
  }
  /**
   * Creates a list of blocks from a Markdown string. Tries to create `Block` and `InlineNode` objects based on
   * Markdown syntax, though not all symbols are recognized. If BlockNote doesn't recognize a symbol, it will parse it
   * as text.
   * @param markdown The Markdown string to parse blocks from.
   * @returns The blocks parsed from the Markdown string.
   */
  tryParseMarkdownToBlocks(t) {
    return Ss(t, this.editor.pmSchema);
  }
  /**
   * Paste HTML into the editor. Defaults to converting HTML to BlockNote HTML.
   * @param html The HTML to paste.
   * @param raw Whether to paste the HTML as is, or to convert it to BlockNote HTML.
   */
  pasteHTML(t, e = !1) {
    var r;
    let o = t;
    if (!e) {
      const s = this.tryParseHTMLToBlocks(t);
      o = this.blocksToFullHTML(s);
    }
    o && ((r = this.editor.prosemirrorView) == null || r.pasteHTML(o));
  }
  /**
   * Paste text into the editor. Defaults to interpreting text as markdown.
   * @param text The text to paste.
   */
  pasteText(t) {
    var e;
    return (e = this.editor.prosemirrorView) == null ? void 0 : e.pasteText(t);
  }
  /**
   * Paste markdown into the editor.
   * @param markdown The markdown to paste.
   */
  pasteMarkdown(t) {
    const e = Gt(t);
    return this.pasteHTML(e);
  }
}
class Bs {
  constructor(t) {
    this.editor = t;
  }
  /**
   * Shorthand to get a typed extension from the editor, by
   * just passing in the extension class.
   *
   * @param ext - The extension class to get
   * @param key - optional, the key of the extension in the extensions object (defaults to the extension name)
   * @returns The extension instance
   */
  extension(t, e = t.key()) {
    const o = this.editor.extensions[e];
    if (!o)
      throw new Error(`Extension ${e} not found`);
    return o;
  }
  /**
   * Get all extensions
   */
  getExtensions() {
    return this.editor.extensions;
  }
  /**
   * Get a specific extension by key
   */
  getExtension(t) {
    return this.editor.extensions[t];
  }
  /**
   * Check if an extension exists
   */
  hasExtension(t) {
    return t in this.editor.extensions;
  }
  // Plugin getters - these provide access to the core BlockNote plugins
  /**
   * Get the formatting toolbar plugin
   */
  get formattingToolbar() {
    return this.editor.extensions.formattingToolbar;
  }
  /**
   * Get the link toolbar plugin
   */
  get linkToolbar() {
    return this.editor.extensions.linkToolbar;
  }
  /**
   * Get the side menu plugin
   */
  get sideMenu() {
    return this.editor.extensions.sideMenu;
  }
  /**
   * Get the suggestion menus plugin
   */
  get suggestionMenus() {
    return this.editor.extensions.suggestionMenus;
  }
  /**
   * Get the file panel plugin (if available)
   */
  get filePanel() {
    return this.editor.extensions.filePanel;
  }
  /**
   * Get the table handles plugin (if available)
   */
  get tableHandles() {
    return this.editor.extensions.tableHandles;
  }
  /**
   * Get the show selection plugin
   */
  get showSelectionPlugin() {
    return this.editor.extensions.showSelection;
  }
  /**
   * Check if collaboration is enabled (Yjs or Liveblocks)
   */
  get isCollaborationEnabled() {
    return this.hasExtension("ySyncPlugin") || this.hasExtension("liveblocksExtension");
  }
}
function Ms(n) {
  const t = L(n);
  if (n.selection.empty || "node" in n.selection)
    return;
  const e = n.doc.resolve(
    re(n.doc, n.selection.from).posBeforeNode
  ), o = n.doc.resolve(
    re(n.doc, n.selection.to).posBeforeNode
  ), r = (l, h) => {
    const u = e.posAtIndex(l, h), f = n.doc.resolve(u).nodeAfter;
    if (!f)
      throw new Error(
        `Error getting selection - node not found at position ${u}`
      );
    return E(f, t);
  }, s = [], i = e.sharedDepth(o.pos), c = e.index(i), a = o.index(i);
  if (e.depth > i) {
    s.push(E(e.nodeAfter, t));
    for (let l = e.depth; l > i; l--)
      if (e.node(l).type.isInGroup("childContainer")) {
        const u = e.index(l) + 1, f = e.node(l).childCount;
        for (let m = u; m < f; m++)
          s.push(r(m, l));
      }
  } else
    s.push(r(c, i));
  for (let l = c + 1; l <= a; l++)
    s.push(r(l, i));
  if (s.length === 0)
    throw new Error(
      `Error getting selection - selection doesn't span any blocks (${n.selection})`
    );
  return {
    blocks: s
  };
}
function Ps(n, t, e) {
  const o = typeof t == "string" ? t : t.id, r = typeof e == "string" ? e : e.id, s = L(n), i = kt(s);
  if (o === r)
    throw new Error(
      `Attempting to set selection with the same anchor and head blocks (id ${o})`
    );
  const c = _(o, n.doc);
  if (!c)
    throw new Error(`Block with ID ${o} not found`);
  const a = _(r, n.doc);
  if (!a)
    throw new Error(`Block with ID ${r} not found`);
  const l = Me(c), h = Me(a), u = i.blockSchema[l.blockNoteType], f = i.blockSchema[h.blockNoteType];
  if (!l.isBlockContainer || u.content === "none")
    throw new Error(
      `Attempting to set selection anchor in block without content (id ${o})`
    );
  if (!h.isBlockContainer || f.content === "none")
    throw new Error(
      `Attempting to set selection anchor in block without content (id ${r})`
    );
  let m, g;
  if (u.content === "table") {
    const p = Je.get(l.blockContent.node);
    m = l.blockContent.beforePos + p.positionAt(0, 0, l.blockContent.node) + 1 + 2;
  } else
    m = l.blockContent.beforePos + 1;
  if (f.content === "table") {
    const p = Je.get(h.blockContent.node), k = h.blockContent.beforePos + p.positionAt(
      p.height - 1,
      p.width - 1,
      h.blockContent.node
    ) + 1, b = n.doc.resolve(k).nodeAfter.nodeSize;
    g = k + b - 2;
  } else
    g = h.blockContent.afterPos - 1;
  n.setSelection(I.create(n.doc, m, g));
}
function Ts(n) {
  const t = L(n);
  let e = n.selection.$from, o = n.selection.$to;
  for (; o.parentOffset >= o.parent.nodeSize - 2 && o.depth > 0; )
    o = n.doc.resolve(o.pos + 1);
  for (; o.parentOffset === 0 && o.depth > 0; )
    o = n.doc.resolve(o.pos - 1);
  for (; e.parentOffset === 0 && e.depth > 0; )
    e = n.doc.resolve(e.pos - 1);
  for (; e.parentOffset >= e.parent.nodeSize - 2 && e.depth > 0; )
    e = n.doc.resolve(e.pos + 1);
  const r = ho(
    n.doc.slice(e.pos, o.pos, !0),
    t
  );
  return {
    _meta: {
      startPos: e.pos,
      endPos: o.pos
    },
    ...r
  };
}
function xs(n) {
  const { bnBlock: t } = we(n), e = L(n.doc), o = n.doc.resolve(t.beforePos), r = o.nodeBefore, s = n.doc.resolve(t.afterPos).nodeAfter;
  let i;
  return o.depth > 1 && (i = o.node(), i.type.isInGroup("bnBlock") || (i = o.node(o.depth - 1))), {
    block: E(t.node, e),
    prevBlock: r === null ? void 0 : E(r, e),
    nextBlock: s === null ? void 0 : E(s, e),
    parentBlock: i === void 0 ? void 0 : E(i, e)
  };
}
function jt(n, t, e = "start") {
  const o = typeof t == "string" ? t : t.id, r = L(n.doc), s = kt(r), i = _(o, n.doc);
  if (!i)
    throw new Error(`Block with ID ${o} not found`);
  const c = Me(i), a = s.blockSchema[c.blockNoteType].content;
  if (c.isBlockContainer) {
    const l = c.blockContent;
    if (a === "none") {
      n.setSelection(X.create(n.doc, l.beforePos));
      return;
    }
    if (a === "inline")
      e === "start" ? n.setSelection(
        I.create(n.doc, l.beforePos + 1)
      ) : n.setSelection(
        I.create(n.doc, l.afterPos - 1)
      );
    else if (a === "table")
      e === "start" ? n.setSelection(
        I.create(n.doc, l.beforePos + 4)
      ) : n.setSelection(
        I.create(n.doc, l.afterPos - 4)
      );
    else
      throw new ne(a);
  } else {
    const l = e === "start" ? c.childContainer.node.firstChild : c.childContainer.node.lastChild;
    jt(n, l.attrs.id, e);
  }
}
class Is {
  constructor(t) {
    this.editor = t;
  }
  /**
   * Gets a snapshot of the current selection. This contains all blocks (included nested blocks)
   * that the selection spans across.
   *
   * If the selection starts / ends halfway through a block, the returned data will contain the entire block.
   */
  getSelection() {
    return this.editor.transact((t) => Ms(t));
  }
  /**
   * Gets a snapshot of the current selection. This contains all blocks (included nested blocks)
   * that the selection spans across.
   *
   * If the selection starts / ends halfway through a block, the returned block will be
   * only the part of the block that is included in the selection.
   */
  getSelectionCutBlocks() {
    return this.editor.transact((t) => Ts(t));
  }
  /**
   * Sets the selection to a range of blocks.
   * @param startBlock The identifier of the block that should be the start of the selection.
   * @param endBlock The identifier of the block that should be the end of the selection.
   */
  setSelection(t, e) {
    return this.editor.transact((o) => Ps(o, t, e));
  }
  /**
   * Gets a snapshot of the current text cursor position.
   * @returns A snapshot of the current text cursor position.
   */
  getTextCursorPosition() {
    return this.editor.transact((t) => xs(t));
  }
  /**
   * Sets the text cursor position to the start or end of an existing block. Throws an error if the target block could
   * not be found.
   * @param targetBlock The identifier of an existing block that the text cursor should be moved to.
   * @param placement Whether the text cursor should be placed at the start or end of the block.
   */
  setTextCursorPosition(t, e = "start") {
    return this.editor.transact(
      (o) => jt(o, t, e)
    );
  }
  /**
   * Gets the bounding box of the current selection.
   */
  getSelectionBoundingBox() {
    if (!this.editor.prosemirrorView)
      return;
    const { selection: t } = this.editor.prosemirrorState, { ranges: e } = t, o = Math.min(...e.map((s) => s.$from.pos)), r = Math.max(...e.map((s) => s.$to.pos));
    if (Te(t)) {
      const s = this.editor.prosemirrorView.nodeDOM(o);
      if (s)
        return s.getBoundingClientRect();
    }
    return me(this.editor.prosemirrorView, o, r);
  }
}
class Ls {
  constructor(t, e) {
    /**
     * Stores the currently active transaction, which is the accumulated transaction from all {@link dispatch} calls during a {@link transact} calls
     */
    d(this, "activeTransaction", null);
    // Flag to indicate if we're in a `can` call
    d(this, "isInCan", !1);
    this.editor = t, this.options = e;
  }
  /**
   * For any command that can be executed, you can check if it can be executed by calling `editor.can(command)`.
   * @example
   * ```ts
   * if (editor.can(editor.undo)) {
   *   // show button
   * } else {
   *   // hide button
   * }
   */
  can(t) {
    try {
      return this.isInCan = !0, t();
    } finally {
      this.isInCan = !1;
    }
  }
  /**
   * Execute a prosemirror command. This is mostly for backwards compatibility with older code.
   *
   * @note You should prefer the {@link transact} method when possible, as it will automatically handle the dispatching of the transaction and work across blocknote transactions.
   *
   * @example
   * ```ts
   * editor.exec((state, dispatch, view) => {
   *   dispatch(state.tr.insertText("Hello, world!"));
   * });
   * ```
   */
  exec(t) {
    if (this.activeTransaction)
      throw new Error(
        "`exec` should not be called within a `transact` call, move the `exec` call outside of the `transact` call"
      );
    if (this.isInCan)
      return this.canExec(t);
    const e = this.prosemirrorState, o = this.prosemirrorView;
    return t(e, (s) => this.prosemirrorView.dispatch(s), o);
  }
  /**
   * Check if a command can be executed. A command should return `false` if it is not valid in the current state.
   *
   * @example
   * ```ts
   * if (editor.canExec(command)) {
   *   // show button
   * } else {
   *   // hide button
   * }
   * ```
   */
  canExec(t) {
    if (this.activeTransaction)
      throw new Error(
        "`canExec` should not be called within a `transact` call, move the `canExec` call outside of the `transact` call"
      );
    const e = this.prosemirrorState, o = this.prosemirrorView;
    return t(e, void 0, o);
  }
  /**
   * Execute a function within a "blocknote transaction".
   * All changes to the editor within the transaction will be grouped together, so that
   * we can dispatch them as a single operation (thus creating only a single undo step)
   *
   * @note There is no need to dispatch the transaction, as it will be automatically dispatched when the callback is complete.
   *
   * @example
   * ```ts
   * // All changes to the editor will be grouped together
   * editor.transact((tr) => {
   *   tr.insertText("Hello, world!");
   * // These two operations will be grouped together in a single undo step
   *   editor.transact((tr) => {
   *     tr.insertText("Hello, world!");
   *   });
   * });
   * ```
   */
  transact(t) {
    if (this.activeTransaction)
      return t(this.activeTransaction);
    try {
      this.activeTransaction = this.editor._tiptapEditor.state.tr;
      const e = t(this.activeTransaction), o = this.activeTransaction;
      return this.activeTransaction = null, o && // Only dispatch if the transaction was actually modified in some way
      (o.docChanged || o.selectionSet || o.scrolledIntoView || o.storedMarksSet || !o.isGeneric) && this.prosemirrorView.dispatch(o), e;
    } finally {
      this.activeTransaction = null;
    }
  }
  /**
   * Get the underlying prosemirror state
   * @note Prefer using `editor.transact` to read the current editor state, as that will ensure the state is up to date
   * @see https://prosemirror.net/docs/ref/#state.EditorState
   */
  get prosemirrorState() {
    if (this.activeTransaction)
      throw new Error(
        "`prosemirrorState` should not be called within a `transact` call, move the `prosemirrorState` call outside of the `transact` call or use `editor.transact` to read the current editor state"
      );
    return this.editor._tiptapEditor.state;
  }
  /**
   * Get the underlying prosemirror view
   * @see https://prosemirror.net/docs/ref/#view.EditorView
   */
  get prosemirrorView() {
    return this.editor._tiptapEditor.view;
  }
  isFocused() {
    var t;
    return ((t = this.prosemirrorView) == null ? void 0 : t.hasFocus()) || !1;
  }
  focus() {
    var t;
    (t = this.prosemirrorView) == null || t.focus();
  }
  /**
   * Checks if the editor is currently editable, or if it's locked.
   * @returns True if the editor is editable, false otherwise.
   */
  get isEditable() {
    if (!this.editor._tiptapEditor) {
      if (!this.editor.headless)
        throw new Error("no editor, but also not headless?");
      return !1;
    }
    return this.editor._tiptapEditor.isEditable === void 0 ? !0 : this.editor._tiptapEditor.isEditable;
  }
  /**
   * Makes the editor editable or locks it, depending on the argument passed.
   * @param editable True to make the editor editable, or false to lock it.
   */
  set isEditable(t) {
    if (!this.editor._tiptapEditor) {
      if (!this.editor.headless)
        throw new Error("no editor, but also not headless?");
      return;
    }
    this.editor._tiptapEditor.options.editable !== t && this.editor._tiptapEditor.setEditable(t);
  }
  /**
   * Undo the last action.
   */
  undo() {
    var t;
    return this.exec(((t = this.options) == null ? void 0 : t.undo) ?? pn);
  }
  /**
   * Redo the last action.
   */
  redo() {
    var t;
    return this.exec(((t = this.options) == null ? void 0 : t.redo) ?? mn);
  }
}
function As(n, t, e, o = { updateSelection: !0 }) {
  let { from: r, to: s } = typeof t == "number" ? { from: t, to: t } : { from: t.from, to: t.to }, i = !0, c = !0, a = "";
  if (e.forEach((l) => {
    l.check(), i && l.isText && l.marks.length === 0 ? a += l.text : i = !1, c = c ? l.isBlock : !1;
  }), r === s && c) {
    const { parent: l } = n.doc.resolve(r);
    l.isTextblock && !l.type.spec.code && !l.childCount && (r -= 1, s += 1);
  }
  return i ? n.insertText(a, r, s) : n.replaceWith(r, s, e), o.updateSelection && Po(n, n.steps.length - 1, -1), !0;
}
class Ds {
  constructor(t) {
    this.editor = t;
  }
  /**
   * Insert a piece of content at the current cursor position.
   *
   * @param content can be a string, or array of partial inline content elements
   */
  insertInlineContent(t, { updateSelection: e = !1 } = {}) {
    const o = q(t, this.editor.pmSchema);
    this.editor.transact((r) => {
      As(
        r,
        {
          from: r.selection.from,
          to: r.selection.to
        },
        o,
        {
          updateSelection: e
        }
      );
    });
  }
  /**
   * Gets the active text styles at the text cursor position or at the end of the current selection if it's active.
   */
  getActiveStyles() {
    return this.editor.transact((t) => {
      const e = {}, o = t.selection.$to.marks();
      for (const r of o) {
        const s = this.editor.schema.styleSchema[r.type.name];
        if (!s) {
          // Links are not considered styles in blocknote
          r.type.name !== "link" && // "blocknoteIgnore" tagged marks (such as comments) are also not considered BlockNote "styles"
          !r.type.spec.blocknoteIgnore && console.warn("mark not found in styleschema", r.type.name);
          continue;
        }
        s.propSchema === "boolean" ? e[s.type] = !0 : e[s.type] = r.attrs.stringValue;
      }
      return e;
    });
  }
  /**
   * Adds styles to the currently selected content.
   * @param styles The styles to add.
   */
  addStyles(t) {
    for (const [e, o] of Object.entries(t)) {
      const r = this.editor.schema.styleSchema[e];
      if (!r)
        throw new Error(`style ${e} not found in styleSchema`);
      if (r.propSchema === "boolean")
        this.editor._tiptapEditor.commands.setMark(e);
      else if (r.propSchema === "string")
        this.editor._tiptapEditor.commands.setMark(e, {
          stringValue: o
        });
      else
        throw new ne(r.propSchema);
    }
  }
  /**
   * Removes styles from the currently selected content.
   * @param styles The styles to remove.
   */
  removeStyles(t) {
    for (const e of Object.keys(t))
      this.editor._tiptapEditor.commands.unsetMark(e);
  }
  /**
   * Toggles styles on the currently selected content.
   * @param styles The styles to toggle.
   */
  toggleStyles(t) {
    for (const [e, o] of Object.entries(t)) {
      const r = this.editor.schema.styleSchema[e];
      if (!r)
        throw new Error(`style ${e} not found in styleSchema`);
      if (r.propSchema === "boolean")
        this.editor._tiptapEditor.commands.toggleMark(e);
      else if (r.propSchema === "string")
        this.editor._tiptapEditor.commands.toggleMark(e, {
          stringValue: o
        });
      else
        throw new ne(r.propSchema);
    }
  }
  /**
   * Gets the currently selected text.
   */
  getSelectedText() {
    return this.editor.transact((t) => t.doc.textBetween(t.selection.from, t.selection.to));
  }
  /**
   * Gets the URL of the last link in the current selection, or `undefined` if there are no links in the selection.
   */
  getSelectedLinkUrl() {
    return this.editor._tiptapEditor.getAttributes("link").href;
  }
  /**
   * Creates a new link to replace the selected content.
   * @param url The link URL.
   * @param text The text to display the link with.
   */
  createLink(t, e) {
    if (t === "")
      return;
    const o = this.editor.pmSchema.mark("link", { href: t });
    this.editor.transact((r) => {
      const { from: s, to: i } = r.selection;
      e ? r.insertText(e, s, i).addMark(s, s + e.length, o) : r.setSelection(I.create(r.doc, i)).addMark(
        s,
        i,
        o
      );
    });
  }
}
function Os(n, t) {
  const e = [];
  return n.forEach((o, r, s) => {
    s !== t && e.push(o);
  }), V.from(e);
}
function _s(n, t) {
  const e = [];
  for (let o = 0; o < n.childCount; o++)
    if (n.child(o).type.name === "tableRow")
      if (e.length > 0 && e[e.length - 1].type.name === "table") {
        const r = e[e.length - 1], s = r.copy(r.content.addToEnd(n.child(o)));
        e[e.length - 1] = s;
      } else {
        const r = t.nodes.table.createChecked(
          void 0,
          n.child(o)
        );
        e.push(r);
      }
    else
      e.push(n.child(o));
  return n = V.from(e), n;
}
function Ns(n, t) {
  let e = V.from(n.content);
  if (e = _s(e, t.state.schema), !Hs(e, t))
    return new z(e, n.openStart, n.openEnd);
  for (let o = 0; o < e.childCount; o++)
    if (e.child(o).type.spec.group === "blockContent") {
      const r = [e.child(o)];
      if (o + 1 < e.childCount && e.child(o + 1).type.name === "blockGroup") {
        const i = e.child(o + 1).child(0).child(0);
        (i.type.name === "bulletListItem" || i.type.name === "numberedListItem" || i.type.name === "checkListItem") && (r.push(e.child(o + 1)), e = Os(e, o + 1));
      }
      const s = t.state.schema.nodes.blockContainer.createChecked(
        void 0,
        r
      );
      e = e.replaceChild(o, s);
    }
  return new z(e, n.openStart, n.openEnd);
}
function Hs(n, t) {
  var s, i;
  const e = n.childCount === 1, o = ((s = n.firstChild) == null ? void 0 : s.type.spec.content) === "inline*", r = ((i = n.firstChild) == null ? void 0 : i.type.spec.content) === "tableRow+";
  if (e) {
    if (o)
      return !1;
    if (r) {
      const c = O(t.state);
      if (c.isBlockContainer)
        return !(c.blockContent.node.type.spec.content === "tableRow+");
    }
  }
  return !0;
}
const Us = {
  enableInputRules: !0,
  enablePasteRules: !0,
  enableCoreExtensions: !1
};
class Kt extends Ne {
  constructor(e) {
    var u, f, m, g, p, k, b, w, D, F, J, Q, Z, ee, v, M, $e, Fe, ze;
    super();
    /**
     * The underlying prosemirror schema
     */
    d(this, "pmSchema");
    /**
     * extensions that are added to the editor, can be tiptap extensions or prosemirror plugins
     */
    d(this, "extensions", {});
    d(this, "_tiptapEditor");
    /**
     * Used by React to store a reference to an `ElementRenderer` helper utility to make sure we can render React elements
     * in the correct context (used by `ReactRenderUtil`)
     */
    d(this, "elementRenderer", null);
    /**
     * Cache of all blocks. This makes sure we don't have to "recompute" blocks if underlying Prosemirror Nodes haven't changed.
     * This is especially useful when we want to keep track of the same block across multiple operations,
     * with this cache, blocks stay the same object reference (referential equality with ===).
     */
    d(this, "blockCache", /* @__PURE__ */ new WeakMap());
    /**
     * The dictionary contains translations for the editor.
     */
    d(this, "dictionary");
    /**
     * The schema of the editor. The schema defines which Blocks, InlineContent, and Styles are available in the editor.
     */
    d(this, "schema");
    d(this, "blockImplementations");
    d(this, "inlineContentImplementations");
    d(this, "styleImplementations");
    /**
     * The `uploadFile` method is what the editor uses when files need to be uploaded (for example when selecting an image to upload).
     * This method should set when creating the editor as this is application-specific.
     *
     * `undefined` means the application doesn't support file uploads.
     *
     * @param file The file that should be uploaded.
     * @returns The URL of the uploaded file OR an object containing props that should be set on the file block (such as an id)
     */
    d(this, "uploadFile");
    d(this, "onUploadStartCallbacks", []);
    d(this, "onUploadEndCallbacks", []);
    d(this, "resolveFileUrl");
    d(this, "resolveUsers");
    /**
     * Editor settings
     */
    d(this, "settings");
    // Manager instances
    d(this, "_blockManager");
    d(this, "_collaborationManager");
    d(this, "_eventManager");
    d(this, "_exportManager");
    d(this, "_extensionManager");
    d(this, "_selectionManager");
    d(this, "_stateManager");
    d(this, "_styleManager");
    /**
     * Mount the editor to a DOM element.
     *
     * @warning Not needed to call manually when using React, use BlockNoteView to take care of mounting
     */
    d(this, "mount", (e) => {
      if (
        // If the editor is scheduled for destruction, and
        this.scheduledDestructionTimeout && // If the editor is being remounted to the same element as the one which is scheduled for destruction,
        // then just cancel the destruction timeout
        this.prosemirrorView.dom === e
      ) {
        clearTimeout(this.scheduledDestructionTimeout), this.scheduledDestructionTimeout = void 0;
        return;
      }
      this._tiptapEditor.mount({ mount: e });
    });
    /**
     * Timeout to schedule the {@link unmount}ing of the editor.
     */
    d(this, "scheduledDestructionTimeout");
    /**
     * Unmount the editor from the DOM element it is bound to
     */
    d(this, "unmount", () => {
      this.scheduledDestructionTimeout = setTimeout(() => {
        this._tiptapEditor.unmount(), this.scheduledDestructionTimeout = void 0;
      }, 1);
    });
    this.options = e;
    const o = e;
    if (o.onEditorContentChange)
      throw new Error(
        "onEditorContentChange initialization option is deprecated, use <BlockNoteView onChange={...} />, the useEditorChange(...) hook, or editor.onChange(...)"
      );
    if (o.onTextCursorPositionChange)
      throw new Error(
        "onTextCursorPositionChange initialization option is deprecated, use <BlockNoteView onSelectionChange={...} />, the useEditorSelectionChange(...) hook, or editor.onSelectionChange(...)"
      );
    if (o.onEditorReady)
      throw new Error(
        "onEditorReady is deprecated. Editor is immediately ready for use after creation."
      );
    if (o.editable)
      throw new Error(
        "editable initialization option is deprecated, use <BlockNoteView editable={true/false} />, or alternatively editor.isEditable = true/false"
      );
    this.dictionary = e.dictionary || ln, this.settings = {
      tables: {
        splitCells: ((u = e == null ? void 0 : e.tables) == null ? void 0 : u.splitCells) ?? !1,
        cellBackgroundColor: ((f = e == null ? void 0 : e.tables) == null ? void 0 : f.cellBackgroundColor) ?? !1,
        cellTextColor: ((m = e == null ? void 0 : e.tables) == null ? void 0 : m.cellTextColor) ?? !1,
        headers: ((g = e == null ? void 0 : e.tables) == null ? void 0 : g.headers) ?? !1
      }
    };
    const r = {
      defaultStyles: !0,
      schema: e.schema || Co.create(),
      ...e,
      placeholders: {
        ...this.dictionary.placeholders,
        ...e.placeholders
      }
    };
    if (r.collaboration || r.comments) {
      const y = {
        // Use collaboration options if available, otherwise provide defaults
        fragment: ((p = r.collaboration) == null ? void 0 : p.fragment) || new R.XmlFragment(),
        user: ((k = r.collaboration) == null ? void 0 : k.user) || {
          name: "User",
          color: "#FF0000"
        },
        provider: ((b = r.collaboration) == null ? void 0 : b.provider) || null,
        renderCursor: (w = r.collaboration) == null ? void 0 : w.renderCursor,
        showCursorLabels: (D = r.collaboration) == null ? void 0 : D.showCursorLabels,
        comments: r.comments,
        resolveUsers: r.resolveUsers
      };
      this._collaborationManager = new ps(
        this,
        y
      );
    } else
      this._collaborationManager = void 0;
    if (r.comments && !r.resolveUsers)
      throw new Error("resolveUsers is required when using comments");
    this.schema = r.schema, this.blockImplementations = r.schema.blockSpecs, this.inlineContentImplementations = r.schema.inlineContentSpecs, this.styleImplementations = r.schema.styleSpecs, this.extensions = {
      ...os({
        editor: this,
        domAttributes: r.domAttributes || {},
        blockSpecs: this.schema.blockSpecs,
        styleSpecs: this.schema.styleSpecs,
        inlineContentSpecs: this.schema.inlineContentSpecs,
        collaboration: r.collaboration,
        trailingBlock: r.trailingBlock,
        disableExtensions: r.disableExtensions,
        setIdAttribute: r.setIdAttribute,
        animations: r.animations ?? !0,
        tableHandles: wt(this, "table"),
        dropCursor: this.options.dropCursor ?? Do,
        placeholders: r.placeholders,
        tabBehavior: r.tabBehavior,
        pasteHandler: r.pasteHandler
      }),
      ...(F = this._collaborationManager) == null ? void 0 : F.initExtensions()
    }, (((J = r._tiptapOptions) == null ? void 0 : J.extensions) || []).forEach((y) => {
      this.extensions[y.name] = y;
    });
    for (let y of r.extensions || []) {
      typeof y == "function" && (y = y(this));
      const C = y.key ?? y.constructor.key();
      if (!C)
        throw new Error(
          `Extension ${y.constructor.name} does not have a key method`
        );
      if (this.extensions[C])
        throw new Error(
          `Extension ${y.constructor.name} already exists with key ${C}`
        );
      this.extensions[C] = y;
    }
    if (Object.entries(r._extensions || {}).forEach(([y, C]) => {
      const P = typeof C == "function" ? C(this) : C;
      if (!("plugin" in P)) {
        this.extensions[y] = P;
        return;
      }
      this.extensions[y] = new class extends S {
        static key() {
          return y;
        }
        constructor() {
          super(), this.addProsemirrorPlugin(P.plugin);
        }
        get priority() {
          return P.priority;
        }
      }();
    }), r.uploadFile) {
      const y = r.uploadFile;
      this.uploadFile = async (C, T) => {
        this.onUploadStartCallbacks.forEach(
          (P) => P.apply(this, [T])
        );
        try {
          return await y(C, T);
        } finally {
          this.onUploadEndCallbacks.forEach(
            (P) => P.apply(this, [T])
          );
        }
      };
    }
    this.resolveFileUrl = r.resolveFileUrl;
    const s = "ySyncPlugin" in this.extensions || "liveblocksExtension" in this.extensions;
    s && r.initialContent && console.warn(
      "When using Collaboration, initialContent might cause conflicts, because changes should come from the collaboration provider"
    );
    const i = Object.fromEntries(
      Object.values(this.schema.blockSpecs).map((y) => y.extensions).filter((y) => y !== void 0).flat().map((y) => [y.key ?? y.constructor.key(), y])
    ), c = [
      ...Object.entries({ ...this.extensions, ...i }).map(
        ([y, C]) => {
          if (C instanceof N || C instanceof W || C instanceof ie)
            return C;
          if (C instanceof S)
            return !C.plugins.length && !C.keyboardShortcuts && !C.inputRules && !C.tiptapExtensions ? void 0 : N.create({
              name: y,
              priority: C.priority,
              addProseMirrorPlugins: () => C.plugins,
              addExtensions: () => C.tiptapExtensions || [],
              // TODO maybe collect all input rules from all extensions into one plugin
              // TODO consider using the prosemirror-inputrules package instead
              addInputRules: C.inputRules ? () => C.inputRules.map(
                (T) => new To({
                  find: T.find,
                  handler: ({ range: P, match: ve, state: Ge }) => {
                    const je = T.replace({
                      match: ve,
                      range: P,
                      editor: this
                    });
                    if (je) {
                      const qt = this.getTextCursorPosition();
                      if (this.schema.blockSchema[qt.block.type].content !== "inline")
                        return;
                      const Yt = we(
                        Ge.tr
                      ), Wt = Ge.tr.deleteRange(
                        P.from,
                        P.to
                      );
                      vo(
                        Wt,
                        Yt.bnBlock.beforePos,
                        je
                      );
                      return;
                    }
                    return null;
                  }
                })
              ) : void 0,
              addKeyboardShortcuts: C.keyboardShortcuts ? () => Object.fromEntries(
                Object.entries(C.keyboardShortcuts).map(
                  ([T, P]) => [
                    T,
                    () => P({ editor: this })
                  ]
                )
              ) : void 0
            });
        }
      )
    ].filter((y) => y !== void 0), a = {
      ...Us,
      ...r._tiptapOptions,
      element: null,
      autofocus: r.autofocus ?? !1,
      extensions: c,
      editorProps: {
        ...(Q = r._tiptapOptions) == null ? void 0 : Q.editorProps,
        attributes: {
          // As of TipTap v2.5.0 the tabIndex is removed when the editor is not
          // editable, so you can't focus it. We want to revert this as we have
          // UI behaviour that relies on it.
          tabIndex: "0",
          ...(ee = (Z = r._tiptapOptions) == null ? void 0 : Z.editorProps) == null ? void 0 : ee.attributes,
          ...(v = r.domAttributes) == null ? void 0 : v.editor,
          class: He(
            "bn-editor",
            r.defaultStyles ? "bn-default-styles" : "",
            (($e = (M = r.domAttributes) == null ? void 0 : M.editor) == null ? void 0 : $e.class) || ""
          )
        },
        transformPasted: Ns
      }
    };
    try {
      const y = r.initialContent || (s ? [
        {
          type: "paragraph",
          id: "initialBlockId"
        }
      ] : [
        {
          type: "paragraph",
          id: gt.options.generateID()
        }
      ]);
      if (!Array.isArray(y) || y.length === 0)
        throw new Error(
          "initialContent must be a non-empty array of blocks, received: " + y
        );
      const C = xo(a.extensions), T = y.map(
        (ve) => Oe(ve, C, this.schema.styleSchema).toJSON()
      ), P = Io(
        {
          type: "doc",
          content: [
            {
              type: "blockGroup",
              content: T
            }
          ]
        },
        C,
        a.parseOptions
      );
      this._tiptapEditor = new Lo({
        ...a,
        content: P.toJSON()
      }), this.pmSchema = this._tiptapEditor.schema;
    } catch (y) {
      throw new Error(
        "Error creating document from blocks passed as `initialContent`",
        { cause: y }
      );
    }
    let l;
    const h = this.pmSchema.nodes.doc.createAndFill;
    this.pmSchema.nodes.doc.createAndFill = (...y) => {
      if (l)
        return l;
      const C = h.apply(this.pmSchema.nodes.doc, y), T = JSON.parse(JSON.stringify(C.toJSON()));
      return T.content[0].content[0].attrs.id = "initialBlockId", l = Qt.fromJSON(this.pmSchema, T), l;
    }, this.pmSchema.cached.blockNoteEditor = this, this._blockManager = new us(this), this._eventManager = new ms(this), this._exportManager = new Es(this), this._extensionManager = new Bs(this), this._selectionManager = new Is(this), this._stateManager = new Ls(
      this,
      s ? {
        undo: (Fe = this._collaborationManager) == null ? void 0 : Fe.getUndoCommand(),
        redo: (ze = this._collaborationManager) == null ? void 0 : ze.getRedoCommand()
      } : void 0
    ), this._styleManager = new Ds(this), this.emit("create");
  }
  get formattingToolbar() {
    return this._extensionManager.formattingToolbar;
  }
  get linkToolbar() {
    return this._extensionManager.linkToolbar;
  }
  get sideMenu() {
    return this._extensionManager.sideMenu;
  }
  get suggestionMenus() {
    return this._extensionManager.suggestionMenus;
  }
  get filePanel() {
    return this._extensionManager.filePanel;
  }
  get tableHandles() {
    return this._extensionManager.tableHandles;
  }
  get comments() {
    var e;
    return (e = this._collaborationManager) == null ? void 0 : e.comments;
  }
  get showSelectionPlugin() {
    return this._extensionManager.showSelectionPlugin;
  }
  /**
   * The plugin for forking a document, only defined if in collaboration mode
   */
  get forkYDocPlugin() {
    var e;
    return (e = this._collaborationManager) == null ? void 0 : e.forkYDocPlugin;
  }
  static create(e) {
    return new Kt(e ?? {});
  }
  /**
   * Execute a prosemirror command. This is mostly for backwards compatibility with older code.
   *
   * @note You should prefer the {@link transact} method when possible, as it will automatically handle the dispatching of the transaction and work across blocknote transactions.
   *
   * @example
   * ```ts
   * editor.exec((state, dispatch, view) => {
   *   dispatch(state.tr.insertText("Hello, world!"));
   * });
   * ```
   */
  exec(e) {
    return this._stateManager.exec(e);
  }
  /**
   * Check if a command can be executed. A command should return `false` if it is not valid in the current state.
   *
   * @example
   * ```ts
   * if (editor.canExec(command)) {
   *   // show button
   * } else {
   *   // hide button
   * }
   * ```
   */
  canExec(e) {
    return this._stateManager.canExec(e);
  }
  /**
   * Execute a function within a "blocknote transaction".
   * All changes to the editor within the transaction will be grouped together, so that
   * we can dispatch them as a single operation (thus creating only a single undo step)
   *
   * @note There is no need to dispatch the transaction, as it will be automatically dispatched when the callback is complete.
   *
   * @example
   * ```ts
   * // All changes to the editor will be grouped together
   * editor.transact((tr) => {
   *   tr.insertText("Hello, world!");
   * // These two operations will be grouped together in a single undo step
   *   editor.transact((tr) => {
   *     tr.insertText("Hello, world!");
   *   });
   * });
   * ```
   */
  transact(e) {
    return this._stateManager.transact(e);
  }
  // TO DISCUSS
  /**
   * Shorthand to get a typed extension from the editor, by
   * just passing in the extension class.
   *
   * @param ext - The extension class to get
   * @param key - optional, the key of the extension in the extensions object (defaults to the extension name)
   * @returns The extension instance
   */
  extension(e, o = e.key()) {
    return this._extensionManager.extension(e, o);
  }
  /**
   * Get the underlying prosemirror state
   * @note Prefer using `editor.transact` to read the current editor state, as that will ensure the state is up to date
   * @see https://prosemirror.net/docs/ref/#state.EditorState
   */
  get prosemirrorState() {
    return this._stateManager.prosemirrorState;
  }
  /**
   * Get the underlying prosemirror view
   * @see https://prosemirror.net/docs/ref/#view.EditorView
   */
  get prosemirrorView() {
    return this._stateManager.prosemirrorView;
  }
  get domElement() {
    var e;
    return (e = this.prosemirrorView) == null ? void 0 : e.dom;
  }
  isFocused() {
    var e;
    return ((e = this.prosemirrorView) == null ? void 0 : e.hasFocus()) || !1;
  }
  get headless() {
    return !this._tiptapEditor.isInitialized;
  }
  focus() {
    this.headless || this.prosemirrorView.focus();
  }
  blur() {
    this.headless || this.prosemirrorView.dom.blur();
  }
  onUploadStart(e) {
    return this.onUploadStartCallbacks.push(e), () => {
      const o = this.onUploadStartCallbacks.indexOf(e);
      o > -1 && this.onUploadStartCallbacks.splice(o, 1);
    };
  }
  onUploadEnd(e) {
    return this.onUploadEndCallbacks.push(e), () => {
      const o = this.onUploadEndCallbacks.indexOf(e);
      o > -1 && this.onUploadEndCallbacks.splice(o, 1);
    };
  }
  /**
   * @deprecated, use `editor.document` instead
   */
  get topLevelBlocks() {
    return this.document;
  }
  /**
   * Gets a snapshot of all top-level (non-nested) blocks in the editor.
   * @returns A snapshot of all top-level (non-nested) blocks in the editor.
   */
  get document() {
    return this._blockManager.document;
  }
  /**
   * Gets a snapshot of an existing block from the editor.
   * @param blockIdentifier The identifier of an existing block that should be
   * retrieved.
   * @returns The block that matches the identifier, or `undefined` if no
   * matching block was found.
   */
  getBlock(e) {
    return this._blockManager.getBlock(e);
  }
  /**
   * Gets a snapshot of the previous sibling of an existing block from the
   * editor.
   * @param blockIdentifier The identifier of an existing block for which the
   * previous sibling should be retrieved.
   * @returns The previous sibling of the block that matches the identifier.
   * `undefined` if no matching block was found, or it's the first child/block
   * in the document.
   */
  getPrevBlock(e) {
    return this._blockManager.getPrevBlock(e);
  }
  /**
   * Gets a snapshot of the next sibling of an existing block from the editor.
   * @param blockIdentifier The identifier of an existing block for which the
   * next sibling should be retrieved.
   * @returns The next sibling of the block that matches the identifier.
   * `undefined` if no matching block was found, or it's the last child/block in
   * the document.
   */
  getNextBlock(e) {
    return this._blockManager.getNextBlock(e);
  }
  /**
   * Gets a snapshot of the parent of an existing block from the editor.
   * @param blockIdentifier The identifier of an existing block for which the
   * parent should be retrieved.
   * @returns The parent of the block that matches the identifier. `undefined`
   * if no matching block was found, or the block isn't nested.
   */
  getParentBlock(e) {
    return this._blockManager.getParentBlock(e);
  }
  /**
   * Traverses all blocks in the editor depth-first, and executes a callback for each.
   * @param callback The callback to execute for each block. Returning `false` stops the traversal.
   * @param reverse Whether the blocks should be traversed in reverse order.
   */
  forEachBlock(e, o = !1) {
    this._blockManager.forEachBlock(e, o);
  }
  /**
   * Executes a callback whenever the editor's contents change.
   * @param callback The callback to execute.
   *
   * @deprecated use {@link BlockNoteEditor.onChange} instead
   */
  onEditorContentChange(e) {
    this._tiptapEditor.on("update", e);
  }
  /**
   * Executes a callback whenever the editor's selection changes.
   * @param callback The callback to execute.
   *
   * @deprecated use `onSelectionChange` instead
   */
  onEditorSelectionChange(e) {
    this._tiptapEditor.on("selectionUpdate", e);
  }
  /**
   * Gets a snapshot of the current text cursor position.
   * @returns A snapshot of the current text cursor position.
   */
  getTextCursorPosition() {
    return this._selectionManager.getTextCursorPosition();
  }
  /**
   * Sets the text cursor position to the start or end of an existing block. Throws an error if the target block could
   * not be found.
   * @param targetBlock The identifier of an existing block that the text cursor should be moved to.
   * @param placement Whether the text cursor should be placed at the start or end of the block.
   */
  setTextCursorPosition(e, o = "start") {
    return this._selectionManager.setTextCursorPosition(e, o);
  }
  /**
   * Gets a snapshot of the current selection. This contains all blocks (included nested blocks)
   * that the selection spans across.
   *
   * If the selection starts / ends halfway through a block, the returned data will contain the entire block.
   */
  getSelection() {
    return this._selectionManager.getSelection();
  }
  /**
   * Gets a snapshot of the current selection. This contains all blocks (included nested blocks)
   * that the selection spans across.
   *
   * If the selection starts / ends halfway through a block, the returned block will be
   * only the part of the block that is included in the selection.
   */
  getSelectionCutBlocks() {
    return this._selectionManager.getSelectionCutBlocks();
  }
  /**
   * Sets the selection to a range of blocks.
   * @param startBlock The identifier of the block that should be the start of the selection.
   * @param endBlock The identifier of the block that should be the end of the selection.
   */
  setSelection(e, o) {
    return this._selectionManager.setSelection(e, o);
  }
  /**
   * Checks if the editor is currently editable, or if it's locked.
   * @returns True if the editor is editable, false otherwise.
   */
  get isEditable() {
    return this._stateManager.isEditable;
  }
  /**
   * Makes the editor editable or locks it, depending on the argument passed.
   * @param editable True to make the editor editable, or false to lock it.
   */
  set isEditable(e) {
    this._stateManager.isEditable = e;
  }
  /**
   * Inserts new blocks into the editor. If a block's `id` is undefined, BlockNote generates one automatically. Throws an
   * error if the reference block could not be found.
   * @param blocksToInsert An array of partial blocks that should be inserted.
   * @param referenceBlock An identifier for an existing block, at which the new blocks should be inserted.
   * @param placement Whether the blocks should be inserted just before, just after, or nested inside the
   * `referenceBlock`.
   */
  insertBlocks(e, o, r = "before") {
    return this._blockManager.insertBlocks(
      e,
      o,
      r
    );
  }
  /**
   * Updates an existing block in the editor. Since updatedBlock is a PartialBlock object, some fields might not be
   * defined. These undefined fields are kept as-is from the existing block. Throws an error if the block to update could
   * not be found.
   * @param blockToUpdate The block that should be updated.
   * @param update A partial block which defines how the existing block should be changed.
   */
  updateBlock(e, o) {
    return this._blockManager.updateBlock(e, o);
  }
  /**
   * Removes existing blocks from the editor. Throws an error if any of the blocks could not be found.
   * @param blocksToRemove An array of identifiers for existing blocks that should be removed.
   */
  removeBlocks(e) {
    return this._blockManager.removeBlocks(e);
  }
  /**
   * Replaces existing blocks in the editor with new blocks. If the blocks that should be removed are not adjacent or
   * are at different nesting levels, `blocksToInsert` will be inserted at the position of the first block in
   * `blocksToRemove`. Throws an error if any of the blocks to remove could not be found.
   * @param blocksToRemove An array of blocks that should be replaced.
   * @param blocksToInsert An array of partial blocks to replace the old ones with.
   */
  replaceBlocks(e, o) {
    return this._blockManager.replaceBlocks(e, o);
  }
  /**
   * Undo the last action.
   */
  undo() {
    return this._stateManager.undo();
  }
  /**
   * Redo the last action.
   */
  redo() {
    return this._stateManager.redo();
  }
  /**
   * Insert a piece of content at the current cursor position.
   *
   * @param content can be a string, or array of partial inline content elements
   */
  insertInlineContent(e, { updateSelection: o = !1 } = {}) {
    this._styleManager.insertInlineContent(e, { updateSelection: o });
  }
  /**
   * Gets the active text styles at the text cursor position or at the end of the current selection if it's active.
   */
  getActiveStyles() {
    return this._styleManager.getActiveStyles();
  }
  /**
   * Adds styles to the currently selected content.
   * @param styles The styles to add.
   */
  addStyles(e) {
    this._styleManager.addStyles(e);
  }
  /**
   * Removes styles from the currently selected content.
   * @param styles The styles to remove.
   */
  removeStyles(e) {
    this._styleManager.removeStyles(e);
  }
  /**
   * Toggles styles on the currently selected content.
   * @param styles The styles to toggle.
   */
  toggleStyles(e) {
    this._styleManager.toggleStyles(e);
  }
  /**
   * Gets the currently selected text.
   */
  getSelectedText() {
    return this._styleManager.getSelectedText();
  }
  /**
   * Gets the URL of the last link in the current selection, or `undefined` if there are no links in the selection.
   */
  getSelectedLinkUrl() {
    return this._styleManager.getSelectedLinkUrl();
  }
  /**
   * Creates a new link to replace the selected content.
   * @param url The link URL.
   * @param text The text to display the link with.
   */
  createLink(e, o) {
    this._styleManager.createLink(e, o);
  }
  /**
   * Checks if the block containing the text cursor can be nested.
   */
  canNestBlock() {
    return this._blockManager.canNestBlock();
  }
  /**
   * Nests the block containing the text cursor into the block above it.
   */
  nestBlock() {
    this._blockManager.nestBlock();
  }
  /**
   * Checks if the block containing the text cursor is nested.
   */
  canUnnestBlock() {
    return this._blockManager.canUnnestBlock();
  }
  /**
   * Lifts the block containing the text cursor out of its parent.
   */
  unnestBlock() {
    this._blockManager.unnestBlock();
  }
  /**
   * Moves the selected blocks up. If the previous block has children, moves
   * them to the end of its children. If there is no previous block, but the
   * current blocks share a common parent, moves them out of & before it.
   */
  moveBlocksUp() {
    return this._blockManager.moveBlocksUp();
  }
  /**
   * Moves the selected blocks down. If the next block has children, moves
   * them to the start of its children. If there is no next block, but the
   * current blocks share a common parent, moves them out of & after it.
   */
  moveBlocksDown() {
    return this._blockManager.moveBlocksDown();
  }
  /**
   * Exports blocks into a simplified HTML string. To better conform to HTML standards, children of blocks which aren't list
   * items are un-nested in the output HTML.
   *
   * @param blocks An array of blocks that should be serialized into HTML.
   * @returns The blocks, serialized as an HTML string.
   */
  blocksToHTMLLossy(e = this.document) {
    return this._exportManager.blocksToHTMLLossy(e);
  }
  /**
   * Serializes blocks into an HTML string in the format that would normally be rendered by the editor.
   *
   * Use this method if you want to server-side render HTML (for example, a blog post that has been edited in BlockNote)
   * and serve it to users without loading the editor on the client (i.e.: displaying the blog post)
   *
   * @param blocks An array of blocks that should be serialized into HTML.
   * @returns The blocks, serialized as an HTML string.
   */
  blocksToFullHTML(e = this.document) {
    return this._exportManager.blocksToFullHTML(e);
  }
  /**
   * Parses blocks from an HTML string. Tries to create `Block` objects out of any HTML block-level elements, and
   * `InlineNode` objects from any HTML inline elements, though not all element types are recognized. If BlockNote
   * doesn't recognize an HTML element's tag, it will parse it as a paragraph or plain text.
   * @param html The HTML string to parse blocks from.
   * @returns The blocks parsed from the HTML string.
   */
  tryParseHTMLToBlocks(e) {
    return this._exportManager.tryParseHTMLToBlocks(e);
  }
  /**
   * Serializes blocks into a Markdown string. The output is simplified as Markdown does not support all features of
   * BlockNote - children of blocks which aren't list items are un-nested and certain styles are removed.
   * @param blocks An array of blocks that should be serialized into Markdown.
   * @returns The blocks, serialized as a Markdown string.
   */
  blocksToMarkdownLossy(e = this.document) {
    return this._exportManager.blocksToMarkdownLossy(e);
  }
  /**
   * Creates a list of blocks from a Markdown string. Tries to create `Block` and `InlineNode` objects based on
   * Markdown syntax, though not all symbols are recognized. If BlockNote doesn't recognize a symbol, it will parse it
   * as text.
   * @param markdown The Markdown string to parse blocks from.
   * @returns The blocks parsed from the Markdown string.
   */
  tryParseMarkdownToBlocks(e) {
    return this._exportManager.tryParseMarkdownToBlocks(e);
  }
  /**
   * Updates the user info for the current user that's shown to other collaborators.
   */
  updateCollaborationUserInfo(e) {
    if (!this._collaborationManager)
      throw new Error(
        "Cannot update collaboration user info when collaboration is disabled."
      );
    this._collaborationManager.updateUserInfo(e);
  }
  /**
   * A callback function that runs whenever the editor's contents change.
   *
   * @param callback The callback to execute.
   * @returns A function to remove the callback.
   */
  onChange(e) {
    return this._eventManager.onChange(e);
  }
  /**
   * A callback function that runs whenever the text cursor position or selection changes.
   *
   * @param callback The callback to execute.
   * @returns A function to remove the callback.
   */
  onSelectionChange(e, o) {
    return this._eventManager.onSelectionChange(
      e,
      o
    );
  }
  /**
   * A callback function that runs when the editor has been initialized.
   *
   * This can be useful for plugins to initialize themselves after the editor has been initialized.
   *
   * @param callback The callback to execute.
   * @returns A function to remove the callback.
   */
  onCreate(e) {
    return this.on("create", e), () => {
      this.off("create", e);
    };
  }
  /**
   * A callback function that runs when the editor has been mounted.
   *
   * This can be useful for plugins to initialize themselves after the editor has been mounted.
   *
   * @param callback The callback to execute.
   * @returns A function to remove the callback.
   */
  onMount(e) {
    this._eventManager.onMount(e);
  }
  /**
   * A callback function that runs when the editor has been unmounted.
   *
   * This can be useful for plugins to clean up themselves after the editor has been unmounted.
   *
   * @param callback The callback to execute.
   * @returns A function to remove the callback.
   */
  onUnmount(e) {
    this._eventManager.onUnmount(e);
  }
  /**
   * Gets the bounding box of the current selection.
   * @returns The bounding box of the current selection.
   */
  getSelectionBoundingBox() {
    return this._selectionManager.getSelectionBoundingBox();
  }
  get isEmpty() {
    const e = this.document;
    return e.length === 0 || e.length === 1 && e[0].type === "paragraph" && e[0].content.length === 0;
  }
  openSuggestionMenu(e, o) {
    this.prosemirrorView && (this.focus(), this.transact((r) => {
      o != null && o.deleteTriggerCharacter && r.insertText(e), r.scrollIntoView().setMeta(this.suggestionMenus.plugins[0], {
        triggerCharacter: e,
        deleteTriggerCharacter: (o == null ? void 0 : o.deleteTriggerCharacter) || !1,
        ignoreQueryLength: (o == null ? void 0 : o.ignoreQueryLength) || !1
      });
    }));
  }
  // `forceSelectionVisible` determines whether the editor selection is shows
  // even when the editor is not focused. This is useful for e.g. creating new
  // links, so the user still sees the affected content when an input field is
  // focused.
  // TODO: Reconsider naming?
  getForceSelectionVisible() {
    return this.showSelectionPlugin.getEnabled();
  }
  setForceSelectionVisible(e) {
    this.showSelectionPlugin.setEnabled(e);
  }
  /**
   * Paste HTML into the editor. Defaults to converting HTML to BlockNote HTML.
   * @param html The HTML to paste.
   * @param raw Whether to paste the HTML as is, or to convert it to BlockNote HTML.
   */
  pasteHTML(e, o = !1) {
    this._exportManager.pasteHTML(e, o);
  }
  /**
   * Paste text into the editor. Defaults to interpreting text as markdown.
   * @param text The text to paste.
   */
  pasteText(e) {
    return this._exportManager.pasteText(e);
  }
  /**
   * Paste markdown into the editor.
   * @param markdown The markdown to paste.
   */
  pasteMarkdown(e) {
    return this._exportManager.pasteMarkdown(e);
  }
}
class ki {
  constructor(t, e, o) {
    this.mappings = e, this.options = o;
  }
  async resolveFile(t) {
    var o;
    if (!((o = this.options) != null && o.resolveFileUrl))
      return (await fetch(t)).blob();
    const e = await this.options.resolveFileUrl(t);
    return e instanceof Blob ? e : (await fetch(e)).blob();
  }
  mapStyles(t) {
    return Object.entries(t).map(([o, r]) => this.mappings.styleMapping[o](r, this));
  }
  mapInlineContent(t) {
    return this.mappings.inlineContentMapping[t.type](
      t,
      this
    );
  }
  transformInlineContent(t) {
    return t.map((e) => this.mapInlineContent(e));
  }
  async mapBlock(t, e, o, r) {
    return this.mappings.blockMapping[t.type](
      t,
      this,
      e,
      o,
      r
    );
  }
}
function bi(n) {
  return {
    createBlockMapping: (t) => t,
    createInlineContentMapping: (t) => t,
    createStyleMapping: (t) => t
  };
}
let he;
async function Rs() {
  return he || (he = (async () => {
    const [n, t] = await Promise.all([
      import("emoji-mart"),
      // use a dynamic import to encourage bundle-splitting
      // and a smaller initial client bundle size
      import("@emoji-mart/data")
    ]), e = "default" in n ? n.default : n, o = "default" in t ? t.default : t;
    return await e.init({ data: o }), { emojiMart: e, emojiData: o };
  })(), he);
}
async function wi(n, t) {
  if (!("text" in n.schema.inlineContentSchema) || n.schema.inlineContentSchema.text !== So.text)
    return [];
  const { emojiData: e, emojiMart: o } = await Rs();
  return (t.trim() === "" ? Object.values(e.emojis) : await o.SearchIndex.search(t)).map((s) => ({
    id: s.skins[0].native,
    onItemClick: () => n.insertInlineContent(s.skins[0].native + " ")
  }));
}
function yi(n, ...t) {
  const e = [...n];
  for (const o of t)
    for (const r of o) {
      const s = e.findLastIndex(
        (i) => i.group === r.group
      );
      s === -1 ? e.push(r) : e.splice(s + 1, 0, r);
    }
  return e;
}
export {
  Kt as BlockNoteEditor,
  S as BlockNoteExtension,
  Co as BlockNoteSchema,
  Ui as COLORS_DARK_MODE_DEFAULT,
  Ri as COLORS_DEFAULT,
  Vi as CustomBlockNoteSchema,
  vr as DEFAULT_LINK_PROTOCOL,
  $i as EMPTY_CELL_HEIGHT,
  Fi as EMPTY_CELL_WIDTH,
  Ne as EventEmitter,
  ki as Exporter,
  zi as FILE_AUDIO_ICON_SVG,
  Gi as FILE_IMAGE_ICON_SVG,
  ji as FILE_VIDEO_ICON_SVG,
  ir as FilePanelProsemirrorPlugin,
  sr as FilePanelView,
  lr as FormattingToolbarProsemirrorPlugin,
  ar as FormattingToolbarView,
  zt as HTMLToBlocks,
  yr as LinkToolbarProsemirrorPlugin,
  _r as SideMenuProsemirrorPlugin,
  Dr as SideMenuView,
  Vr as SuggestionMenuProseMirrorPlugin,
  Yr as TableHandlesProsemirrorPlugin,
  qr as TableHandlesView,
  gt as UniqueID,
  ne as UnreachableCaseError,
  Cr as VALID_LINK_PROTOCOLS,
  Ki as addDefaultPropsExternalHTML,
  Se as addInlineContentAttributes,
  uo as addInlineContentKeyboardShortcuts,
  qi as addNodeAndExtensionsToSpec,
  Yi as addStyleAttributes,
  Wi as applyNonSelectableBlockFix,
  Si as assertEmpty,
  Xi as audioParse,
  Ji as audioRender,
  Qi as audioToExternalHTML,
  Zi as blockHasType,
  Oe as blockToNode,
  Wn as blocksToMarkdown,
  ea as camelToDataKebab,
  ta as captureCellAnchor,
  oa as checkPageBreakBlocksInSchema,
  Re as cleanHTMLToMarkdown,
  yi as combineByGroup,
  oo as contentNodeToInlineContent,
  to as contentNodeToTableContent,
  na as createAudioBlockConfig,
  ra as createAudioBlockSpec,
  sa as createBlockConfig,
  ia as createBlockNoteExtension,
  aa as createBlockSpec,
  ca as createBlockSpecFromTiptapNode,
  la as createBulletListItemBlockConfig,
  da as createBulletListItemBlockSpec,
  ha as createCheckListItemBlockSpec,
  ua as createCheckListItemConfig,
  pa as createCodeBlockConfig,
  ma as createCodeBlockSpec,
  fa as createDefaultBlockDOMOutputSpec,
  ga as createDividerBlockConfig,
  ka as createDividerBlockSpec,
  Ce as createExternalHTMLExporter,
  ba as createFileBlockConfig,
  wa as createFileBlockSpec,
  ya as createHeadingBlockConfig,
  Ca as createHeadingBlockSpec,
  va as createImageBlockConfig,
  Sa as createImageBlockSpec,
  fi as createInlineContentSpec,
  mo as createInlineContentSpecFromTipTapNode,
  vn as createInternalHTMLSerializer,
  Ea as createInternalInlineContentSpec,
  Ba as createInternalStyleSpec,
  Ma as createNumberedListItemBlockConfig,
  Pa as createNumberedListItemBlockSpec,
  Ta as createPageBreakBlockConfig,
  xa as createPageBreakBlockSpec,
  Ia as createParagraphBlockConfig,
  La as createParagraphBlockSpec,
  Aa as createQuoteBlockConfig,
  Da as createQuoteBlockSpec,
  Oa as createStyleSpec,
  _a as createStyleSpecFromTipTapMark,
  gi as createSuggestionMenu,
  Na as createTableBlockSpec,
  Ha as createToggleListItemBlockConfig,
  Ua as createToggleListItemBlockSpec,
  Ra as createToggleWrapper,
  Va as createVideoBlockConfig,
  $a as createVideoBlockSpec,
  Fa as defaultBlockSpecs,
  za as defaultBlockToHTML,
  So as defaultInlineContentSchema,
  Ga as defaultInlineContentSpecs,
  Ye as defaultProps,
  ja as defaultStyleSchema,
  Ka as defaultStyleSpecs,
  qa as defaultToggledState,
  lo as docToBlocks,
  wt as editorHasBlockWithType,
  Ya as fileParse,
  Wa as filenameFromURL,
  Xa as filterSuggestionItems,
  Ie as fixColumnList,
  Ja as formatKeyboardShortcut,
  cr as formattingToolbarPluginKey,
  fo as getBackgroundColorAttribute,
  cs as getBlock,
  Ei as getBlockCache,
  Qa as getBlockFromPos,
  Me as getBlockInfo,
  _e as getBlockInfoFromResolvedPos,
  O as getBlockInfoFromSelection,
  we as getBlockInfoFromTransaction,
  Bi as getBlockInfoWithManualOffset,
  os as getBlockNoteExtensions,
  kt as getBlockNoteSchema,
  Mi as getBlockSchema,
  Tt as getBlocksChangedByTransaction,
  Pi as getColspan,
  wi as getDefaultEmojiPickerItems,
  Za as getDefaultSlashMenuItems,
  fn as getInlineContentParseRules,
  Ti as getInlineContentSchema,
  ec as getInlineContentSchemaFromSpecs,
  tc as getLanguageId,
  re as getNearestBlockPos,
  ds as getNextBlock,
  _ as getNodeById,
  oc as getPageBreakSlashMenuItems,
  hs as getParentBlock,
  nc as getParseRules,
  L as getPmSchema,
  ls as getPrevBlock,
  xi as getRowspan,
  rc as getStyleParseRules,
  Ii as getStyleSchema,
  sc as getStyleSchemaFromSpecs,
  ic as getTextAlignmentAttribute,
  bo as getTextColorAttribute,
  ac as imageParse,
  cc as imageRender,
  lc as imageToExternalHTML,
  q as inlineContentToNodes,
  gn as insertBlocks,
  dc as insertOrUpdateBlock,
  hc as isAppleOS,
  xe as isEmptyColumn,
  Li as isLinkInlineContent,
  bt as isNodeBlock,
  Ai as isPartialLinkInlineContent,
  Di as isPartialTableCell,
  uc as isSafari,
  Oi as isStyledTextInlineContent,
  _i as isTableCell,
  We as isTableCellSelection,
  yo as isVideoUrl,
  wr as linkToolbarPluginKey,
  Ni as mapTableCell,
  bi as mappingFactory,
  Ss as markdownToBlocks,
  Gt as markdownToHTML,
  He as mergeCSSClasses,
  pc as mergeParagraphs,
  E as nodeToBlock,
  pe as nodeToCustomInlineContent,
  mc as parseAudioElement,
  fc as parseDefaultProps,
  po as propsToAttributes,
  ho as prosemirrorSliceToSlicedBlocks,
  Ze as removeAndInsertBlocks,
  kn as removeEmptyColumns,
  Lt as selectedFragmentToHTML,
  Or as sideMenuPluginKey,
  gc as stylePropsToAttributes,
  pt as tableContentToNodes,
  oe as tableHandlesPluginKey,
  kc as tablePropSchema,
  Hr as trackPosition,
  wo as updateBlock,
  ko as updateBlockCommand,
  vo as updateBlockTr,
  bc as uploadToTmpFilesDotOrg_DEV_ONLY,
  wc as videoParse,
  yc as withPageBreak,
  Cc as wrapInBlockStructure
};
//# sourceMappingURL=blocknote.js.map
